var _0 = { exports: {} }, Yu = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qo;
function Nh() {
  if (qo) return Yu;
  qo = 1;
  var f = Symbol.for("react.transitional.element"), m = Symbol.for("react.fragment");
  function S(s, U, N) {
    var M = null;
    if (N !== void 0 && (M = "" + N), U.key !== void 0 && (M = "" + U.key), "key" in U) {
      N = {};
      for (var C in U)
        C !== "key" && (N[C] = U[C]);
    } else N = U;
    return U = N.ref, {
      $$typeof: f,
      type: s,
      key: M,
      ref: U !== void 0 ? U : null,
      props: N
    };
  }
  return Yu.Fragment = m, Yu.jsx = S, Yu.jsxs = S, Yu;
}
var Bo;
function Uh() {
  return Bo || (Bo = 1, _0.exports = Nh()), _0.exports;
}
var B = Uh(), T0 = { exports: {} }, w = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xo;
function Rh() {
  if (Xo) return w;
  Xo = 1;
  var f = Symbol.for("react.transitional.element"), m = Symbol.for("react.portal"), S = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), U = Symbol.for("react.profiler"), N = Symbol.for("react.consumer"), M = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), O = Symbol.for("react.suspense"), o = Symbol.for("react.memo"), X = Symbol.for("react.lazy"), D = Symbol.for("react.activity"), Z = Symbol.iterator;
  function ct(d) {
    return d === null || typeof d != "object" ? null : (d = Z && d[Z] || d["@@iterator"], typeof d == "function" ? d : null);
  }
  var st = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, bt = Object.assign, _t = {};
  function lt(d, _, R) {
    this.props = d, this.context = _, this.refs = _t, this.updater = R || st;
  }
  lt.prototype.isReactComponent = {}, lt.prototype.setState = function(d, _) {
    if (typeof d != "object" && typeof d != "function" && d != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, d, _, "setState");
  }, lt.prototype.forceUpdate = function(d) {
    this.updater.enqueueForceUpdate(this, d, "forceUpdate");
  };
  function jt() {
  }
  jt.prototype = lt.prototype;
  function gt(d, _, R) {
    this.props = d, this.context = _, this.refs = _t, this.updater = R || st;
  }
  var Tt = gt.prototype = new jt();
  Tt.constructor = gt, bt(Tt, lt.prototype), Tt.isPureReactComponent = !0;
  var Ot = Array.isArray;
  function mt() {
  }
  var H = { H: null, A: null, T: null, S: null }, ut = Object.prototype.hasOwnProperty;
  function xt(d, _, R) {
    var Y = R.ref;
    return {
      $$typeof: f,
      type: d,
      key: _,
      ref: Y !== void 0 ? Y : null,
      props: R
    };
  }
  function fe(d, _) {
    return xt(d.type, _, d.props);
  }
  function il(d) {
    return typeof d == "object" && d !== null && d.$$typeof === f;
  }
  function Qt(d) {
    var _ = { "=": "=0", ":": "=2" };
    return "$" + d.replace(/[=:]/g, function(R) {
      return _[R];
    });
  }
  var xl = /\/+/g;
  function Ol(d, _) {
    return typeof d == "object" && d !== null && d.key != null ? Qt("" + d.key) : _.toString(36);
  }
  function qt(d) {
    switch (d.status) {
      case "fulfilled":
        return d.value;
      case "rejected":
        throw d.reason;
      default:
        switch (typeof d.status == "string" ? d.then(mt, mt) : (d.status = "pending", d.then(
          function(_) {
            d.status === "pending" && (d.status = "fulfilled", d.value = _);
          },
          function(_) {
            d.status === "pending" && (d.status = "rejected", d.reason = _);
          }
        )), d.status) {
          case "fulfilled":
            return d.value;
          case "rejected":
            throw d.reason;
        }
    }
    throw d;
  }
  function A(d, _, R, Y, V) {
    var K = typeof d;
    (K === "undefined" || K === "boolean") && (d = null);
    var tt = !1;
    if (d === null) tt = !0;
    else
      switch (K) {
        case "bigint":
        case "string":
        case "number":
          tt = !0;
          break;
        case "object":
          switch (d.$$typeof) {
            case f:
            case m:
              tt = !0;
              break;
            case X:
              return tt = d._init, A(
                tt(d._payload),
                _,
                R,
                Y,
                V
              );
          }
      }
    if (tt)
      return V = V(d), tt = Y === "" ? "." + Ol(d, 0) : Y, Ot(V) ? (R = "", tt != null && (R = tt.replace(xl, "$&/") + "/"), A(V, _, R, "", function(Cl) {
        return Cl;
      })) : V != null && (il(V) && (V = fe(
        V,
        R + (V.key == null || d && d.key === V.key ? "" : ("" + V.key).replace(
          xl,
          "$&/"
        ) + "/") + tt
      )), _.push(V)), 1;
    tt = 0;
    var Ht = Y === "" ? "." : Y + ":";
    if (Ot(d))
      for (var Et = 0; Et < d.length; Et++)
        Y = d[Et], K = Ht + Ol(Y, Et), tt += A(
          Y,
          _,
          R,
          K,
          V
        );
    else if (Et = ct(d), typeof Et == "function")
      for (d = Et.call(d), Et = 0; !(Y = d.next()).done; )
        Y = Y.value, K = Ht + Ol(Y, Et++), tt += A(
          Y,
          _,
          R,
          K,
          V
        );
    else if (K === "object") {
      if (typeof d.then == "function")
        return A(
          qt(d),
          _,
          R,
          Y,
          V
        );
      throw _ = String(d), Error(
        "Objects are not valid as a React child (found: " + (_ === "[object Object]" ? "object with keys {" + Object.keys(d).join(", ") + "}" : _) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return tt;
  }
  function G(d, _, R) {
    if (d == null) return d;
    var Y = [], V = 0;
    return A(d, Y, "", "", function(K) {
      return _.call(R, K, V++);
    }), Y;
  }
  function Q(d) {
    if (d._status === -1) {
      var _ = d._result;
      _ = _(), _.then(
        function(R) {
          (d._status === 0 || d._status === -1) && (d._status = 1, d._result = R);
        },
        function(R) {
          (d._status === 0 || d._status === -1) && (d._status = 2, d._result = R);
        }
      ), d._status === -1 && (d._status = 0, d._result = _);
    }
    if (d._status === 1) return d._result.default;
    throw d._result;
  }
  var et = typeof reportError == "function" ? reportError : function(d) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var _ = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof d == "object" && d !== null && typeof d.message == "string" ? String(d.message) : String(d),
        error: d
      });
      if (!window.dispatchEvent(_)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", d);
      return;
    }
    console.error(d);
  }, at = {
    map: G,
    forEach: function(d, _, R) {
      G(
        d,
        function() {
          _.apply(this, arguments);
        },
        R
      );
    },
    count: function(d) {
      var _ = 0;
      return G(d, function() {
        _++;
      }), _;
    },
    toArray: function(d) {
      return G(d, function(_) {
        return _;
      }) || [];
    },
    only: function(d) {
      if (!il(d))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return d;
    }
  };
  return w.Activity = D, w.Children = at, w.Component = lt, w.Fragment = S, w.Profiler = U, w.PureComponent = gt, w.StrictMode = s, w.Suspense = O, w.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = H, w.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(d) {
      return H.H.useMemoCache(d);
    }
  }, w.cache = function(d) {
    return function() {
      return d.apply(null, arguments);
    };
  }, w.cacheSignal = function() {
    return null;
  }, w.cloneElement = function(d, _, R) {
    if (d == null)
      throw Error(
        "The argument must be a React element, but you passed " + d + "."
      );
    var Y = bt({}, d.props), V = d.key;
    if (_ != null)
      for (K in _.key !== void 0 && (V = "" + _.key), _)
        !ut.call(_, K) || K === "key" || K === "__self" || K === "__source" || K === "ref" && _.ref === void 0 || (Y[K] = _[K]);
    var K = arguments.length - 2;
    if (K === 1) Y.children = R;
    else if (1 < K) {
      for (var tt = Array(K), Ht = 0; Ht < K; Ht++)
        tt[Ht] = arguments[Ht + 2];
      Y.children = tt;
    }
    return xt(d.type, V, Y);
  }, w.createContext = function(d) {
    return d = {
      $$typeof: M,
      _currentValue: d,
      _currentValue2: d,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, d.Provider = d, d.Consumer = {
      $$typeof: N,
      _context: d
    }, d;
  }, w.createElement = function(d, _, R) {
    var Y, V = {}, K = null;
    if (_ != null)
      for (Y in _.key !== void 0 && (K = "" + _.key), _)
        ut.call(_, Y) && Y !== "key" && Y !== "__self" && Y !== "__source" && (V[Y] = _[Y]);
    var tt = arguments.length - 2;
    if (tt === 1) V.children = R;
    else if (1 < tt) {
      for (var Ht = Array(tt), Et = 0; Et < tt; Et++)
        Ht[Et] = arguments[Et + 2];
      V.children = Ht;
    }
    if (d && d.defaultProps)
      for (Y in tt = d.defaultProps, tt)
        V[Y] === void 0 && (V[Y] = tt[Y]);
    return xt(d, K, V);
  }, w.createRef = function() {
    return { current: null };
  }, w.forwardRef = function(d) {
    return { $$typeof: C, render: d };
  }, w.isValidElement = il, w.lazy = function(d) {
    return {
      $$typeof: X,
      _payload: { _status: -1, _result: d },
      _init: Q
    };
  }, w.memo = function(d, _) {
    return {
      $$typeof: o,
      type: d,
      compare: _ === void 0 ? null : _
    };
  }, w.startTransition = function(d) {
    var _ = H.T, R = {};
    H.T = R;
    try {
      var Y = d(), V = H.S;
      V !== null && V(R, Y), typeof Y == "object" && Y !== null && typeof Y.then == "function" && Y.then(mt, et);
    } catch (K) {
      et(K);
    } finally {
      _ !== null && R.types !== null && (_.types = R.types), H.T = _;
    }
  }, w.unstable_useCacheRefresh = function() {
    return H.H.useCacheRefresh();
  }, w.use = function(d) {
    return H.H.use(d);
  }, w.useActionState = function(d, _, R) {
    return H.H.useActionState(d, _, R);
  }, w.useCallback = function(d, _) {
    return H.H.useCallback(d, _);
  }, w.useContext = function(d) {
    return H.H.useContext(d);
  }, w.useDebugValue = function() {
  }, w.useDeferredValue = function(d, _) {
    return H.H.useDeferredValue(d, _);
  }, w.useEffect = function(d, _) {
    return H.H.useEffect(d, _);
  }, w.useEffectEvent = function(d) {
    return H.H.useEffectEvent(d);
  }, w.useId = function() {
    return H.H.useId();
  }, w.useImperativeHandle = function(d, _, R) {
    return H.H.useImperativeHandle(d, _, R);
  }, w.useInsertionEffect = function(d, _) {
    return H.H.useInsertionEffect(d, _);
  }, w.useLayoutEffect = function(d, _) {
    return H.H.useLayoutEffect(d, _);
  }, w.useMemo = function(d, _) {
    return H.H.useMemo(d, _);
  }, w.useOptimistic = function(d, _) {
    return H.H.useOptimistic(d, _);
  }, w.useReducer = function(d, _, R) {
    return H.H.useReducer(d, _, R);
  }, w.useRef = function(d) {
    return H.H.useRef(d);
  }, w.useState = function(d) {
    return H.H.useState(d);
  }, w.useSyncExternalStore = function(d, _, R) {
    return H.H.useSyncExternalStore(
      d,
      _,
      R
    );
  }, w.useTransition = function() {
    return H.H.useTransition();
  }, w.version = "19.2.0", w;
}
var xo;
function G0() {
  return xo || (xo = 1, T0.exports = Rh()), T0.exports;
}
var ie = G0(), z0 = { exports: {} }, ju = {}, M0 = { exports: {} }, O0 = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qo;
function Ch() {
  return Qo || (Qo = 1, (function(f) {
    function m(A, G) {
      var Q = A.length;
      A.push(G);
      t: for (; 0 < Q; ) {
        var et = Q - 1 >>> 1, at = A[et];
        if (0 < U(at, G))
          A[et] = G, A[Q] = at, Q = et;
        else break t;
      }
    }
    function S(A) {
      return A.length === 0 ? null : A[0];
    }
    function s(A) {
      if (A.length === 0) return null;
      var G = A[0], Q = A.pop();
      if (Q !== G) {
        A[0] = Q;
        t: for (var et = 0, at = A.length, d = at >>> 1; et < d; ) {
          var _ = 2 * (et + 1) - 1, R = A[_], Y = _ + 1, V = A[Y];
          if (0 > U(R, Q))
            Y < at && 0 > U(V, R) ? (A[et] = V, A[Y] = Q, et = Y) : (A[et] = R, A[_] = Q, et = _);
          else if (Y < at && 0 > U(V, Q))
            A[et] = V, A[Y] = Q, et = Y;
          else break t;
        }
      }
      return G;
    }
    function U(A, G) {
      var Q = A.sortIndex - G.sortIndex;
      return Q !== 0 ? Q : A.id - G.id;
    }
    if (f.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var N = performance;
      f.unstable_now = function() {
        return N.now();
      };
    } else {
      var M = Date, C = M.now();
      f.unstable_now = function() {
        return M.now() - C;
      };
    }
    var O = [], o = [], X = 1, D = null, Z = 3, ct = !1, st = !1, bt = !1, _t = !1, lt = typeof setTimeout == "function" ? setTimeout : null, jt = typeof clearTimeout == "function" ? clearTimeout : null, gt = typeof setImmediate < "u" ? setImmediate : null;
    function Tt(A) {
      for (var G = S(o); G !== null; ) {
        if (G.callback === null) s(o);
        else if (G.startTime <= A)
          s(o), G.sortIndex = G.expirationTime, m(O, G);
        else break;
        G = S(o);
      }
    }
    function Ot(A) {
      if (bt = !1, Tt(A), !st)
        if (S(O) !== null)
          st = !0, mt || (mt = !0, Qt());
        else {
          var G = S(o);
          G !== null && qt(Ot, G.startTime - A);
        }
    }
    var mt = !1, H = -1, ut = 5, xt = -1;
    function fe() {
      return _t ? !0 : !(f.unstable_now() - xt < ut);
    }
    function il() {
      if (_t = !1, mt) {
        var A = f.unstable_now();
        xt = A;
        var G = !0;
        try {
          t: {
            st = !1, bt && (bt = !1, jt(H), H = -1), ct = !0;
            var Q = Z;
            try {
              l: {
                for (Tt(A), D = S(O); D !== null && !(D.expirationTime > A && fe()); ) {
                  var et = D.callback;
                  if (typeof et == "function") {
                    D.callback = null, Z = D.priorityLevel;
                    var at = et(
                      D.expirationTime <= A
                    );
                    if (A = f.unstable_now(), typeof at == "function") {
                      D.callback = at, Tt(A), G = !0;
                      break l;
                    }
                    D === S(O) && s(O), Tt(A);
                  } else s(O);
                  D = S(O);
                }
                if (D !== null) G = !0;
                else {
                  var d = S(o);
                  d !== null && qt(
                    Ot,
                    d.startTime - A
                  ), G = !1;
                }
              }
              break t;
            } finally {
              D = null, Z = Q, ct = !1;
            }
            G = void 0;
          }
        } finally {
          G ? Qt() : mt = !1;
        }
      }
    }
    var Qt;
    if (typeof gt == "function")
      Qt = function() {
        gt(il);
      };
    else if (typeof MessageChannel < "u") {
      var xl = new MessageChannel(), Ol = xl.port2;
      xl.port1.onmessage = il, Qt = function() {
        Ol.postMessage(null);
      };
    } else
      Qt = function() {
        lt(il, 0);
      };
    function qt(A, G) {
      H = lt(function() {
        A(f.unstable_now());
      }, G);
    }
    f.unstable_IdlePriority = 5, f.unstable_ImmediatePriority = 1, f.unstable_LowPriority = 4, f.unstable_NormalPriority = 3, f.unstable_Profiling = null, f.unstable_UserBlockingPriority = 2, f.unstable_cancelCallback = function(A) {
      A.callback = null;
    }, f.unstable_forceFrameRate = function(A) {
      0 > A || 125 < A ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : ut = 0 < A ? Math.floor(1e3 / A) : 5;
    }, f.unstable_getCurrentPriorityLevel = function() {
      return Z;
    }, f.unstable_next = function(A) {
      switch (Z) {
        case 1:
        case 2:
        case 3:
          var G = 3;
          break;
        default:
          G = Z;
      }
      var Q = Z;
      Z = G;
      try {
        return A();
      } finally {
        Z = Q;
      }
    }, f.unstable_requestPaint = function() {
      _t = !0;
    }, f.unstable_runWithPriority = function(A, G) {
      switch (A) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          A = 3;
      }
      var Q = Z;
      Z = A;
      try {
        return G();
      } finally {
        Z = Q;
      }
    }, f.unstable_scheduleCallback = function(A, G, Q) {
      var et = f.unstable_now();
      switch (typeof Q == "object" && Q !== null ? (Q = Q.delay, Q = typeof Q == "number" && 0 < Q ? et + Q : et) : Q = et, A) {
        case 1:
          var at = -1;
          break;
        case 2:
          at = 250;
          break;
        case 5:
          at = 1073741823;
          break;
        case 4:
          at = 1e4;
          break;
        default:
          at = 5e3;
      }
      return at = Q + at, A = {
        id: X++,
        callback: G,
        priorityLevel: A,
        startTime: Q,
        expirationTime: at,
        sortIndex: -1
      }, Q > et ? (A.sortIndex = Q, m(o, A), S(O) === null && A === S(o) && (bt ? (jt(H), H = -1) : bt = !0, qt(Ot, Q - et))) : (A.sortIndex = at, m(O, A), st || ct || (st = !0, mt || (mt = !0, Qt()))), A;
    }, f.unstable_shouldYield = fe, f.unstable_wrapCallback = function(A) {
      var G = Z;
      return function() {
        var Q = Z;
        Z = G;
        try {
          return A.apply(this, arguments);
        } finally {
          Z = Q;
        }
      };
    };
  })(O0)), O0;
}
var Lo;
function Gh() {
  return Lo || (Lo = 1, M0.exports = Ch()), M0.exports;
}
var D0 = { exports: {} }, kt = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zo;
function Hh() {
  if (Zo) return kt;
  Zo = 1;
  var f = G0();
  function m(O) {
    var o = "https://react.dev/errors/" + O;
    if (1 < arguments.length) {
      o += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var X = 2; X < arguments.length; X++)
        o += "&args[]=" + encodeURIComponent(arguments[X]);
    }
    return "Minified React error #" + O + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function S() {
  }
  var s = {
    d: {
      f: S,
      r: function() {
        throw Error(m(522));
      },
      D: S,
      C: S,
      L: S,
      m: S,
      X: S,
      S,
      M: S
    },
    p: 0,
    findDOMNode: null
  }, U = Symbol.for("react.portal");
  function N(O, o, X) {
    var D = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: U,
      key: D == null ? null : "" + D,
      children: O,
      containerInfo: o,
      implementation: X
    };
  }
  var M = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function C(O, o) {
    if (O === "font") return "";
    if (typeof o == "string")
      return o === "use-credentials" ? o : "";
  }
  return kt.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = s, kt.createPortal = function(O, o) {
    var X = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11)
      throw Error(m(299));
    return N(O, o, null, X);
  }, kt.flushSync = function(O) {
    var o = M.T, X = s.p;
    try {
      if (M.T = null, s.p = 2, O) return O();
    } finally {
      M.T = o, s.p = X, s.d.f();
    }
  }, kt.preconnect = function(O, o) {
    typeof O == "string" && (o ? (o = o.crossOrigin, o = typeof o == "string" ? o === "use-credentials" ? o : "" : void 0) : o = null, s.d.C(O, o));
  }, kt.prefetchDNS = function(O) {
    typeof O == "string" && s.d.D(O);
  }, kt.preinit = function(O, o) {
    if (typeof O == "string" && o && typeof o.as == "string") {
      var X = o.as, D = C(X, o.crossOrigin), Z = typeof o.integrity == "string" ? o.integrity : void 0, ct = typeof o.fetchPriority == "string" ? o.fetchPriority : void 0;
      X === "style" ? s.d.S(
        O,
        typeof o.precedence == "string" ? o.precedence : void 0,
        {
          crossOrigin: D,
          integrity: Z,
          fetchPriority: ct
        }
      ) : X === "script" && s.d.X(O, {
        crossOrigin: D,
        integrity: Z,
        fetchPriority: ct,
        nonce: typeof o.nonce == "string" ? o.nonce : void 0
      });
    }
  }, kt.preinitModule = function(O, o) {
    if (typeof O == "string")
      if (typeof o == "object" && o !== null) {
        if (o.as == null || o.as === "script") {
          var X = C(
            o.as,
            o.crossOrigin
          );
          s.d.M(O, {
            crossOrigin: X,
            integrity: typeof o.integrity == "string" ? o.integrity : void 0,
            nonce: typeof o.nonce == "string" ? o.nonce : void 0
          });
        }
      } else o == null && s.d.M(O);
  }, kt.preload = function(O, o) {
    if (typeof O == "string" && typeof o == "object" && o !== null && typeof o.as == "string") {
      var X = o.as, D = C(X, o.crossOrigin);
      s.d.L(O, X, {
        crossOrigin: D,
        integrity: typeof o.integrity == "string" ? o.integrity : void 0,
        nonce: typeof o.nonce == "string" ? o.nonce : void 0,
        type: typeof o.type == "string" ? o.type : void 0,
        fetchPriority: typeof o.fetchPriority == "string" ? o.fetchPriority : void 0,
        referrerPolicy: typeof o.referrerPolicy == "string" ? o.referrerPolicy : void 0,
        imageSrcSet: typeof o.imageSrcSet == "string" ? o.imageSrcSet : void 0,
        imageSizes: typeof o.imageSizes == "string" ? o.imageSizes : void 0,
        media: typeof o.media == "string" ? o.media : void 0
      });
    }
  }, kt.preloadModule = function(O, o) {
    if (typeof O == "string")
      if (o) {
        var X = C(o.as, o.crossOrigin);
        s.d.m(O, {
          as: typeof o.as == "string" && o.as !== "script" ? o.as : void 0,
          crossOrigin: X,
          integrity: typeof o.integrity == "string" ? o.integrity : void 0
        });
      } else s.d.m(O);
  }, kt.requestFormReset = function(O) {
    s.d.r(O);
  }, kt.unstable_batchedUpdates = function(O, o) {
    return O(o);
  }, kt.useFormState = function(O, o, X) {
    return M.H.useFormState(O, o, X);
  }, kt.useFormStatus = function() {
    return M.H.useHostTransitionStatus();
  }, kt.version = "19.2.0", kt;
}
var Vo;
function Yh() {
  if (Vo) return D0.exports;
  Vo = 1;
  function f() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(f);
      } catch (m) {
        console.error(m);
      }
  }
  return f(), D0.exports = Hh(), D0.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wo;
function jh() {
  if (wo) return ju;
  wo = 1;
  var f = Gh(), m = G0(), S = Yh();
  function s(t) {
    var l = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      l += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var e = 2; e < arguments.length; e++)
        l += "&args[]=" + encodeURIComponent(arguments[e]);
    }
    return "Minified React error #" + t + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function U(t) {
    return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11);
  }
  function N(t) {
    var l = t, e = t;
    if (t.alternate) for (; l.return; ) l = l.return;
    else {
      t = l;
      do
        l = t, (l.flags & 4098) !== 0 && (e = l.return), t = l.return;
      while (t);
    }
    return l.tag === 3 ? e : null;
  }
  function M(t) {
    if (t.tag === 13) {
      var l = t.memoizedState;
      if (l === null && (t = t.alternate, t !== null && (l = t.memoizedState)), l !== null) return l.dehydrated;
    }
    return null;
  }
  function C(t) {
    if (t.tag === 31) {
      var l = t.memoizedState;
      if (l === null && (t = t.alternate, t !== null && (l = t.memoizedState)), l !== null) return l.dehydrated;
    }
    return null;
  }
  function O(t) {
    if (N(t) !== t)
      throw Error(s(188));
  }
  function o(t) {
    var l = t.alternate;
    if (!l) {
      if (l = N(t), l === null) throw Error(s(188));
      return l !== t ? null : t;
    }
    for (var e = t, a = l; ; ) {
      var u = e.return;
      if (u === null) break;
      var n = u.alternate;
      if (n === null) {
        if (a = u.return, a !== null) {
          e = a;
          continue;
        }
        break;
      }
      if (u.child === n.child) {
        for (n = u.child; n; ) {
          if (n === e) return O(u), t;
          if (n === a) return O(u), l;
          n = n.sibling;
        }
        throw Error(s(188));
      }
      if (e.return !== a.return) e = u, a = n;
      else {
        for (var i = !1, c = u.child; c; ) {
          if (c === e) {
            i = !0, e = u, a = n;
            break;
          }
          if (c === a) {
            i = !0, a = u, e = n;
            break;
          }
          c = c.sibling;
        }
        if (!i) {
          for (c = n.child; c; ) {
            if (c === e) {
              i = !0, e = n, a = u;
              break;
            }
            if (c === a) {
              i = !0, a = n, e = u;
              break;
            }
            c = c.sibling;
          }
          if (!i) throw Error(s(189));
        }
      }
      if (e.alternate !== a) throw Error(s(190));
    }
    if (e.tag !== 3) throw Error(s(188));
    return e.stateNode.current === e ? t : l;
  }
  function X(t) {
    var l = t.tag;
    if (l === 5 || l === 26 || l === 27 || l === 6) return t;
    for (t = t.child; t !== null; ) {
      if (l = X(t), l !== null) return l;
      t = t.sibling;
    }
    return null;
  }
  var D = Object.assign, Z = Symbol.for("react.element"), ct = Symbol.for("react.transitional.element"), st = Symbol.for("react.portal"), bt = Symbol.for("react.fragment"), _t = Symbol.for("react.strict_mode"), lt = Symbol.for("react.profiler"), jt = Symbol.for("react.consumer"), gt = Symbol.for("react.context"), Tt = Symbol.for("react.forward_ref"), Ot = Symbol.for("react.suspense"), mt = Symbol.for("react.suspense_list"), H = Symbol.for("react.memo"), ut = Symbol.for("react.lazy"), xt = Symbol.for("react.activity"), fe = Symbol.for("react.memo_cache_sentinel"), il = Symbol.iterator;
  function Qt(t) {
    return t === null || typeof t != "object" ? null : (t = il && t[il] || t["@@iterator"], typeof t == "function" ? t : null);
  }
  var xl = Symbol.for("react.client.reference");
  function Ol(t) {
    if (t == null) return null;
    if (typeof t == "function")
      return t.$$typeof === xl ? null : t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case bt:
        return "Fragment";
      case lt:
        return "Profiler";
      case _t:
        return "StrictMode";
      case Ot:
        return "Suspense";
      case mt:
        return "SuspenseList";
      case xt:
        return "Activity";
    }
    if (typeof t == "object")
      switch (t.$$typeof) {
        case st:
          return "Portal";
        case gt:
          return t.displayName || "Context";
        case jt:
          return (t._context.displayName || "Context") + ".Consumer";
        case Tt:
          var l = t.render;
          return t = t.displayName, t || (t = l.displayName || l.name || "", t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"), t;
        case H:
          return l = t.displayName || null, l !== null ? l : Ol(t.type) || "Memo";
        case ut:
          l = t._payload, t = t._init;
          try {
            return Ol(t(l));
          } catch {
          }
      }
    return null;
  }
  var qt = Array.isArray, A = m.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, G = S.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Q = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, et = [], at = -1;
  function d(t) {
    return { current: t };
  }
  function _(t) {
    0 > at || (t.current = et[at], et[at] = null, at--);
  }
  function R(t, l) {
    at++, et[at] = t.current, t.current = l;
  }
  var Y = d(null), V = d(null), K = d(null), tt = d(null);
  function Ht(t, l) {
    switch (R(K, l), R(V, t), R(Y, null), l.nodeType) {
      case 9:
      case 11:
        t = (t = l.documentElement) && (t = t.namespaceURI) ? no(t) : 0;
        break;
      default:
        if (t = l.tagName, l = l.namespaceURI)
          l = no(l), t = io(l, t);
        else
          switch (t) {
            case "svg":
              t = 1;
              break;
            case "math":
              t = 2;
              break;
            default:
              t = 0;
          }
    }
    _(Y), R(Y, t);
  }
  function Et() {
    _(Y), _(V), _(K);
  }
  function Cl(t) {
    t.memoizedState !== null && R(tt, t);
    var l = Y.current, e = io(l, t.type);
    l !== e && (R(V, t), R(Y, e));
  }
  function la(t) {
    V.current === t && (_(Y), _(V)), tt.current === t && (_(tt), Ru._currentValue = Q);
  }
  var Jt, Ql;
  function It(t) {
    if (Jt === void 0)
      try {
        throw Error();
      } catch (e) {
        var l = e.stack.trim().match(/\n( *(at )?)/);
        Jt = l && l[1] || "", Ql = -1 < e.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Jt + t + Ql;
  }
  var La = !1;
  function ci(t, l) {
    if (!t || La) return "";
    La = !0;
    var e = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (l) {
              var z = function() {
                throw Error();
              };
              if (Object.defineProperty(z.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(z, []);
                } catch (b) {
                  var p = b;
                }
                Reflect.construct(t, [], z);
              } else {
                try {
                  z.call();
                } catch (b) {
                  p = b;
                }
                t.call(z.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (b) {
                p = b;
              }
              (z = t()) && typeof z.catch == "function" && z.catch(function() {
              });
            }
          } catch (b) {
            if (b && p && typeof b.stack == "string")
              return [b.stack, p.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var u = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      u && u.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var n = a.DetermineComponentFrameRoot(), i = n[0], c = n[1];
      if (i && c) {
        var r = i.split(`
`), g = c.split(`
`);
        for (u = a = 0; a < r.length && !r[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; u < g.length && !g[u].includes(
          "DetermineComponentFrameRoot"
        ); )
          u++;
        if (a === r.length || u === g.length)
          for (a = r.length - 1, u = g.length - 1; 1 <= a && 0 <= u && r[a] !== g[u]; )
            u--;
        for (; 1 <= a && 0 <= u; a--, u--)
          if (r[a] !== g[u]) {
            if (a !== 1 || u !== 1)
              do
                if (a--, u--, 0 > u || r[a] !== g[u]) {
                  var E = `
` + r[a].replace(" at new ", " at ");
                  return t.displayName && E.includes("<anonymous>") && (E = E.replace("<anonymous>", t.displayName)), E;
                }
              while (1 <= a && 0 <= u);
            break;
          }
      }
    } finally {
      La = !1, Error.prepareStackTrace = e;
    }
    return (e = t ? t.displayName || t.name : "") ? It(e) : "";
  }
  function ir(t, l) {
    switch (t.tag) {
      case 26:
      case 27:
      case 5:
        return It(t.type);
      case 16:
        return It("Lazy");
      case 13:
        return t.child !== l && l !== null ? It("Suspense Fallback") : It("Suspense");
      case 19:
        return It("SuspenseList");
      case 0:
      case 15:
        return ci(t.type, !1);
      case 11:
        return ci(t.type.render, !1);
      case 1:
        return ci(t.type, !0);
      case 31:
        return It("Activity");
      default:
        return "";
    }
  }
  function Y0(t) {
    try {
      var l = "", e = null;
      do
        l += ir(t, e), e = t, t = t.return;
      while (t);
      return l;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  var fi = Object.prototype.hasOwnProperty, si = f.unstable_scheduleCallback, oi = f.unstable_cancelCallback, cr = f.unstable_shouldYield, fr = f.unstable_requestPaint, cl = f.unstable_now, sr = f.unstable_getCurrentPriorityLevel, j0 = f.unstable_ImmediatePriority, q0 = f.unstable_UserBlockingPriority, xu = f.unstable_NormalPriority, or = f.unstable_LowPriority, B0 = f.unstable_IdlePriority, rr = f.log, hr = f.unstable_setDisableYieldValue, Za = null, fl = null;
  function se(t) {
    if (typeof rr == "function" && hr(t), fl && typeof fl.setStrictMode == "function")
      try {
        fl.setStrictMode(Za, t);
      } catch {
      }
  }
  var sl = Math.clz32 ? Math.clz32 : mr, dr = Math.log, yr = Math.LN2;
  function mr(t) {
    return t >>>= 0, t === 0 ? 32 : 31 - (dr(t) / yr | 0) | 0;
  }
  var Qu = 256, Lu = 262144, Zu = 4194304;
  function Ye(t) {
    var l = t & 42;
    if (l !== 0) return l;
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return t & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return t & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return t;
    }
  }
  function Vu(t, l, e) {
    var a = t.pendingLanes;
    if (a === 0) return 0;
    var u = 0, n = t.suspendedLanes, i = t.pingedLanes;
    t = t.warmLanes;
    var c = a & 134217727;
    return c !== 0 ? (a = c & ~n, a !== 0 ? u = Ye(a) : (i &= c, i !== 0 ? u = Ye(i) : e || (e = c & ~t, e !== 0 && (u = Ye(e))))) : (c = a & ~n, c !== 0 ? u = Ye(c) : i !== 0 ? u = Ye(i) : e || (e = a & ~t, e !== 0 && (u = Ye(e)))), u === 0 ? 0 : l !== 0 && l !== u && (l & n) === 0 && (n = u & -u, e = l & -l, n >= e || n === 32 && (e & 4194048) !== 0) ? l : u;
  }
  function Va(t, l) {
    return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & l) === 0;
  }
  function vr(t, l) {
    switch (t) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return l + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function X0() {
    var t = Zu;
    return Zu <<= 1, (Zu & 62914560) === 0 && (Zu = 4194304), t;
  }
  function ri(t) {
    for (var l = [], e = 0; 31 > e; e++) l.push(t);
    return l;
  }
  function wa(t, l) {
    t.pendingLanes |= l, l !== 268435456 && (t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0);
  }
  function gr(t, l, e, a, u, n) {
    var i = t.pendingLanes;
    t.pendingLanes = e, t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0, t.expiredLanes &= e, t.entangledLanes &= e, t.errorRecoveryDisabledLanes &= e, t.shellSuspendCounter = 0;
    var c = t.entanglements, r = t.expirationTimes, g = t.hiddenUpdates;
    for (e = i & ~e; 0 < e; ) {
      var E = 31 - sl(e), z = 1 << E;
      c[E] = 0, r[E] = -1;
      var p = g[E];
      if (p !== null)
        for (g[E] = null, E = 0; E < p.length; E++) {
          var b = p[E];
          b !== null && (b.lane &= -536870913);
        }
      e &= ~z;
    }
    a !== 0 && x0(t, a, 0), n !== 0 && u === 0 && t.tag !== 0 && (t.suspendedLanes |= n & ~(i & ~l));
  }
  function x0(t, l, e) {
    t.pendingLanes |= l, t.suspendedLanes &= ~l;
    var a = 31 - sl(l);
    t.entangledLanes |= l, t.entanglements[a] = t.entanglements[a] | 1073741824 | e & 261930;
  }
  function Q0(t, l) {
    var e = t.entangledLanes |= l;
    for (t = t.entanglements; e; ) {
      var a = 31 - sl(e), u = 1 << a;
      u & l | t[a] & l && (t[a] |= l), e &= ~u;
    }
  }
  function L0(t, l) {
    var e = l & -l;
    return e = (e & 42) !== 0 ? 1 : hi(e), (e & (t.suspendedLanes | l)) !== 0 ? 0 : e;
  }
  function hi(t) {
    switch (t) {
      case 2:
        t = 1;
        break;
      case 8:
        t = 4;
        break;
      case 32:
        t = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        t = 128;
        break;
      case 268435456:
        t = 134217728;
        break;
      default:
        t = 0;
    }
    return t;
  }
  function di(t) {
    return t &= -t, 2 < t ? 8 < t ? (t & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function Z0() {
    var t = G.p;
    return t !== 0 ? t : (t = window.event, t === void 0 ? 32 : Uo(t.type));
  }
  function V0(t, l) {
    var e = G.p;
    try {
      return G.p = t, l();
    } finally {
      G.p = e;
    }
  }
  var oe = Math.random().toString(36).slice(2), Lt = "__reactFiber$" + oe, Pt = "__reactProps$" + oe, ea = "__reactContainer$" + oe, yi = "__reactEvents$" + oe, pr = "__reactListeners$" + oe, Sr = "__reactHandles$" + oe, w0 = "__reactResources$" + oe, Ka = "__reactMarker$" + oe;
  function mi(t) {
    delete t[Lt], delete t[Pt], delete t[yi], delete t[pr], delete t[Sr];
  }
  function aa(t) {
    var l = t[Lt];
    if (l) return l;
    for (var e = t.parentNode; e; ) {
      if (l = e[ea] || e[Lt]) {
        if (e = l.alternate, l.child !== null || e !== null && e.child !== null)
          for (t = yo(t); t !== null; ) {
            if (e = t[Lt]) return e;
            t = yo(t);
          }
        return l;
      }
      t = e, e = t.parentNode;
    }
    return null;
  }
  function ua(t) {
    if (t = t[Lt] || t[ea]) {
      var l = t.tag;
      if (l === 5 || l === 6 || l === 13 || l === 31 || l === 26 || l === 27 || l === 3)
        return t;
    }
    return null;
  }
  function Ja(t) {
    var l = t.tag;
    if (l === 5 || l === 26 || l === 27 || l === 6) return t.stateNode;
    throw Error(s(33));
  }
  function na(t) {
    var l = t[w0];
    return l || (l = t[w0] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), l;
  }
  function Bt(t) {
    t[Ka] = !0;
  }
  var K0 = /* @__PURE__ */ new Set(), J0 = {};
  function je(t, l) {
    ia(t, l), ia(t + "Capture", l);
  }
  function ia(t, l) {
    for (J0[t] = l, t = 0; t < l.length; t++)
      K0.add(l[t]);
  }
  var br = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), k0 = {}, W0 = {};
  function Er(t) {
    return fi.call(W0, t) ? !0 : fi.call(k0, t) ? !1 : br.test(t) ? W0[t] = !0 : (k0[t] = !0, !1);
  }
  function wu(t, l, e) {
    if (Er(l))
      if (e === null) t.removeAttribute(l);
      else {
        switch (typeof e) {
          case "undefined":
          case "function":
          case "symbol":
            t.removeAttribute(l);
            return;
          case "boolean":
            var a = l.toLowerCase().slice(0, 5);
            if (a !== "data-" && a !== "aria-") {
              t.removeAttribute(l);
              return;
            }
        }
        t.setAttribute(l, "" + e);
      }
  }
  function Ku(t, l, e) {
    if (e === null) t.removeAttribute(l);
    else {
      switch (typeof e) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(l);
          return;
      }
      t.setAttribute(l, "" + e);
    }
  }
  function Ll(t, l, e, a) {
    if (a === null) t.removeAttribute(e);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(e);
          return;
      }
      t.setAttributeNS(l, e, "" + a);
    }
  }
  function gl(t) {
    switch (typeof t) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return t;
      case "object":
        return t;
      default:
        return "";
    }
  }
  function $0(t) {
    var l = t.type;
    return (t = t.nodeName) && t.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
  }
  function Ar(t, l, e) {
    var a = Object.getOwnPropertyDescriptor(
      t.constructor.prototype,
      l
    );
    if (!t.hasOwnProperty(l) && typeof a < "u" && typeof a.get == "function" && typeof a.set == "function") {
      var u = a.get, n = a.set;
      return Object.defineProperty(t, l, {
        configurable: !0,
        get: function() {
          return u.call(this);
        },
        set: function(i) {
          e = "" + i, n.call(this, i);
        }
      }), Object.defineProperty(t, l, {
        enumerable: a.enumerable
      }), {
        getValue: function() {
          return e;
        },
        setValue: function(i) {
          e = "" + i;
        },
        stopTracking: function() {
          t._valueTracker = null, delete t[l];
        }
      };
    }
  }
  function vi(t) {
    if (!t._valueTracker) {
      var l = $0(t) ? "checked" : "value";
      t._valueTracker = Ar(
        t,
        l,
        "" + t[l]
      );
    }
  }
  function F0(t) {
    if (!t) return !1;
    var l = t._valueTracker;
    if (!l) return !0;
    var e = l.getValue(), a = "";
    return t && (a = $0(t) ? t.checked ? "true" : "false" : t.value), t = a, t !== e ? (l.setValue(t), !0) : !1;
  }
  function Ju(t) {
    if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u") return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  var _r = /[\n"\\]/g;
  function pl(t) {
    return t.replace(
      _r,
      function(l) {
        return "\\" + l.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function gi(t, l, e, a, u, n, i, c) {
    t.name = "", i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" ? t.type = i : t.removeAttribute("type"), l != null ? i === "number" ? (l === 0 && t.value === "" || t.value != l) && (t.value = "" + gl(l)) : t.value !== "" + gl(l) && (t.value = "" + gl(l)) : i !== "submit" && i !== "reset" || t.removeAttribute("value"), l != null ? pi(t, i, gl(l)) : e != null ? pi(t, i, gl(e)) : a != null && t.removeAttribute("value"), u == null && n != null && (t.defaultChecked = !!n), u != null && (t.checked = u && typeof u != "function" && typeof u != "symbol"), c != null && typeof c != "function" && typeof c != "symbol" && typeof c != "boolean" ? t.name = "" + gl(c) : t.removeAttribute("name");
  }
  function I0(t, l, e, a, u, n, i, c) {
    if (n != null && typeof n != "function" && typeof n != "symbol" && typeof n != "boolean" && (t.type = n), l != null || e != null) {
      if (!(n !== "submit" && n !== "reset" || l != null)) {
        vi(t);
        return;
      }
      e = e != null ? "" + gl(e) : "", l = l != null ? "" + gl(l) : e, c || l === t.value || (t.value = l), t.defaultValue = l;
    }
    a = a ?? u, a = typeof a != "function" && typeof a != "symbol" && !!a, t.checked = c ? t.checked : !!a, t.defaultChecked = !!a, i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" && (t.name = i), vi(t);
  }
  function pi(t, l, e) {
    l === "number" && Ju(t.ownerDocument) === t || t.defaultValue === "" + e || (t.defaultValue = "" + e);
  }
  function ca(t, l, e, a) {
    if (t = t.options, l) {
      l = {};
      for (var u = 0; u < e.length; u++)
        l["$" + e[u]] = !0;
      for (e = 0; e < t.length; e++)
        u = l.hasOwnProperty("$" + t[e].value), t[e].selected !== u && (t[e].selected = u), u && a && (t[e].defaultSelected = !0);
    } else {
      for (e = "" + gl(e), l = null, u = 0; u < t.length; u++) {
        if (t[u].value === e) {
          t[u].selected = !0, a && (t[u].defaultSelected = !0);
          return;
        }
        l !== null || t[u].disabled || (l = t[u]);
      }
      l !== null && (l.selected = !0);
    }
  }
  function P0(t, l, e) {
    if (l != null && (l = "" + gl(l), l !== t.value && (t.value = l), e == null)) {
      t.defaultValue !== l && (t.defaultValue = l);
      return;
    }
    t.defaultValue = e != null ? "" + gl(e) : "";
  }
  function tf(t, l, e, a) {
    if (l == null) {
      if (a != null) {
        if (e != null) throw Error(s(92));
        if (qt(a)) {
          if (1 < a.length) throw Error(s(93));
          a = a[0];
        }
        e = a;
      }
      e == null && (e = ""), l = e;
    }
    e = gl(l), t.defaultValue = e, a = t.textContent, a === e && a !== "" && a !== null && (t.value = a), vi(t);
  }
  function fa(t, l) {
    if (l) {
      var e = t.firstChild;
      if (e && e === t.lastChild && e.nodeType === 3) {
        e.nodeValue = l;
        return;
      }
    }
    t.textContent = l;
  }
  var Tr = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function lf(t, l, e) {
    var a = l.indexOf("--") === 0;
    e == null || typeof e == "boolean" || e === "" ? a ? t.setProperty(l, "") : l === "float" ? t.cssFloat = "" : t[l] = "" : a ? t.setProperty(l, e) : typeof e != "number" || e === 0 || Tr.has(l) ? l === "float" ? t.cssFloat = e : t[l] = ("" + e).trim() : t[l] = e + "px";
  }
  function ef(t, l, e) {
    if (l != null && typeof l != "object")
      throw Error(s(62));
    if (t = t.style, e != null) {
      for (var a in e)
        !e.hasOwnProperty(a) || l != null && l.hasOwnProperty(a) || (a.indexOf("--") === 0 ? t.setProperty(a, "") : a === "float" ? t.cssFloat = "" : t[a] = "");
      for (var u in l)
        a = l[u], l.hasOwnProperty(u) && e[u] !== a && lf(t, u, a);
    } else
      for (var n in l)
        l.hasOwnProperty(n) && lf(t, n, l[n]);
  }
  function Si(t) {
    if (t.indexOf("-") === -1) return !1;
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var zr = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Mr = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function ku(t) {
    return Mr.test("" + t) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : t;
  }
  function Zl() {
  }
  var bi = null;
  function Ei(t) {
    return t = t.target || t.srcElement || window, t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === 3 ? t.parentNode : t;
  }
  var sa = null, oa = null;
  function af(t) {
    var l = ua(t);
    if (l && (t = l.stateNode)) {
      var e = t[Pt] || null;
      t: switch (t = l.stateNode, l.type) {
        case "input":
          if (gi(
            t,
            e.value,
            e.defaultValue,
            e.defaultValue,
            e.checked,
            e.defaultChecked,
            e.type,
            e.name
          ), l = e.name, e.type === "radio" && l != null) {
            for (e = t; e.parentNode; ) e = e.parentNode;
            for (e = e.querySelectorAll(
              'input[name="' + pl(
                "" + l
              ) + '"][type="radio"]'
            ), l = 0; l < e.length; l++) {
              var a = e[l];
              if (a !== t && a.form === t.form) {
                var u = a[Pt] || null;
                if (!u) throw Error(s(90));
                gi(
                  a,
                  u.value,
                  u.defaultValue,
                  u.defaultValue,
                  u.checked,
                  u.defaultChecked,
                  u.type,
                  u.name
                );
              }
            }
            for (l = 0; l < e.length; l++)
              a = e[l], a.form === t.form && F0(a);
          }
          break t;
        case "textarea":
          P0(t, e.value, e.defaultValue);
          break t;
        case "select":
          l = e.value, l != null && ca(t, !!e.multiple, l, !1);
      }
    }
  }
  var Ai = !1;
  function uf(t, l, e) {
    if (Ai) return t(l, e);
    Ai = !0;
    try {
      var a = t(l);
      return a;
    } finally {
      if (Ai = !1, (sa !== null || oa !== null) && (jn(), sa && (l = sa, t = oa, oa = sa = null, af(l), t)))
        for (l = 0; l < t.length; l++) af(t[l]);
    }
  }
  function ka(t, l) {
    var e = t.stateNode;
    if (e === null) return null;
    var a = e[Pt] || null;
    if (a === null) return null;
    e = a[l];
    t: switch (l) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (a = !a.disabled) || (t = t.type, a = !(t === "button" || t === "input" || t === "select" || t === "textarea")), t = !a;
        break t;
      default:
        t = !1;
    }
    if (t) return null;
    if (e && typeof e != "function")
      throw Error(
        s(231, l, typeof e)
      );
    return e;
  }
  var Vl = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), _i = !1;
  if (Vl)
    try {
      var Wa = {};
      Object.defineProperty(Wa, "passive", {
        get: function() {
          _i = !0;
        }
      }), window.addEventListener("test", Wa, Wa), window.removeEventListener("test", Wa, Wa);
    } catch {
      _i = !1;
    }
  var re = null, Ti = null, Wu = null;
  function nf() {
    if (Wu) return Wu;
    var t, l = Ti, e = l.length, a, u = "value" in re ? re.value : re.textContent, n = u.length;
    for (t = 0; t < e && l[t] === u[t]; t++) ;
    var i = e - t;
    for (a = 1; a <= i && l[e - a] === u[n - a]; a++) ;
    return Wu = u.slice(t, 1 < a ? 1 - a : void 0);
  }
  function $u(t) {
    var l = t.keyCode;
    return "charCode" in t ? (t = t.charCode, t === 0 && l === 13 && (t = 13)) : t = l, t === 10 && (t = 13), 32 <= t || t === 13 ? t : 0;
  }
  function Fu() {
    return !0;
  }
  function cf() {
    return !1;
  }
  function tl(t) {
    function l(e, a, u, n, i) {
      this._reactName = e, this._targetInst = u, this.type = a, this.nativeEvent = n, this.target = i, this.currentTarget = null;
      for (var c in t)
        t.hasOwnProperty(c) && (e = t[c], this[c] = e ? e(n) : n[c]);
      return this.isDefaultPrevented = (n.defaultPrevented != null ? n.defaultPrevented : n.returnValue === !1) ? Fu : cf, this.isPropagationStopped = cf, this;
    }
    return D(l.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var e = this.nativeEvent;
        e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = Fu);
      },
      stopPropagation: function() {
        var e = this.nativeEvent;
        e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = Fu);
      },
      persist: function() {
      },
      isPersistent: Fu
    }), l;
  }
  var qe = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(t) {
      return t.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Iu = tl(qe), $a = D({}, qe, { view: 0, detail: 0 }), Or = tl($a), zi, Mi, Fa, Pu = D({}, $a, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Di,
    button: 0,
    buttons: 0,
    relatedTarget: function(t) {
      return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
    },
    movementX: function(t) {
      return "movementX" in t ? t.movementX : (t !== Fa && (Fa && t.type === "mousemove" ? (zi = t.screenX - Fa.screenX, Mi = t.screenY - Fa.screenY) : Mi = zi = 0, Fa = t), zi);
    },
    movementY: function(t) {
      return "movementY" in t ? t.movementY : Mi;
    }
  }), ff = tl(Pu), Dr = D({}, Pu, { dataTransfer: 0 }), Nr = tl(Dr), Ur = D({}, $a, { relatedTarget: 0 }), Oi = tl(Ur), Rr = D({}, qe, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Cr = tl(Rr), Gr = D({}, qe, {
    clipboardData: function(t) {
      return "clipboardData" in t ? t.clipboardData : window.clipboardData;
    }
  }), Hr = tl(Gr), Yr = D({}, qe, { data: 0 }), sf = tl(Yr), jr = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, qr = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Br = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Xr(t) {
    var l = this.nativeEvent;
    return l.getModifierState ? l.getModifierState(t) : (t = Br[t]) ? !!l[t] : !1;
  }
  function Di() {
    return Xr;
  }
  var xr = D({}, $a, {
    key: function(t) {
      if (t.key) {
        var l = jr[t.key] || t.key;
        if (l !== "Unidentified") return l;
      }
      return t.type === "keypress" ? (t = $u(t), t === 13 ? "Enter" : String.fromCharCode(t)) : t.type === "keydown" || t.type === "keyup" ? qr[t.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Di,
    charCode: function(t) {
      return t.type === "keypress" ? $u(t) : 0;
    },
    keyCode: function(t) {
      return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    },
    which: function(t) {
      return t.type === "keypress" ? $u(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    }
  }), Qr = tl(xr), Lr = D({}, Pu, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), of = tl(Lr), Zr = D({}, $a, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Di
  }), Vr = tl(Zr), wr = D({}, qe, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Kr = tl(wr), Jr = D({}, Pu, {
    deltaX: function(t) {
      return "deltaX" in t ? t.deltaX : "wheelDeltaX" in t ? -t.wheelDeltaX : 0;
    },
    deltaY: function(t) {
      return "deltaY" in t ? t.deltaY : "wheelDeltaY" in t ? -t.wheelDeltaY : "wheelDelta" in t ? -t.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), kr = tl(Jr), Wr = D({}, qe, {
    newState: 0,
    oldState: 0
  }), $r = tl(Wr), Fr = [9, 13, 27, 32], Ni = Vl && "CompositionEvent" in window, Ia = null;
  Vl && "documentMode" in document && (Ia = document.documentMode);
  var Ir = Vl && "TextEvent" in window && !Ia, rf = Vl && (!Ni || Ia && 8 < Ia && 11 >= Ia), hf = " ", df = !1;
  function yf(t, l) {
    switch (t) {
      case "keyup":
        return Fr.indexOf(l.keyCode) !== -1;
      case "keydown":
        return l.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function mf(t) {
    return t = t.detail, typeof t == "object" && "data" in t ? t.data : null;
  }
  var ra = !1;
  function Pr(t, l) {
    switch (t) {
      case "compositionend":
        return mf(l);
      case "keypress":
        return l.which !== 32 ? null : (df = !0, hf);
      case "textInput":
        return t = l.data, t === hf && df ? null : t;
      default:
        return null;
    }
  }
  function t2(t, l) {
    if (ra)
      return t === "compositionend" || !Ni && yf(t, l) ? (t = nf(), Wu = Ti = re = null, ra = !1, t) : null;
    switch (t) {
      case "paste":
        return null;
      case "keypress":
        if (!(l.ctrlKey || l.altKey || l.metaKey) || l.ctrlKey && l.altKey) {
          if (l.char && 1 < l.char.length)
            return l.char;
          if (l.which) return String.fromCharCode(l.which);
        }
        return null;
      case "compositionend":
        return rf && l.locale !== "ko" ? null : l.data;
      default:
        return null;
    }
  }
  var l2 = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function vf(t) {
    var l = t && t.nodeName && t.nodeName.toLowerCase();
    return l === "input" ? !!l2[t.type] : l === "textarea";
  }
  function gf(t, l, e, a) {
    sa ? oa ? oa.push(a) : oa = [a] : sa = a, l = Zn(l, "onChange"), 0 < l.length && (e = new Iu(
      "onChange",
      "change",
      null,
      e,
      a
    ), t.push({ event: e, listeners: l }));
  }
  var Pa = null, tu = null;
  function e2(t) {
    P1(t, 0);
  }
  function tn(t) {
    var l = Ja(t);
    if (F0(l)) return t;
  }
  function pf(t, l) {
    if (t === "change") return l;
  }
  var Sf = !1;
  if (Vl) {
    var Ui;
    if (Vl) {
      var Ri = "oninput" in document;
      if (!Ri) {
        var bf = document.createElement("div");
        bf.setAttribute("oninput", "return;"), Ri = typeof bf.oninput == "function";
      }
      Ui = Ri;
    } else Ui = !1;
    Sf = Ui && (!document.documentMode || 9 < document.documentMode);
  }
  function Ef() {
    Pa && (Pa.detachEvent("onpropertychange", Af), tu = Pa = null);
  }
  function Af(t) {
    if (t.propertyName === "value" && tn(tu)) {
      var l = [];
      gf(
        l,
        tu,
        t,
        Ei(t)
      ), uf(e2, l);
    }
  }
  function a2(t, l, e) {
    t === "focusin" ? (Ef(), Pa = l, tu = e, Pa.attachEvent("onpropertychange", Af)) : t === "focusout" && Ef();
  }
  function u2(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown")
      return tn(tu);
  }
  function n2(t, l) {
    if (t === "click") return tn(l);
  }
  function i2(t, l) {
    if (t === "input" || t === "change")
      return tn(l);
  }
  function c2(t, l) {
    return t === l && (t !== 0 || 1 / t === 1 / l) || t !== t && l !== l;
  }
  var ol = typeof Object.is == "function" ? Object.is : c2;
  function lu(t, l) {
    if (ol(t, l)) return !0;
    if (typeof t != "object" || t === null || typeof l != "object" || l === null)
      return !1;
    var e = Object.keys(t), a = Object.keys(l);
    if (e.length !== a.length) return !1;
    for (a = 0; a < e.length; a++) {
      var u = e[a];
      if (!fi.call(l, u) || !ol(t[u], l[u]))
        return !1;
    }
    return !0;
  }
  function _f(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function Tf(t, l) {
    var e = _f(t);
    t = 0;
    for (var a; e; ) {
      if (e.nodeType === 3) {
        if (a = t + e.textContent.length, t <= l && a >= l)
          return { node: e, offset: l - t };
        t = a;
      }
      t: {
        for (; e; ) {
          if (e.nextSibling) {
            e = e.nextSibling;
            break t;
          }
          e = e.parentNode;
        }
        e = void 0;
      }
      e = _f(e);
    }
  }
  function zf(t, l) {
    return t && l ? t === l ? !0 : t && t.nodeType === 3 ? !1 : l && l.nodeType === 3 ? zf(t, l.parentNode) : "contains" in t ? t.contains(l) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(l) & 16) : !1 : !1;
  }
  function Mf(t) {
    t = t != null && t.ownerDocument != null && t.ownerDocument.defaultView != null ? t.ownerDocument.defaultView : window;
    for (var l = Ju(t.document); l instanceof t.HTMLIFrameElement; ) {
      try {
        var e = typeof l.contentWindow.location.href == "string";
      } catch {
        e = !1;
      }
      if (e) t = l.contentWindow;
      else break;
      l = Ju(t.document);
    }
    return l;
  }
  function Ci(t) {
    var l = t && t.nodeName && t.nodeName.toLowerCase();
    return l && (l === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || l === "textarea" || t.contentEditable === "true");
  }
  var f2 = Vl && "documentMode" in document && 11 >= document.documentMode, ha = null, Gi = null, eu = null, Hi = !1;
  function Of(t, l, e) {
    var a = e.window === e ? e.document : e.nodeType === 9 ? e : e.ownerDocument;
    Hi || ha == null || ha !== Ju(a) || (a = ha, "selectionStart" in a && Ci(a) ? a = { start: a.selectionStart, end: a.selectionEnd } : (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection(), a = {
      anchorNode: a.anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }), eu && lu(eu, a) || (eu = a, a = Zn(Gi, "onSelect"), 0 < a.length && (l = new Iu(
      "onSelect",
      "select",
      null,
      l,
      e
    ), t.push({ event: l, listeners: a }), l.target = ha)));
  }
  function Be(t, l) {
    var e = {};
    return e[t.toLowerCase()] = l.toLowerCase(), e["Webkit" + t] = "webkit" + l, e["Moz" + t] = "moz" + l, e;
  }
  var da = {
    animationend: Be("Animation", "AnimationEnd"),
    animationiteration: Be("Animation", "AnimationIteration"),
    animationstart: Be("Animation", "AnimationStart"),
    transitionrun: Be("Transition", "TransitionRun"),
    transitionstart: Be("Transition", "TransitionStart"),
    transitioncancel: Be("Transition", "TransitionCancel"),
    transitionend: Be("Transition", "TransitionEnd")
  }, Yi = {}, Df = {};
  Vl && (Df = document.createElement("div").style, "AnimationEvent" in window || (delete da.animationend.animation, delete da.animationiteration.animation, delete da.animationstart.animation), "TransitionEvent" in window || delete da.transitionend.transition);
  function Xe(t) {
    if (Yi[t]) return Yi[t];
    if (!da[t]) return t;
    var l = da[t], e;
    for (e in l)
      if (l.hasOwnProperty(e) && e in Df)
        return Yi[t] = l[e];
    return t;
  }
  var Nf = Xe("animationend"), Uf = Xe("animationiteration"), Rf = Xe("animationstart"), s2 = Xe("transitionrun"), o2 = Xe("transitionstart"), r2 = Xe("transitioncancel"), Cf = Xe("transitionend"), Gf = /* @__PURE__ */ new Map(), ji = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  ji.push("scrollEnd");
  function Dl(t, l) {
    Gf.set(t, l), je(l, [t]);
  }
  var ln = typeof reportError == "function" ? reportError : function(t) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var l = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof t == "object" && t !== null && typeof t.message == "string" ? String(t.message) : String(t),
        error: t
      });
      if (!window.dispatchEvent(l)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", t);
      return;
    }
    console.error(t);
  }, Sl = [], ya = 0, qi = 0;
  function en() {
    for (var t = ya, l = qi = ya = 0; l < t; ) {
      var e = Sl[l];
      Sl[l++] = null;
      var a = Sl[l];
      Sl[l++] = null;
      var u = Sl[l];
      Sl[l++] = null;
      var n = Sl[l];
      if (Sl[l++] = null, a !== null && u !== null) {
        var i = a.pending;
        i === null ? u.next = u : (u.next = i.next, i.next = u), a.pending = u;
      }
      n !== 0 && Hf(e, u, n);
    }
  }
  function an(t, l, e, a) {
    Sl[ya++] = t, Sl[ya++] = l, Sl[ya++] = e, Sl[ya++] = a, qi |= a, t.lanes |= a, t = t.alternate, t !== null && (t.lanes |= a);
  }
  function Bi(t, l, e, a) {
    return an(t, l, e, a), un(t);
  }
  function xe(t, l) {
    return an(t, null, null, l), un(t);
  }
  function Hf(t, l, e) {
    t.lanes |= e;
    var a = t.alternate;
    a !== null && (a.lanes |= e);
    for (var u = !1, n = t.return; n !== null; )
      n.childLanes |= e, a = n.alternate, a !== null && (a.childLanes |= e), n.tag === 22 && (t = n.stateNode, t === null || t._visibility & 1 || (u = !0)), t = n, n = n.return;
    return t.tag === 3 ? (n = t.stateNode, u && l !== null && (u = 31 - sl(e), t = n.hiddenUpdates, a = t[u], a === null ? t[u] = [l] : a.push(l), l.lane = e | 536870912), n) : null;
  }
  function un(t) {
    if (50 < Tu)
      throw Tu = 0, Jc = null, Error(s(185));
    for (var l = t.return; l !== null; )
      t = l, l = t.return;
    return t.tag === 3 ? t.stateNode : null;
  }
  var ma = {};
  function h2(t, l, e, a) {
    this.tag = t, this.key = e, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = l, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = a, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function rl(t, l, e, a) {
    return new h2(t, l, e, a);
  }
  function Xi(t) {
    return t = t.prototype, !(!t || !t.isReactComponent);
  }
  function wl(t, l) {
    var e = t.alternate;
    return e === null ? (e = rl(
      t.tag,
      l,
      t.key,
      t.mode
    ), e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.alternate = t, t.alternate = e) : (e.pendingProps = l, e.type = t.type, e.flags = 0, e.subtreeFlags = 0, e.deletions = null), e.flags = t.flags & 65011712, e.childLanes = t.childLanes, e.lanes = t.lanes, e.child = t.child, e.memoizedProps = t.memoizedProps, e.memoizedState = t.memoizedState, e.updateQueue = t.updateQueue, l = t.dependencies, e.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.refCleanup = t.refCleanup, e;
  }
  function Yf(t, l) {
    t.flags &= 65011714;
    var e = t.alternate;
    return e === null ? (t.childLanes = 0, t.lanes = l, t.child = null, t.subtreeFlags = 0, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null) : (t.childLanes = e.childLanes, t.lanes = e.lanes, t.child = e.child, t.subtreeFlags = 0, t.deletions = null, t.memoizedProps = e.memoizedProps, t.memoizedState = e.memoizedState, t.updateQueue = e.updateQueue, t.type = e.type, l = e.dependencies, t.dependencies = l === null ? null : {
      lanes: l.lanes,
      firstContext: l.firstContext
    }), t;
  }
  function nn(t, l, e, a, u, n) {
    var i = 0;
    if (a = t, typeof t == "function") Xi(t) && (i = 1);
    else if (typeof t == "string")
      i = gh(
        t,
        e,
        Y.current
      ) ? 26 : t === "html" || t === "head" || t === "body" ? 27 : 5;
    else
      t: switch (t) {
        case xt:
          return t = rl(31, e, l, u), t.elementType = xt, t.lanes = n, t;
        case bt:
          return Qe(e.children, u, n, l);
        case _t:
          i = 8, u |= 24;
          break;
        case lt:
          return t = rl(12, e, l, u | 2), t.elementType = lt, t.lanes = n, t;
        case Ot:
          return t = rl(13, e, l, u), t.elementType = Ot, t.lanes = n, t;
        case mt:
          return t = rl(19, e, l, u), t.elementType = mt, t.lanes = n, t;
        default:
          if (typeof t == "object" && t !== null)
            switch (t.$$typeof) {
              case gt:
                i = 10;
                break t;
              case jt:
                i = 9;
                break t;
              case Tt:
                i = 11;
                break t;
              case H:
                i = 14;
                break t;
              case ut:
                i = 16, a = null;
                break t;
            }
          i = 29, e = Error(
            s(130, t === null ? "null" : typeof t, "")
          ), a = null;
      }
    return l = rl(i, e, l, u), l.elementType = t, l.type = a, l.lanes = n, l;
  }
  function Qe(t, l, e, a) {
    return t = rl(7, t, a, l), t.lanes = e, t;
  }
  function xi(t, l, e) {
    return t = rl(6, t, null, l), t.lanes = e, t;
  }
  function jf(t) {
    var l = rl(18, null, null, 0);
    return l.stateNode = t, l;
  }
  function Qi(t, l, e) {
    return l = rl(
      4,
      t.children !== null ? t.children : [],
      t.key,
      l
    ), l.lanes = e, l.stateNode = {
      containerInfo: t.containerInfo,
      pendingChildren: null,
      implementation: t.implementation
    }, l;
  }
  var qf = /* @__PURE__ */ new WeakMap();
  function bl(t, l) {
    if (typeof t == "object" && t !== null) {
      var e = qf.get(t);
      return e !== void 0 ? e : (l = {
        value: t,
        source: l,
        stack: Y0(l)
      }, qf.set(t, l), l);
    }
    return {
      value: t,
      source: l,
      stack: Y0(l)
    };
  }
  var va = [], ga = 0, cn = null, au = 0, El = [], Al = 0, he = null, Gl = 1, Hl = "";
  function Kl(t, l) {
    va[ga++] = au, va[ga++] = cn, cn = t, au = l;
  }
  function Bf(t, l, e) {
    El[Al++] = Gl, El[Al++] = Hl, El[Al++] = he, he = t;
    var a = Gl;
    t = Hl;
    var u = 32 - sl(a) - 1;
    a &= ~(1 << u), e += 1;
    var n = 32 - sl(l) + u;
    if (30 < n) {
      var i = u - u % 5;
      n = (a & (1 << i) - 1).toString(32), a >>= i, u -= i, Gl = 1 << 32 - sl(l) + u | e << u | a, Hl = n + t;
    } else
      Gl = 1 << n | e << u | a, Hl = t;
  }
  function Li(t) {
    t.return !== null && (Kl(t, 1), Bf(t, 1, 0));
  }
  function Zi(t) {
    for (; t === cn; )
      cn = va[--ga], va[ga] = null, au = va[--ga], va[ga] = null;
    for (; t === he; )
      he = El[--Al], El[Al] = null, Hl = El[--Al], El[Al] = null, Gl = El[--Al], El[Al] = null;
  }
  function Xf(t, l) {
    El[Al++] = Gl, El[Al++] = Hl, El[Al++] = he, Gl = l.id, Hl = l.overflow, he = t;
  }
  var Zt = null, pt = null, P = !1, de = null, _l = !1, Vi = Error(s(519));
  function ye(t) {
    var l = Error(
      s(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw uu(bl(l, t)), Vi;
  }
  function xf(t) {
    var l = t.stateNode, e = t.type, a = t.memoizedProps;
    switch (l[Lt] = t, l[Pt] = a, e) {
      case "dialog":
        $("cancel", l), $("close", l);
        break;
      case "iframe":
      case "object":
      case "embed":
        $("load", l);
        break;
      case "video":
      case "audio":
        for (e = 0; e < Mu.length; e++)
          $(Mu[e], l);
        break;
      case "source":
        $("error", l);
        break;
      case "img":
      case "image":
      case "link":
        $("error", l), $("load", l);
        break;
      case "details":
        $("toggle", l);
        break;
      case "input":
        $("invalid", l), I0(
          l,
          a.value,
          a.defaultValue,
          a.checked,
          a.defaultChecked,
          a.type,
          a.name,
          !0
        );
        break;
      case "select":
        $("invalid", l);
        break;
      case "textarea":
        $("invalid", l), tf(l, a.value, a.defaultValue, a.children);
    }
    e = a.children, typeof e != "string" && typeof e != "number" && typeof e != "bigint" || l.textContent === "" + e || a.suppressHydrationWarning === !0 || ao(l.textContent, e) ? (a.popover != null && ($("beforetoggle", l), $("toggle", l)), a.onScroll != null && $("scroll", l), a.onScrollEnd != null && $("scrollend", l), a.onClick != null && (l.onclick = Zl), l = !0) : l = !1, l || ye(t, !0);
  }
  function Qf(t) {
    for (Zt = t.return; Zt; )
      switch (Zt.tag) {
        case 5:
        case 31:
        case 13:
          _l = !1;
          return;
        case 27:
        case 3:
          _l = !0;
          return;
        default:
          Zt = Zt.return;
      }
  }
  function pa(t) {
    if (t !== Zt) return !1;
    if (!P) return Qf(t), P = !0, !1;
    var l = t.tag, e;
    if ((e = l !== 3 && l !== 27) && ((e = l === 5) && (e = t.type, e = !(e !== "form" && e !== "button") || f0(t.type, t.memoizedProps)), e = !e), e && pt && ye(t), Qf(t), l === 13) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(s(317));
      pt = ho(t);
    } else if (l === 31) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(s(317));
      pt = ho(t);
    } else
      l === 27 ? (l = pt, De(t.type) ? (t = d0, d0 = null, pt = t) : pt = l) : pt = Zt ? zl(t.stateNode.nextSibling) : null;
    return !0;
  }
  function Le() {
    pt = Zt = null, P = !1;
  }
  function wi() {
    var t = de;
    return t !== null && (ul === null ? ul = t : ul.push.apply(
      ul,
      t
    ), de = null), t;
  }
  function uu(t) {
    de === null ? de = [t] : de.push(t);
  }
  var Ki = d(null), Ze = null, Jl = null;
  function me(t, l, e) {
    R(Ki, l._currentValue), l._currentValue = e;
  }
  function kl(t) {
    t._currentValue = Ki.current, _(Ki);
  }
  function Ji(t, l, e) {
    for (; t !== null; ) {
      var a = t.alternate;
      if ((t.childLanes & l) !== l ? (t.childLanes |= l, a !== null && (a.childLanes |= l)) : a !== null && (a.childLanes & l) !== l && (a.childLanes |= l), t === e) break;
      t = t.return;
    }
  }
  function ki(t, l, e, a) {
    var u = t.child;
    for (u !== null && (u.return = t); u !== null; ) {
      var n = u.dependencies;
      if (n !== null) {
        var i = u.child;
        n = n.firstContext;
        t: for (; n !== null; ) {
          var c = n;
          n = u;
          for (var r = 0; r < l.length; r++)
            if (c.context === l[r]) {
              n.lanes |= e, c = n.alternate, c !== null && (c.lanes |= e), Ji(
                n.return,
                e,
                t
              ), a || (i = null);
              break t;
            }
          n = c.next;
        }
      } else if (u.tag === 18) {
        if (i = u.return, i === null) throw Error(s(341));
        i.lanes |= e, n = i.alternate, n !== null && (n.lanes |= e), Ji(i, e, t), i = null;
      } else i = u.child;
      if (i !== null) i.return = u;
      else
        for (i = u; i !== null; ) {
          if (i === t) {
            i = null;
            break;
          }
          if (u = i.sibling, u !== null) {
            u.return = i.return, i = u;
            break;
          }
          i = i.return;
        }
      u = i;
    }
  }
  function Sa(t, l, e, a) {
    t = null;
    for (var u = l, n = !1; u !== null; ) {
      if (!n) {
        if ((u.flags & 524288) !== 0) n = !0;
        else if ((u.flags & 262144) !== 0) break;
      }
      if (u.tag === 10) {
        var i = u.alternate;
        if (i === null) throw Error(s(387));
        if (i = i.memoizedProps, i !== null) {
          var c = u.type;
          ol(u.pendingProps.value, i.value) || (t !== null ? t.push(c) : t = [c]);
        }
      } else if (u === tt.current) {
        if (i = u.alternate, i === null) throw Error(s(387));
        i.memoizedState.memoizedState !== u.memoizedState.memoizedState && (t !== null ? t.push(Ru) : t = [Ru]);
      }
      u = u.return;
    }
    t !== null && ki(
      l,
      t,
      e,
      a
    ), l.flags |= 262144;
  }
  function fn(t) {
    for (t = t.firstContext; t !== null; ) {
      if (!ol(
        t.context._currentValue,
        t.memoizedValue
      ))
        return !0;
      t = t.next;
    }
    return !1;
  }
  function Ve(t) {
    Ze = t, Jl = null, t = t.dependencies, t !== null && (t.firstContext = null);
  }
  function Vt(t) {
    return Lf(Ze, t);
  }
  function sn(t, l) {
    return Ze === null && Ve(t), Lf(t, l);
  }
  function Lf(t, l) {
    var e = l._currentValue;
    if (l = { context: l, memoizedValue: e, next: null }, Jl === null) {
      if (t === null) throw Error(s(308));
      Jl = l, t.dependencies = { lanes: 0, firstContext: l }, t.flags |= 524288;
    } else Jl = Jl.next = l;
    return e;
  }
  var d2 = typeof AbortController < "u" ? AbortController : function() {
    var t = [], l = this.signal = {
      aborted: !1,
      addEventListener: function(e, a) {
        t.push(a);
      }
    };
    this.abort = function() {
      l.aborted = !0, t.forEach(function(e) {
        return e();
      });
    };
  }, y2 = f.unstable_scheduleCallback, m2 = f.unstable_NormalPriority, Ut = {
    $$typeof: gt,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Wi() {
    return {
      controller: new d2(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function nu(t) {
    t.refCount--, t.refCount === 0 && y2(m2, function() {
      t.controller.abort();
    });
  }
  var iu = null, $i = 0, ba = 0, Ea = null;
  function v2(t, l) {
    if (iu === null) {
      var e = iu = [];
      $i = 0, ba = Pc(), Ea = {
        status: "pending",
        value: void 0,
        then: function(a) {
          e.push(a);
        }
      };
    }
    return $i++, l.then(Zf, Zf), l;
  }
  function Zf() {
    if (--$i === 0 && iu !== null) {
      Ea !== null && (Ea.status = "fulfilled");
      var t = iu;
      iu = null, ba = 0, Ea = null;
      for (var l = 0; l < t.length; l++) (0, t[l])();
    }
  }
  function g2(t, l) {
    var e = [], a = {
      status: "pending",
      value: null,
      reason: null,
      then: function(u) {
        e.push(u);
      }
    };
    return t.then(
      function() {
        a.status = "fulfilled", a.value = l;
        for (var u = 0; u < e.length; u++) (0, e[u])(l);
      },
      function(u) {
        for (a.status = "rejected", a.reason = u, u = 0; u < e.length; u++)
          (0, e[u])(void 0);
      }
    ), a;
  }
  var Vf = A.S;
  A.S = function(t, l) {
    O1 = cl(), typeof l == "object" && l !== null && typeof l.then == "function" && v2(t, l), Vf !== null && Vf(t, l);
  };
  var we = d(null);
  function Fi() {
    var t = we.current;
    return t !== null ? t : vt.pooledCache;
  }
  function on(t, l) {
    l === null ? R(we, we.current) : R(we, l.pool);
  }
  function wf() {
    var t = Fi();
    return t === null ? null : { parent: Ut._currentValue, pool: t };
  }
  var Aa = Error(s(460)), Ii = Error(s(474)), rn = Error(s(542)), hn = { then: function() {
  } };
  function Kf(t) {
    return t = t.status, t === "fulfilled" || t === "rejected";
  }
  function Jf(t, l, e) {
    switch (e = t[e], e === void 0 ? t.push(l) : e !== l && (l.then(Zl, Zl), l = e), l.status) {
      case "fulfilled":
        return l.value;
      case "rejected":
        throw t = l.reason, Wf(t), t;
      default:
        if (typeof l.status == "string") l.then(Zl, Zl);
        else {
          if (t = vt, t !== null && 100 < t.shellSuspendCounter)
            throw Error(s(482));
          t = l, t.status = "pending", t.then(
            function(a) {
              if (l.status === "pending") {
                var u = l;
                u.status = "fulfilled", u.value = a;
              }
            },
            function(a) {
              if (l.status === "pending") {
                var u = l;
                u.status = "rejected", u.reason = a;
              }
            }
          );
        }
        switch (l.status) {
          case "fulfilled":
            return l.value;
          case "rejected":
            throw t = l.reason, Wf(t), t;
        }
        throw Je = l, Aa;
    }
  }
  function Ke(t) {
    try {
      var l = t._init;
      return l(t._payload);
    } catch (e) {
      throw e !== null && typeof e == "object" && typeof e.then == "function" ? (Je = e, Aa) : e;
    }
  }
  var Je = null;
  function kf() {
    if (Je === null) throw Error(s(459));
    var t = Je;
    return Je = null, t;
  }
  function Wf(t) {
    if (t === Aa || t === rn)
      throw Error(s(483));
  }
  var _a = null, cu = 0;
  function dn(t) {
    var l = cu;
    return cu += 1, _a === null && (_a = []), Jf(_a, t, l);
  }
  function fu(t, l) {
    l = l.props.ref, t.ref = l !== void 0 ? l : null;
  }
  function yn(t, l) {
    throw l.$$typeof === Z ? Error(s(525)) : (t = Object.prototype.toString.call(l), Error(
      s(
        31,
        t === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : t
      )
    ));
  }
  function $f(t) {
    function l(y, h) {
      if (t) {
        var v = y.deletions;
        v === null ? (y.deletions = [h], y.flags |= 16) : v.push(h);
      }
    }
    function e(y, h) {
      if (!t) return null;
      for (; h !== null; )
        l(y, h), h = h.sibling;
      return null;
    }
    function a(y) {
      for (var h = /* @__PURE__ */ new Map(); y !== null; )
        y.key !== null ? h.set(y.key, y) : h.set(y.index, y), y = y.sibling;
      return h;
    }
    function u(y, h) {
      return y = wl(y, h), y.index = 0, y.sibling = null, y;
    }
    function n(y, h, v) {
      return y.index = v, t ? (v = y.alternate, v !== null ? (v = v.index, v < h ? (y.flags |= 67108866, h) : v) : (y.flags |= 67108866, h)) : (y.flags |= 1048576, h);
    }
    function i(y) {
      return t && y.alternate === null && (y.flags |= 67108866), y;
    }
    function c(y, h, v, T) {
      return h === null || h.tag !== 6 ? (h = xi(v, y.mode, T), h.return = y, h) : (h = u(h, v), h.return = y, h);
    }
    function r(y, h, v, T) {
      var x = v.type;
      return x === bt ? E(
        y,
        h,
        v.props.children,
        T,
        v.key
      ) : h !== null && (h.elementType === x || typeof x == "object" && x !== null && x.$$typeof === ut && Ke(x) === h.type) ? (h = u(h, v.props), fu(h, v), h.return = y, h) : (h = nn(
        v.type,
        v.key,
        v.props,
        null,
        y.mode,
        T
      ), fu(h, v), h.return = y, h);
    }
    function g(y, h, v, T) {
      return h === null || h.tag !== 4 || h.stateNode.containerInfo !== v.containerInfo || h.stateNode.implementation !== v.implementation ? (h = Qi(v, y.mode, T), h.return = y, h) : (h = u(h, v.children || []), h.return = y, h);
    }
    function E(y, h, v, T, x) {
      return h === null || h.tag !== 7 ? (h = Qe(
        v,
        y.mode,
        T,
        x
      ), h.return = y, h) : (h = u(h, v), h.return = y, h);
    }
    function z(y, h, v) {
      if (typeof h == "string" && h !== "" || typeof h == "number" || typeof h == "bigint")
        return h = xi(
          "" + h,
          y.mode,
          v
        ), h.return = y, h;
      if (typeof h == "object" && h !== null) {
        switch (h.$$typeof) {
          case ct:
            return v = nn(
              h.type,
              h.key,
              h.props,
              null,
              y.mode,
              v
            ), fu(v, h), v.return = y, v;
          case st:
            return h = Qi(
              h,
              y.mode,
              v
            ), h.return = y, h;
          case ut:
            return h = Ke(h), z(y, h, v);
        }
        if (qt(h) || Qt(h))
          return h = Qe(
            h,
            y.mode,
            v,
            null
          ), h.return = y, h;
        if (typeof h.then == "function")
          return z(y, dn(h), v);
        if (h.$$typeof === gt)
          return z(
            y,
            sn(y, h),
            v
          );
        yn(y, h);
      }
      return null;
    }
    function p(y, h, v, T) {
      var x = h !== null ? h.key : null;
      if (typeof v == "string" && v !== "" || typeof v == "number" || typeof v == "bigint")
        return x !== null ? null : c(y, h, "" + v, T);
      if (typeof v == "object" && v !== null) {
        switch (v.$$typeof) {
          case ct:
            return v.key === x ? r(y, h, v, T) : null;
          case st:
            return v.key === x ? g(y, h, v, T) : null;
          case ut:
            return v = Ke(v), p(y, h, v, T);
        }
        if (qt(v) || Qt(v))
          return x !== null ? null : E(y, h, v, T, null);
        if (typeof v.then == "function")
          return p(
            y,
            h,
            dn(v),
            T
          );
        if (v.$$typeof === gt)
          return p(
            y,
            h,
            sn(y, v),
            T
          );
        yn(y, v);
      }
      return null;
    }
    function b(y, h, v, T, x) {
      if (typeof T == "string" && T !== "" || typeof T == "number" || typeof T == "bigint")
        return y = y.get(v) || null, c(h, y, "" + T, x);
      if (typeof T == "object" && T !== null) {
        switch (T.$$typeof) {
          case ct:
            return y = y.get(
              T.key === null ? v : T.key
            ) || null, r(h, y, T, x);
          case st:
            return y = y.get(
              T.key === null ? v : T.key
            ) || null, g(h, y, T, x);
          case ut:
            return T = Ke(T), b(
              y,
              h,
              v,
              T,
              x
            );
        }
        if (qt(T) || Qt(T))
          return y = y.get(v) || null, E(h, y, T, x, null);
        if (typeof T.then == "function")
          return b(
            y,
            h,
            v,
            dn(T),
            x
          );
        if (T.$$typeof === gt)
          return b(
            y,
            h,
            v,
            sn(h, T),
            x
          );
        yn(h, T);
      }
      return null;
    }
    function j(y, h, v, T) {
      for (var x = null, nt = null, q = h, k = h = 0, I = null; q !== null && k < v.length; k++) {
        q.index > k ? (I = q, q = null) : I = q.sibling;
        var it = p(
          y,
          q,
          v[k],
          T
        );
        if (it === null) {
          q === null && (q = I);
          break;
        }
        t && q && it.alternate === null && l(y, q), h = n(it, h, k), nt === null ? x = it : nt.sibling = it, nt = it, q = I;
      }
      if (k === v.length)
        return e(y, q), P && Kl(y, k), x;
      if (q === null) {
        for (; k < v.length; k++)
          q = z(y, v[k], T), q !== null && (h = n(
            q,
            h,
            k
          ), nt === null ? x = q : nt.sibling = q, nt = q);
        return P && Kl(y, k), x;
      }
      for (q = a(q); k < v.length; k++)
        I = b(
          q,
          y,
          k,
          v[k],
          T
        ), I !== null && (t && I.alternate !== null && q.delete(
          I.key === null ? k : I.key
        ), h = n(
          I,
          h,
          k
        ), nt === null ? x = I : nt.sibling = I, nt = I);
      return t && q.forEach(function(Ge) {
        return l(y, Ge);
      }), P && Kl(y, k), x;
    }
    function L(y, h, v, T) {
      if (v == null) throw Error(s(151));
      for (var x = null, nt = null, q = h, k = h = 0, I = null, it = v.next(); q !== null && !it.done; k++, it = v.next()) {
        q.index > k ? (I = q, q = null) : I = q.sibling;
        var Ge = p(y, q, it.value, T);
        if (Ge === null) {
          q === null && (q = I);
          break;
        }
        t && q && Ge.alternate === null && l(y, q), h = n(Ge, h, k), nt === null ? x = Ge : nt.sibling = Ge, nt = Ge, q = I;
      }
      if (it.done)
        return e(y, q), P && Kl(y, k), x;
      if (q === null) {
        for (; !it.done; k++, it = v.next())
          it = z(y, it.value, T), it !== null && (h = n(it, h, k), nt === null ? x = it : nt.sibling = it, nt = it);
        return P && Kl(y, k), x;
      }
      for (q = a(q); !it.done; k++, it = v.next())
        it = b(q, y, k, it.value, T), it !== null && (t && it.alternate !== null && q.delete(it.key === null ? k : it.key), h = n(it, h, k), nt === null ? x = it : nt.sibling = it, nt = it);
      return t && q.forEach(function(Dh) {
        return l(y, Dh);
      }), P && Kl(y, k), x;
    }
    function yt(y, h, v, T) {
      if (typeof v == "object" && v !== null && v.type === bt && v.key === null && (v = v.props.children), typeof v == "object" && v !== null) {
        switch (v.$$typeof) {
          case ct:
            t: {
              for (var x = v.key; h !== null; ) {
                if (h.key === x) {
                  if (x = v.type, x === bt) {
                    if (h.tag === 7) {
                      e(
                        y,
                        h.sibling
                      ), T = u(
                        h,
                        v.props.children
                      ), T.return = y, y = T;
                      break t;
                    }
                  } else if (h.elementType === x || typeof x == "object" && x !== null && x.$$typeof === ut && Ke(x) === h.type) {
                    e(
                      y,
                      h.sibling
                    ), T = u(h, v.props), fu(T, v), T.return = y, y = T;
                    break t;
                  }
                  e(y, h);
                  break;
                } else l(y, h);
                h = h.sibling;
              }
              v.type === bt ? (T = Qe(
                v.props.children,
                y.mode,
                T,
                v.key
              ), T.return = y, y = T) : (T = nn(
                v.type,
                v.key,
                v.props,
                null,
                y.mode,
                T
              ), fu(T, v), T.return = y, y = T);
            }
            return i(y);
          case st:
            t: {
              for (x = v.key; h !== null; ) {
                if (h.key === x)
                  if (h.tag === 4 && h.stateNode.containerInfo === v.containerInfo && h.stateNode.implementation === v.implementation) {
                    e(
                      y,
                      h.sibling
                    ), T = u(h, v.children || []), T.return = y, y = T;
                    break t;
                  } else {
                    e(y, h);
                    break;
                  }
                else l(y, h);
                h = h.sibling;
              }
              T = Qi(v, y.mode, T), T.return = y, y = T;
            }
            return i(y);
          case ut:
            return v = Ke(v), yt(
              y,
              h,
              v,
              T
            );
        }
        if (qt(v))
          return j(
            y,
            h,
            v,
            T
          );
        if (Qt(v)) {
          if (x = Qt(v), typeof x != "function") throw Error(s(150));
          return v = x.call(v), L(
            y,
            h,
            v,
            T
          );
        }
        if (typeof v.then == "function")
          return yt(
            y,
            h,
            dn(v),
            T
          );
        if (v.$$typeof === gt)
          return yt(
            y,
            h,
            sn(y, v),
            T
          );
        yn(y, v);
      }
      return typeof v == "string" && v !== "" || typeof v == "number" || typeof v == "bigint" ? (v = "" + v, h !== null && h.tag === 6 ? (e(y, h.sibling), T = u(h, v), T.return = y, y = T) : (e(y, h), T = xi(v, y.mode, T), T.return = y, y = T), i(y)) : e(y, h);
    }
    return function(y, h, v, T) {
      try {
        cu = 0;
        var x = yt(
          y,
          h,
          v,
          T
        );
        return _a = null, x;
      } catch (q) {
        if (q === Aa || q === rn) throw q;
        var nt = rl(29, q, null, y.mode);
        return nt.lanes = T, nt.return = y, nt;
      } finally {
      }
    };
  }
  var ke = $f(!0), Ff = $f(!1), ve = !1;
  function Pi(t) {
    t.updateQueue = {
      baseState: t.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function tc(t, l) {
    t = t.updateQueue, l.updateQueue === t && (l.updateQueue = {
      baseState: t.baseState,
      firstBaseUpdate: t.firstBaseUpdate,
      lastBaseUpdate: t.lastBaseUpdate,
      shared: t.shared,
      callbacks: null
    });
  }
  function ge(t) {
    return { lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function pe(t, l, e) {
    var a = t.updateQueue;
    if (a === null) return null;
    if (a = a.shared, (ft & 2) !== 0) {
      var u = a.pending;
      return u === null ? l.next = l : (l.next = u.next, u.next = l), a.pending = l, l = un(t), Hf(t, null, e), l;
    }
    return an(t, a, l, e), un(t);
  }
  function su(t, l, e) {
    if (l = l.updateQueue, l !== null && (l = l.shared, (e & 4194048) !== 0)) {
      var a = l.lanes;
      a &= t.pendingLanes, e |= a, l.lanes = e, Q0(t, e);
    }
  }
  function lc(t, l) {
    var e = t.updateQueue, a = t.alternate;
    if (a !== null && (a = a.updateQueue, e === a)) {
      var u = null, n = null;
      if (e = e.firstBaseUpdate, e !== null) {
        do {
          var i = {
            lane: e.lane,
            tag: e.tag,
            payload: e.payload,
            callback: null,
            next: null
          };
          n === null ? u = n = i : n = n.next = i, e = e.next;
        } while (e !== null);
        n === null ? u = n = l : n = n.next = l;
      } else u = n = l;
      e = {
        baseState: a.baseState,
        firstBaseUpdate: u,
        lastBaseUpdate: n,
        shared: a.shared,
        callbacks: a.callbacks
      }, t.updateQueue = e;
      return;
    }
    t = e.lastBaseUpdate, t === null ? e.firstBaseUpdate = l : t.next = l, e.lastBaseUpdate = l;
  }
  var ec = !1;
  function ou() {
    if (ec) {
      var t = Ea;
      if (t !== null) throw t;
    }
  }
  function ru(t, l, e, a) {
    ec = !1;
    var u = t.updateQueue;
    ve = !1;
    var n = u.firstBaseUpdate, i = u.lastBaseUpdate, c = u.shared.pending;
    if (c !== null) {
      u.shared.pending = null;
      var r = c, g = r.next;
      r.next = null, i === null ? n = g : i.next = g, i = r;
      var E = t.alternate;
      E !== null && (E = E.updateQueue, c = E.lastBaseUpdate, c !== i && (c === null ? E.firstBaseUpdate = g : c.next = g, E.lastBaseUpdate = r));
    }
    if (n !== null) {
      var z = u.baseState;
      i = 0, E = g = r = null, c = n;
      do {
        var p = c.lane & -536870913, b = p !== c.lane;
        if (b ? (F & p) === p : (a & p) === p) {
          p !== 0 && p === ba && (ec = !0), E !== null && (E = E.next = {
            lane: 0,
            tag: c.tag,
            payload: c.payload,
            callback: null,
            next: null
          });
          t: {
            var j = t, L = c;
            p = l;
            var yt = e;
            switch (L.tag) {
              case 1:
                if (j = L.payload, typeof j == "function") {
                  z = j.call(yt, z, p);
                  break t;
                }
                z = j;
                break t;
              case 3:
                j.flags = j.flags & -65537 | 128;
              case 0:
                if (j = L.payload, p = typeof j == "function" ? j.call(yt, z, p) : j, p == null) break t;
                z = D({}, z, p);
                break t;
              case 2:
                ve = !0;
            }
          }
          p = c.callback, p !== null && (t.flags |= 64, b && (t.flags |= 8192), b = u.callbacks, b === null ? u.callbacks = [p] : b.push(p));
        } else
          b = {
            lane: p,
            tag: c.tag,
            payload: c.payload,
            callback: c.callback,
            next: null
          }, E === null ? (g = E = b, r = z) : E = E.next = b, i |= p;
        if (c = c.next, c === null) {
          if (c = u.shared.pending, c === null)
            break;
          b = c, c = b.next, b.next = null, u.lastBaseUpdate = b, u.shared.pending = null;
        }
      } while (!0);
      E === null && (r = z), u.baseState = r, u.firstBaseUpdate = g, u.lastBaseUpdate = E, n === null && (u.shared.lanes = 0), _e |= i, t.lanes = i, t.memoizedState = z;
    }
  }
  function If(t, l) {
    if (typeof t != "function")
      throw Error(s(191, t));
    t.call(l);
  }
  function Pf(t, l) {
    var e = t.callbacks;
    if (e !== null)
      for (t.callbacks = null, t = 0; t < e.length; t++)
        If(e[t], l);
  }
  var Ta = d(null), mn = d(0);
  function ts(t, l) {
    t = ae, R(mn, t), R(Ta, l), ae = t | l.baseLanes;
  }
  function ac() {
    R(mn, ae), R(Ta, Ta.current);
  }
  function uc() {
    ae = mn.current, _(Ta), _(mn);
  }
  var hl = d(null), Tl = null;
  function Se(t) {
    var l = t.alternate;
    R(Dt, Dt.current & 1), R(hl, t), Tl === null && (l === null || Ta.current !== null || l.memoizedState !== null) && (Tl = t);
  }
  function nc(t) {
    R(Dt, Dt.current), R(hl, t), Tl === null && (Tl = t);
  }
  function ls(t) {
    t.tag === 22 ? (R(Dt, Dt.current), R(hl, t), Tl === null && (Tl = t)) : be();
  }
  function be() {
    R(Dt, Dt.current), R(hl, hl.current);
  }
  function dl(t) {
    _(hl), Tl === t && (Tl = null), _(Dt);
  }
  var Dt = d(0);
  function vn(t) {
    for (var l = t; l !== null; ) {
      if (l.tag === 13) {
        var e = l.memoizedState;
        if (e !== null && (e = e.dehydrated, e === null || r0(e) || h0(e)))
          return l;
      } else if (l.tag === 19 && (l.memoizedProps.revealOrder === "forwards" || l.memoizedProps.revealOrder === "backwards" || l.memoizedProps.revealOrder === "unstable_legacy-backwards" || l.memoizedProps.revealOrder === "together")) {
        if ((l.flags & 128) !== 0) return l;
      } else if (l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === t) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === t) return null;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
    return null;
  }
  var Wl = 0, J = null, ht = null, Rt = null, gn = !1, za = !1, We = !1, pn = 0, hu = 0, Ma = null, p2 = 0;
  function zt() {
    throw Error(s(321));
  }
  function ic(t, l) {
    if (l === null) return !1;
    for (var e = 0; e < l.length && e < t.length; e++)
      if (!ol(t[e], l[e])) return !1;
    return !0;
  }
  function cc(t, l, e, a, u, n) {
    return Wl = n, J = l, l.memoizedState = null, l.updateQueue = null, l.lanes = 0, A.H = t === null || t.memoizedState === null ? Bs : Ac, We = !1, n = e(a, u), We = !1, za && (n = as(
      l,
      e,
      a,
      u
    )), es(t), n;
  }
  function es(t) {
    A.H = mu;
    var l = ht !== null && ht.next !== null;
    if (Wl = 0, Rt = ht = J = null, gn = !1, hu = 0, Ma = null, l) throw Error(s(300));
    t === null || Ct || (t = t.dependencies, t !== null && fn(t) && (Ct = !0));
  }
  function as(t, l, e, a) {
    J = t;
    var u = 0;
    do {
      if (za && (Ma = null), hu = 0, za = !1, 25 <= u) throw Error(s(301));
      if (u += 1, Rt = ht = null, t.updateQueue != null) {
        var n = t.updateQueue;
        n.lastEffect = null, n.events = null, n.stores = null, n.memoCache != null && (n.memoCache.index = 0);
      }
      A.H = Xs, n = l(e, a);
    } while (za);
    return n;
  }
  function S2() {
    var t = A.H, l = t.useState()[0];
    return l = typeof l.then == "function" ? du(l) : l, t = t.useState()[0], (ht !== null ? ht.memoizedState : null) !== t && (J.flags |= 1024), l;
  }
  function fc() {
    var t = pn !== 0;
    return pn = 0, t;
  }
  function sc(t, l, e) {
    l.updateQueue = t.updateQueue, l.flags &= -2053, t.lanes &= ~e;
  }
  function oc(t) {
    if (gn) {
      for (t = t.memoizedState; t !== null; ) {
        var l = t.queue;
        l !== null && (l.pending = null), t = t.next;
      }
      gn = !1;
    }
    Wl = 0, Rt = ht = J = null, za = !1, hu = pn = 0, Ma = null;
  }
  function Ft() {
    var t = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Rt === null ? J.memoizedState = Rt = t : Rt = Rt.next = t, Rt;
  }
  function Nt() {
    if (ht === null) {
      var t = J.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = ht.next;
    var l = Rt === null ? J.memoizedState : Rt.next;
    if (l !== null)
      Rt = l, ht = t;
    else {
      if (t === null)
        throw J.alternate === null ? Error(s(467)) : Error(s(310));
      ht = t, t = {
        memoizedState: ht.memoizedState,
        baseState: ht.baseState,
        baseQueue: ht.baseQueue,
        queue: ht.queue,
        next: null
      }, Rt === null ? J.memoizedState = Rt = t : Rt = Rt.next = t;
    }
    return Rt;
  }
  function Sn() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function du(t) {
    var l = hu;
    return hu += 1, Ma === null && (Ma = []), t = Jf(Ma, t, l), l = J, (Rt === null ? l.memoizedState : Rt.next) === null && (l = l.alternate, A.H = l === null || l.memoizedState === null ? Bs : Ac), t;
  }
  function bn(t) {
    if (t !== null && typeof t == "object") {
      if (typeof t.then == "function") return du(t);
      if (t.$$typeof === gt) return Vt(t);
    }
    throw Error(s(438, String(t)));
  }
  function rc(t) {
    var l = null, e = J.updateQueue;
    if (e !== null && (l = e.memoCache), l == null) {
      var a = J.alternate;
      a !== null && (a = a.updateQueue, a !== null && (a = a.memoCache, a != null && (l = {
        data: a.data.map(function(u) {
          return u.slice();
        }),
        index: 0
      })));
    }
    if (l == null && (l = { data: [], index: 0 }), e === null && (e = Sn(), J.updateQueue = e), e.memoCache = l, e = l.data[l.index], e === void 0)
      for (e = l.data[l.index] = Array(t), a = 0; a < t; a++)
        e[a] = fe;
    return l.index++, e;
  }
  function $l(t, l) {
    return typeof l == "function" ? l(t) : l;
  }
  function En(t) {
    var l = Nt();
    return hc(l, ht, t);
  }
  function hc(t, l, e) {
    var a = t.queue;
    if (a === null) throw Error(s(311));
    a.lastRenderedReducer = e;
    var u = t.baseQueue, n = a.pending;
    if (n !== null) {
      if (u !== null) {
        var i = u.next;
        u.next = n.next, n.next = i;
      }
      l.baseQueue = u = n, a.pending = null;
    }
    if (n = t.baseState, u === null) t.memoizedState = n;
    else {
      l = u.next;
      var c = i = null, r = null, g = l, E = !1;
      do {
        var z = g.lane & -536870913;
        if (z !== g.lane ? (F & z) === z : (Wl & z) === z) {
          var p = g.revertLane;
          if (p === 0)
            r !== null && (r = r.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: g.action,
              hasEagerState: g.hasEagerState,
              eagerState: g.eagerState,
              next: null
            }), z === ba && (E = !0);
          else if ((Wl & p) === p) {
            g = g.next, p === ba && (E = !0);
            continue;
          } else
            z = {
              lane: 0,
              revertLane: g.revertLane,
              gesture: null,
              action: g.action,
              hasEagerState: g.hasEagerState,
              eagerState: g.eagerState,
              next: null
            }, r === null ? (c = r = z, i = n) : r = r.next = z, J.lanes |= p, _e |= p;
          z = g.action, We && e(n, z), n = g.hasEagerState ? g.eagerState : e(n, z);
        } else
          p = {
            lane: z,
            revertLane: g.revertLane,
            gesture: g.gesture,
            action: g.action,
            hasEagerState: g.hasEagerState,
            eagerState: g.eagerState,
            next: null
          }, r === null ? (c = r = p, i = n) : r = r.next = p, J.lanes |= z, _e |= z;
        g = g.next;
      } while (g !== null && g !== l);
      if (r === null ? i = n : r.next = c, !ol(n, t.memoizedState) && (Ct = !0, E && (e = Ea, e !== null)))
        throw e;
      t.memoizedState = n, t.baseState = i, t.baseQueue = r, a.lastRenderedState = n;
    }
    return u === null && (a.lanes = 0), [t.memoizedState, a.dispatch];
  }
  function dc(t) {
    var l = Nt(), e = l.queue;
    if (e === null) throw Error(s(311));
    e.lastRenderedReducer = t;
    var a = e.dispatch, u = e.pending, n = l.memoizedState;
    if (u !== null) {
      e.pending = null;
      var i = u = u.next;
      do
        n = t(n, i.action), i = i.next;
      while (i !== u);
      ol(n, l.memoizedState) || (Ct = !0), l.memoizedState = n, l.baseQueue === null && (l.baseState = n), e.lastRenderedState = n;
    }
    return [n, a];
  }
  function us(t, l, e) {
    var a = J, u = Nt(), n = P;
    if (n) {
      if (e === void 0) throw Error(s(407));
      e = e();
    } else e = l();
    var i = !ol(
      (ht || u).memoizedState,
      e
    );
    if (i && (u.memoizedState = e, Ct = !0), u = u.queue, vc(cs.bind(null, a, u, t), [
      t
    ]), u.getSnapshot !== l || i || Rt !== null && Rt.memoizedState.tag & 1) {
      if (a.flags |= 2048, Oa(
        9,
        { destroy: void 0 },
        is.bind(
          null,
          a,
          u,
          e,
          l
        ),
        null
      ), vt === null) throw Error(s(349));
      n || (Wl & 127) !== 0 || ns(a, l, e);
    }
    return e;
  }
  function ns(t, l, e) {
    t.flags |= 16384, t = { getSnapshot: l, value: e }, l = J.updateQueue, l === null ? (l = Sn(), J.updateQueue = l, l.stores = [t]) : (e = l.stores, e === null ? l.stores = [t] : e.push(t));
  }
  function is(t, l, e, a) {
    l.value = e, l.getSnapshot = a, fs(l) && ss(t);
  }
  function cs(t, l, e) {
    return e(function() {
      fs(l) && ss(t);
    });
  }
  function fs(t) {
    var l = t.getSnapshot;
    t = t.value;
    try {
      var e = l();
      return !ol(t, e);
    } catch {
      return !0;
    }
  }
  function ss(t) {
    var l = xe(t, 2);
    l !== null && nl(l, t, 2);
  }
  function yc(t) {
    var l = Ft();
    if (typeof t == "function") {
      var e = t;
      if (t = e(), We) {
        se(!0);
        try {
          e();
        } finally {
          se(!1);
        }
      }
    }
    return l.memoizedState = l.baseState = t, l.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: $l,
      lastRenderedState: t
    }, l;
  }
  function os(t, l, e, a) {
    return t.baseState = e, hc(
      t,
      ht,
      typeof a == "function" ? a : $l
    );
  }
  function b2(t, l, e, a, u) {
    if (Tn(t)) throw Error(s(485));
    if (t = l.action, t !== null) {
      var n = {
        payload: u,
        action: t,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(i) {
          n.listeners.push(i);
        }
      };
      A.T !== null ? e(!0) : n.isTransition = !1, a(n), e = l.pending, e === null ? (n.next = l.pending = n, rs(l, n)) : (n.next = e.next, l.pending = e.next = n);
    }
  }
  function rs(t, l) {
    var e = l.action, a = l.payload, u = t.state;
    if (l.isTransition) {
      var n = A.T, i = {};
      A.T = i;
      try {
        var c = e(u, a), r = A.S;
        r !== null && r(i, c), hs(t, l, c);
      } catch (g) {
        mc(t, l, g);
      } finally {
        n !== null && i.types !== null && (n.types = i.types), A.T = n;
      }
    } else
      try {
        n = e(u, a), hs(t, l, n);
      } catch (g) {
        mc(t, l, g);
      }
  }
  function hs(t, l, e) {
    e !== null && typeof e == "object" && typeof e.then == "function" ? e.then(
      function(a) {
        ds(t, l, a);
      },
      function(a) {
        return mc(t, l, a);
      }
    ) : ds(t, l, e);
  }
  function ds(t, l, e) {
    l.status = "fulfilled", l.value = e, ys(l), t.state = e, l = t.pending, l !== null && (e = l.next, e === l ? t.pending = null : (e = e.next, l.next = e, rs(t, e)));
  }
  function mc(t, l, e) {
    var a = t.pending;
    if (t.pending = null, a !== null) {
      a = a.next;
      do
        l.status = "rejected", l.reason = e, ys(l), l = l.next;
      while (l !== a);
    }
    t.action = null;
  }
  function ys(t) {
    t = t.listeners;
    for (var l = 0; l < t.length; l++) (0, t[l])();
  }
  function ms(t, l) {
    return l;
  }
  function vs(t, l) {
    if (P) {
      var e = vt.formState;
      if (e !== null) {
        t: {
          var a = J;
          if (P) {
            if (pt) {
              l: {
                for (var u = pt, n = _l; u.nodeType !== 8; ) {
                  if (!n) {
                    u = null;
                    break l;
                  }
                  if (u = zl(
                    u.nextSibling
                  ), u === null) {
                    u = null;
                    break l;
                  }
                }
                n = u.data, u = n === "F!" || n === "F" ? u : null;
              }
              if (u) {
                pt = zl(
                  u.nextSibling
                ), a = u.data === "F!";
                break t;
              }
            }
            ye(a);
          }
          a = !1;
        }
        a && (l = e[0]);
      }
    }
    return e = Ft(), e.memoizedState = e.baseState = l, a = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: ms,
      lastRenderedState: l
    }, e.queue = a, e = Ys.bind(
      null,
      J,
      a
    ), a.dispatch = e, a = yc(!1), n = Ec.bind(
      null,
      J,
      !1,
      a.queue
    ), a = Ft(), u = {
      state: l,
      dispatch: null,
      action: t,
      pending: null
    }, a.queue = u, e = b2.bind(
      null,
      J,
      u,
      n,
      e
    ), u.dispatch = e, a.memoizedState = t, [l, e, !1];
  }
  function gs(t) {
    var l = Nt();
    return ps(l, ht, t);
  }
  function ps(t, l, e) {
    if (l = hc(
      t,
      l,
      ms
    )[0], t = En($l)[0], typeof l == "object" && l !== null && typeof l.then == "function")
      try {
        var a = du(l);
      } catch (i) {
        throw i === Aa ? rn : i;
      }
    else a = l;
    l = Nt();
    var u = l.queue, n = u.dispatch;
    return e !== l.memoizedState && (J.flags |= 2048, Oa(
      9,
      { destroy: void 0 },
      E2.bind(null, u, e),
      null
    )), [a, n, t];
  }
  function E2(t, l) {
    t.action = l;
  }
  function Ss(t) {
    var l = Nt(), e = ht;
    if (e !== null)
      return ps(l, e, t);
    Nt(), l = l.memoizedState, e = Nt();
    var a = e.queue.dispatch;
    return e.memoizedState = t, [l, a, !1];
  }
  function Oa(t, l, e, a) {
    return t = { tag: t, create: e, deps: a, inst: l, next: null }, l = J.updateQueue, l === null && (l = Sn(), J.updateQueue = l), e = l.lastEffect, e === null ? l.lastEffect = t.next = t : (a = e.next, e.next = t, t.next = a, l.lastEffect = t), t;
  }
  function bs() {
    return Nt().memoizedState;
  }
  function An(t, l, e, a) {
    var u = Ft();
    J.flags |= t, u.memoizedState = Oa(
      1 | l,
      { destroy: void 0 },
      e,
      a === void 0 ? null : a
    );
  }
  function _n(t, l, e, a) {
    var u = Nt();
    a = a === void 0 ? null : a;
    var n = u.memoizedState.inst;
    ht !== null && a !== null && ic(a, ht.memoizedState.deps) ? u.memoizedState = Oa(l, n, e, a) : (J.flags |= t, u.memoizedState = Oa(
      1 | l,
      n,
      e,
      a
    ));
  }
  function Es(t, l) {
    An(8390656, 8, t, l);
  }
  function vc(t, l) {
    _n(2048, 8, t, l);
  }
  function A2(t) {
    J.flags |= 4;
    var l = J.updateQueue;
    if (l === null)
      l = Sn(), J.updateQueue = l, l.events = [t];
    else {
      var e = l.events;
      e === null ? l.events = [t] : e.push(t);
    }
  }
  function As(t) {
    var l = Nt().memoizedState;
    return A2({ ref: l, nextImpl: t }), function() {
      if ((ft & 2) !== 0) throw Error(s(440));
      return l.impl.apply(void 0, arguments);
    };
  }
  function _s(t, l) {
    return _n(4, 2, t, l);
  }
  function Ts(t, l) {
    return _n(4, 4, t, l);
  }
  function zs(t, l) {
    if (typeof l == "function") {
      t = t();
      var e = l(t);
      return function() {
        typeof e == "function" ? e() : l(null);
      };
    }
    if (l != null)
      return t = t(), l.current = t, function() {
        l.current = null;
      };
  }
  function Ms(t, l, e) {
    e = e != null ? e.concat([t]) : null, _n(4, 4, zs.bind(null, l, t), e);
  }
  function gc() {
  }
  function Os(t, l) {
    var e = Nt();
    l = l === void 0 ? null : l;
    var a = e.memoizedState;
    return l !== null && ic(l, a[1]) ? a[0] : (e.memoizedState = [t, l], t);
  }
  function Ds(t, l) {
    var e = Nt();
    l = l === void 0 ? null : l;
    var a = e.memoizedState;
    if (l !== null && ic(l, a[1]))
      return a[0];
    if (a = t(), We) {
      se(!0);
      try {
        t();
      } finally {
        se(!1);
      }
    }
    return e.memoizedState = [a, l], a;
  }
  function pc(t, l, e) {
    return e === void 0 || (Wl & 1073741824) !== 0 && (F & 261930) === 0 ? t.memoizedState = l : (t.memoizedState = e, t = N1(), J.lanes |= t, _e |= t, e);
  }
  function Ns(t, l, e, a) {
    return ol(e, l) ? e : Ta.current !== null ? (t = pc(t, e, a), ol(t, l) || (Ct = !0), t) : (Wl & 42) === 0 || (Wl & 1073741824) !== 0 && (F & 261930) === 0 ? (Ct = !0, t.memoizedState = e) : (t = N1(), J.lanes |= t, _e |= t, l);
  }
  function Us(t, l, e, a, u) {
    var n = G.p;
    G.p = n !== 0 && 8 > n ? n : 8;
    var i = A.T, c = {};
    A.T = c, Ec(t, !1, l, e);
    try {
      var r = u(), g = A.S;
      if (g !== null && g(c, r), r !== null && typeof r == "object" && typeof r.then == "function") {
        var E = g2(
          r,
          a
        );
        yu(
          t,
          l,
          E,
          vl(t)
        );
      } else
        yu(
          t,
          l,
          a,
          vl(t)
        );
    } catch (z) {
      yu(
        t,
        l,
        { then: function() {
        }, status: "rejected", reason: z },
        vl()
      );
    } finally {
      G.p = n, i !== null && c.types !== null && (i.types = c.types), A.T = i;
    }
  }
  function _2() {
  }
  function Sc(t, l, e, a) {
    if (t.tag !== 5) throw Error(s(476));
    var u = Rs(t).queue;
    Us(
      t,
      u,
      l,
      Q,
      e === null ? _2 : function() {
        return Cs(t), e(a);
      }
    );
  }
  function Rs(t) {
    var l = t.memoizedState;
    if (l !== null) return l;
    l = {
      memoizedState: Q,
      baseState: Q,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $l,
        lastRenderedState: Q
      },
      next: null
    };
    var e = {};
    return l.next = {
      memoizedState: e,
      baseState: e,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $l,
        lastRenderedState: e
      },
      next: null
    }, t.memoizedState = l, t = t.alternate, t !== null && (t.memoizedState = l), l;
  }
  function Cs(t) {
    var l = Rs(t);
    l.next === null && (l = t.alternate.memoizedState), yu(
      t,
      l.next.queue,
      {},
      vl()
    );
  }
  function bc() {
    return Vt(Ru);
  }
  function Gs() {
    return Nt().memoizedState;
  }
  function Hs() {
    return Nt().memoizedState;
  }
  function T2(t) {
    for (var l = t.return; l !== null; ) {
      switch (l.tag) {
        case 24:
        case 3:
          var e = vl();
          t = ge(e);
          var a = pe(l, t, e);
          a !== null && (nl(a, l, e), su(a, l, e)), l = { cache: Wi() }, t.payload = l;
          return;
      }
      l = l.return;
    }
  }
  function z2(t, l, e) {
    var a = vl();
    e = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Tn(t) ? js(l, e) : (e = Bi(t, l, e, a), e !== null && (nl(e, t, a), qs(e, l, a)));
  }
  function Ys(t, l, e) {
    var a = vl();
    yu(t, l, e, a);
  }
  function yu(t, l, e, a) {
    var u = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Tn(t)) js(l, u);
    else {
      var n = t.alternate;
      if (t.lanes === 0 && (n === null || n.lanes === 0) && (n = l.lastRenderedReducer, n !== null))
        try {
          var i = l.lastRenderedState, c = n(i, e);
          if (u.hasEagerState = !0, u.eagerState = c, ol(c, i))
            return an(t, l, u, 0), vt === null && en(), !1;
        } catch {
        } finally {
        }
      if (e = Bi(t, l, u, a), e !== null)
        return nl(e, t, a), qs(e, l, a), !0;
    }
    return !1;
  }
  function Ec(t, l, e, a) {
    if (a = {
      lane: 2,
      revertLane: Pc(),
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Tn(t)) {
      if (l) throw Error(s(479));
    } else
      l = Bi(
        t,
        e,
        a,
        2
      ), l !== null && nl(l, t, 2);
  }
  function Tn(t) {
    var l = t.alternate;
    return t === J || l !== null && l === J;
  }
  function js(t, l) {
    za = gn = !0;
    var e = t.pending;
    e === null ? l.next = l : (l.next = e.next, e.next = l), t.pending = l;
  }
  function qs(t, l, e) {
    if ((e & 4194048) !== 0) {
      var a = l.lanes;
      a &= t.pendingLanes, e |= a, l.lanes = e, Q0(t, e);
    }
  }
  var mu = {
    readContext: Vt,
    use: bn,
    useCallback: zt,
    useContext: zt,
    useEffect: zt,
    useImperativeHandle: zt,
    useLayoutEffect: zt,
    useInsertionEffect: zt,
    useMemo: zt,
    useReducer: zt,
    useRef: zt,
    useState: zt,
    useDebugValue: zt,
    useDeferredValue: zt,
    useTransition: zt,
    useSyncExternalStore: zt,
    useId: zt,
    useHostTransitionStatus: zt,
    useFormState: zt,
    useActionState: zt,
    useOptimistic: zt,
    useMemoCache: zt,
    useCacheRefresh: zt
  };
  mu.useEffectEvent = zt;
  var Bs = {
    readContext: Vt,
    use: bn,
    useCallback: function(t, l) {
      return Ft().memoizedState = [
        t,
        l === void 0 ? null : l
      ], t;
    },
    useContext: Vt,
    useEffect: Es,
    useImperativeHandle: function(t, l, e) {
      e = e != null ? e.concat([t]) : null, An(
        4194308,
        4,
        zs.bind(null, l, t),
        e
      );
    },
    useLayoutEffect: function(t, l) {
      return An(4194308, 4, t, l);
    },
    useInsertionEffect: function(t, l) {
      An(4, 2, t, l);
    },
    useMemo: function(t, l) {
      var e = Ft();
      l = l === void 0 ? null : l;
      var a = t();
      if (We) {
        se(!0);
        try {
          t();
        } finally {
          se(!1);
        }
      }
      return e.memoizedState = [a, l], a;
    },
    useReducer: function(t, l, e) {
      var a = Ft();
      if (e !== void 0) {
        var u = e(l);
        if (We) {
          se(!0);
          try {
            e(l);
          } finally {
            se(!1);
          }
        }
      } else u = l;
      return a.memoizedState = a.baseState = u, t = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: u
      }, a.queue = t, t = t.dispatch = z2.bind(
        null,
        J,
        t
      ), [a.memoizedState, t];
    },
    useRef: function(t) {
      var l = Ft();
      return t = { current: t }, l.memoizedState = t;
    },
    useState: function(t) {
      t = yc(t);
      var l = t.queue, e = Ys.bind(null, J, l);
      return l.dispatch = e, [t.memoizedState, e];
    },
    useDebugValue: gc,
    useDeferredValue: function(t, l) {
      var e = Ft();
      return pc(e, t, l);
    },
    useTransition: function() {
      var t = yc(!1);
      return t = Us.bind(
        null,
        J,
        t.queue,
        !0,
        !1
      ), Ft().memoizedState = t, [!1, t];
    },
    useSyncExternalStore: function(t, l, e) {
      var a = J, u = Ft();
      if (P) {
        if (e === void 0)
          throw Error(s(407));
        e = e();
      } else {
        if (e = l(), vt === null)
          throw Error(s(349));
        (F & 127) !== 0 || ns(a, l, e);
      }
      u.memoizedState = e;
      var n = { value: e, getSnapshot: l };
      return u.queue = n, Es(cs.bind(null, a, n, t), [
        t
      ]), a.flags |= 2048, Oa(
        9,
        { destroy: void 0 },
        is.bind(
          null,
          a,
          n,
          e,
          l
        ),
        null
      ), e;
    },
    useId: function() {
      var t = Ft(), l = vt.identifierPrefix;
      if (P) {
        var e = Hl, a = Gl;
        e = (a & ~(1 << 32 - sl(a) - 1)).toString(32) + e, l = "_" + l + "R_" + e, e = pn++, 0 < e && (l += "H" + e.toString(32)), l += "_";
      } else
        e = p2++, l = "_" + l + "r_" + e.toString(32) + "_";
      return t.memoizedState = l;
    },
    useHostTransitionStatus: bc,
    useFormState: vs,
    useActionState: vs,
    useOptimistic: function(t) {
      var l = Ft();
      l.memoizedState = l.baseState = t;
      var e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return l.queue = e, l = Ec.bind(
        null,
        J,
        !0,
        e
      ), e.dispatch = l, [t, l];
    },
    useMemoCache: rc,
    useCacheRefresh: function() {
      return Ft().memoizedState = T2.bind(
        null,
        J
      );
    },
    useEffectEvent: function(t) {
      var l = Ft(), e = { impl: t };
      return l.memoizedState = e, function() {
        if ((ft & 2) !== 0)
          throw Error(s(440));
        return e.impl.apply(void 0, arguments);
      };
    }
  }, Ac = {
    readContext: Vt,
    use: bn,
    useCallback: Os,
    useContext: Vt,
    useEffect: vc,
    useImperativeHandle: Ms,
    useInsertionEffect: _s,
    useLayoutEffect: Ts,
    useMemo: Ds,
    useReducer: En,
    useRef: bs,
    useState: function() {
      return En($l);
    },
    useDebugValue: gc,
    useDeferredValue: function(t, l) {
      var e = Nt();
      return Ns(
        e,
        ht.memoizedState,
        t,
        l
      );
    },
    useTransition: function() {
      var t = En($l)[0], l = Nt().memoizedState;
      return [
        typeof t == "boolean" ? t : du(t),
        l
      ];
    },
    useSyncExternalStore: us,
    useId: Gs,
    useHostTransitionStatus: bc,
    useFormState: gs,
    useActionState: gs,
    useOptimistic: function(t, l) {
      var e = Nt();
      return os(e, ht, t, l);
    },
    useMemoCache: rc,
    useCacheRefresh: Hs
  };
  Ac.useEffectEvent = As;
  var Xs = {
    readContext: Vt,
    use: bn,
    useCallback: Os,
    useContext: Vt,
    useEffect: vc,
    useImperativeHandle: Ms,
    useInsertionEffect: _s,
    useLayoutEffect: Ts,
    useMemo: Ds,
    useReducer: dc,
    useRef: bs,
    useState: function() {
      return dc($l);
    },
    useDebugValue: gc,
    useDeferredValue: function(t, l) {
      var e = Nt();
      return ht === null ? pc(e, t, l) : Ns(
        e,
        ht.memoizedState,
        t,
        l
      );
    },
    useTransition: function() {
      var t = dc($l)[0], l = Nt().memoizedState;
      return [
        typeof t == "boolean" ? t : du(t),
        l
      ];
    },
    useSyncExternalStore: us,
    useId: Gs,
    useHostTransitionStatus: bc,
    useFormState: Ss,
    useActionState: Ss,
    useOptimistic: function(t, l) {
      var e = Nt();
      return ht !== null ? os(e, ht, t, l) : (e.baseState = t, [t, e.queue.dispatch]);
    },
    useMemoCache: rc,
    useCacheRefresh: Hs
  };
  Xs.useEffectEvent = As;
  function _c(t, l, e, a) {
    l = t.memoizedState, e = e(a, l), e = e == null ? l : D({}, l, e), t.memoizedState = e, t.lanes === 0 && (t.updateQueue.baseState = e);
  }
  var Tc = {
    enqueueSetState: function(t, l, e) {
      t = t._reactInternals;
      var a = vl(), u = ge(a);
      u.payload = l, e != null && (u.callback = e), l = pe(t, u, a), l !== null && (nl(l, t, a), su(l, t, a));
    },
    enqueueReplaceState: function(t, l, e) {
      t = t._reactInternals;
      var a = vl(), u = ge(a);
      u.tag = 1, u.payload = l, e != null && (u.callback = e), l = pe(t, u, a), l !== null && (nl(l, t, a), su(l, t, a));
    },
    enqueueForceUpdate: function(t, l) {
      t = t._reactInternals;
      var e = vl(), a = ge(e);
      a.tag = 2, l != null && (a.callback = l), l = pe(t, a, e), l !== null && (nl(l, t, e), su(l, t, e));
    }
  };
  function xs(t, l, e, a, u, n, i) {
    return t = t.stateNode, typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(a, n, i) : l.prototype && l.prototype.isPureReactComponent ? !lu(e, a) || !lu(u, n) : !0;
  }
  function Qs(t, l, e, a) {
    t = l.state, typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(e, a), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(e, a), l.state !== t && Tc.enqueueReplaceState(l, l.state, null);
  }
  function $e(t, l) {
    var e = l;
    if ("ref" in l) {
      e = {};
      for (var a in l)
        a !== "ref" && (e[a] = l[a]);
    }
    if (t = t.defaultProps) {
      e === l && (e = D({}, e));
      for (var u in t)
        e[u] === void 0 && (e[u] = t[u]);
    }
    return e;
  }
  function Ls(t) {
    ln(t);
  }
  function Zs(t) {
    console.error(t);
  }
  function Vs(t) {
    ln(t);
  }
  function zn(t, l) {
    try {
      var e = t.onUncaughtError;
      e(l.value, { componentStack: l.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function ws(t, l, e) {
    try {
      var a = t.onCaughtError;
      a(e.value, {
        componentStack: e.stack,
        errorBoundary: l.tag === 1 ? l.stateNode : null
      });
    } catch (u) {
      setTimeout(function() {
        throw u;
      });
    }
  }
  function zc(t, l, e) {
    return e = ge(e), e.tag = 3, e.payload = { element: null }, e.callback = function() {
      zn(t, l);
    }, e;
  }
  function Ks(t) {
    return t = ge(t), t.tag = 3, t;
  }
  function Js(t, l, e, a) {
    var u = e.type.getDerivedStateFromError;
    if (typeof u == "function") {
      var n = a.value;
      t.payload = function() {
        return u(n);
      }, t.callback = function() {
        ws(l, e, a);
      };
    }
    var i = e.stateNode;
    i !== null && typeof i.componentDidCatch == "function" && (t.callback = function() {
      ws(l, e, a), typeof u != "function" && (Te === null ? Te = /* @__PURE__ */ new Set([this]) : Te.add(this));
      var c = a.stack;
      this.componentDidCatch(a.value, {
        componentStack: c !== null ? c : ""
      });
    });
  }
  function M2(t, l, e, a, u) {
    if (e.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
      if (l = e.alternate, l !== null && Sa(
        l,
        e,
        u,
        !0
      ), e = hl.current, e !== null) {
        switch (e.tag) {
          case 31:
          case 13:
            return Tl === null ? qn() : e.alternate === null && Mt === 0 && (Mt = 3), e.flags &= -257, e.flags |= 65536, e.lanes = u, a === hn ? e.flags |= 16384 : (l = e.updateQueue, l === null ? e.updateQueue = /* @__PURE__ */ new Set([a]) : l.add(a), $c(t, a, u)), !1;
          case 22:
            return e.flags |= 65536, a === hn ? e.flags |= 16384 : (l = e.updateQueue, l === null ? (l = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([a])
            }, e.updateQueue = l) : (e = l.retryQueue, e === null ? l.retryQueue = /* @__PURE__ */ new Set([a]) : e.add(a)), $c(t, a, u)), !1;
        }
        throw Error(s(435, e.tag));
      }
      return $c(t, a, u), qn(), !1;
    }
    if (P)
      return l = hl.current, l !== null ? ((l.flags & 65536) === 0 && (l.flags |= 256), l.flags |= 65536, l.lanes = u, a !== Vi && (t = Error(s(422), { cause: a }), uu(bl(t, e)))) : (a !== Vi && (l = Error(s(423), {
        cause: a
      }), uu(
        bl(l, e)
      )), t = t.current.alternate, t.flags |= 65536, u &= -u, t.lanes |= u, a = bl(a, e), u = zc(
        t.stateNode,
        a,
        u
      ), lc(t, u), Mt !== 4 && (Mt = 2)), !1;
    var n = Error(s(520), { cause: a });
    if (n = bl(n, e), _u === null ? _u = [n] : _u.push(n), Mt !== 4 && (Mt = 2), l === null) return !0;
    a = bl(a, e), e = l;
    do {
      switch (e.tag) {
        case 3:
          return e.flags |= 65536, t = u & -u, e.lanes |= t, t = zc(e.stateNode, a, t), lc(e, t), !1;
        case 1:
          if (l = e.type, n = e.stateNode, (e.flags & 128) === 0 && (typeof l.getDerivedStateFromError == "function" || n !== null && typeof n.componentDidCatch == "function" && (Te === null || !Te.has(n))))
            return e.flags |= 65536, u &= -u, e.lanes |= u, u = Ks(u), Js(
              u,
              t,
              e,
              a
            ), lc(e, u), !1;
      }
      e = e.return;
    } while (e !== null);
    return !1;
  }
  var Mc = Error(s(461)), Ct = !1;
  function wt(t, l, e, a) {
    l.child = t === null ? Ff(l, null, e, a) : ke(
      l,
      t.child,
      e,
      a
    );
  }
  function ks(t, l, e, a, u) {
    e = e.render;
    var n = l.ref;
    if ("ref" in a) {
      var i = {};
      for (var c in a)
        c !== "ref" && (i[c] = a[c]);
    } else i = a;
    return Ve(l), a = cc(
      t,
      l,
      e,
      i,
      n,
      u
    ), c = fc(), t !== null && !Ct ? (sc(t, l, u), Fl(t, l, u)) : (P && c && Li(l), l.flags |= 1, wt(t, l, a, u), l.child);
  }
  function Ws(t, l, e, a, u) {
    if (t === null) {
      var n = e.type;
      return typeof n == "function" && !Xi(n) && n.defaultProps === void 0 && e.compare === null ? (l.tag = 15, l.type = n, $s(
        t,
        l,
        n,
        a,
        u
      )) : (t = nn(
        e.type,
        null,
        a,
        l,
        l.mode,
        u
      ), t.ref = l.ref, t.return = l, l.child = t);
    }
    if (n = t.child, !Hc(t, u)) {
      var i = n.memoizedProps;
      if (e = e.compare, e = e !== null ? e : lu, e(i, a) && t.ref === l.ref)
        return Fl(t, l, u);
    }
    return l.flags |= 1, t = wl(n, a), t.ref = l.ref, t.return = l, l.child = t;
  }
  function $s(t, l, e, a, u) {
    if (t !== null) {
      var n = t.memoizedProps;
      if (lu(n, a) && t.ref === l.ref)
        if (Ct = !1, l.pendingProps = a = n, Hc(t, u))
          (t.flags & 131072) !== 0 && (Ct = !0);
        else
          return l.lanes = t.lanes, Fl(t, l, u);
    }
    return Oc(
      t,
      l,
      e,
      a,
      u
    );
  }
  function Fs(t, l, e, a) {
    var u = a.children, n = t !== null ? t.memoizedState : null;
    if (t === null && l.stateNode === null && (l.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.mode === "hidden") {
      if ((l.flags & 128) !== 0) {
        if (n = n !== null ? n.baseLanes | e : e, t !== null) {
          for (a = l.child = t.child, u = 0; a !== null; )
            u = u | a.lanes | a.childLanes, a = a.sibling;
          a = u & ~n;
        } else a = 0, l.child = null;
        return Is(
          t,
          l,
          n,
          e,
          a
        );
      }
      if ((e & 536870912) !== 0)
        l.memoizedState = { baseLanes: 0, cachePool: null }, t !== null && on(
          l,
          n !== null ? n.cachePool : null
        ), n !== null ? ts(l, n) : ac(), ls(l);
      else
        return a = l.lanes = 536870912, Is(
          t,
          l,
          n !== null ? n.baseLanes | e : e,
          e,
          a
        );
    } else
      n !== null ? (on(l, n.cachePool), ts(l, n), be(), l.memoizedState = null) : (t !== null && on(l, null), ac(), be());
    return wt(t, l, u, e), l.child;
  }
  function vu(t, l) {
    return t !== null && t.tag === 22 || l.stateNode !== null || (l.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), l.sibling;
  }
  function Is(t, l, e, a, u) {
    var n = Fi();
    return n = n === null ? null : { parent: Ut._currentValue, pool: n }, l.memoizedState = {
      baseLanes: e,
      cachePool: n
    }, t !== null && on(l, null), ac(), ls(l), t !== null && Sa(t, l, a, !0), l.childLanes = u, null;
  }
  function Mn(t, l) {
    return l = Dn(
      { mode: l.mode, children: l.children },
      t.mode
    ), l.ref = t.ref, t.child = l, l.return = t, l;
  }
  function Ps(t, l, e) {
    return ke(l, t.child, null, e), t = Mn(l, l.pendingProps), t.flags |= 2, dl(l), l.memoizedState = null, t;
  }
  function O2(t, l, e) {
    var a = l.pendingProps, u = (l.flags & 128) !== 0;
    if (l.flags &= -129, t === null) {
      if (P) {
        if (a.mode === "hidden")
          return t = Mn(l, a), l.lanes = 536870912, vu(null, t);
        if (nc(l), (t = pt) ? (t = ro(
          t,
          _l
        ), t = t !== null && t.data === "&" ? t : null, t !== null && (l.memoizedState = {
          dehydrated: t,
          treeContext: he !== null ? { id: Gl, overflow: Hl } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = jf(t), e.return = l, l.child = e, Zt = l, pt = null)) : t = null, t === null) throw ye(l);
        return l.lanes = 536870912, null;
      }
      return Mn(l, a);
    }
    var n = t.memoizedState;
    if (n !== null) {
      var i = n.dehydrated;
      if (nc(l), u)
        if (l.flags & 256)
          l.flags &= -257, l = Ps(
            t,
            l,
            e
          );
        else if (l.memoizedState !== null)
          l.child = t.child, l.flags |= 128, l = null;
        else throw Error(s(558));
      else if (Ct || Sa(t, l, e, !1), u = (e & t.childLanes) !== 0, Ct || u) {
        if (a = vt, a !== null && (i = L0(a, e), i !== 0 && i !== n.retryLane))
          throw n.retryLane = i, xe(t, i), nl(a, t, i), Mc;
        qn(), l = Ps(
          t,
          l,
          e
        );
      } else
        t = n.treeContext, pt = zl(i.nextSibling), Zt = l, P = !0, de = null, _l = !1, t !== null && Xf(l, t), l = Mn(l, a), l.flags |= 4096;
      return l;
    }
    return t = wl(t.child, {
      mode: a.mode,
      children: a.children
    }), t.ref = l.ref, l.child = t, t.return = l, t;
  }
  function On(t, l) {
    var e = l.ref;
    if (e === null)
      t !== null && t.ref !== null && (l.flags |= 4194816);
    else {
      if (typeof e != "function" && typeof e != "object")
        throw Error(s(284));
      (t === null || t.ref !== e) && (l.flags |= 4194816);
    }
  }
  function Oc(t, l, e, a, u) {
    return Ve(l), e = cc(
      t,
      l,
      e,
      a,
      void 0,
      u
    ), a = fc(), t !== null && !Ct ? (sc(t, l, u), Fl(t, l, u)) : (P && a && Li(l), l.flags |= 1, wt(t, l, e, u), l.child);
  }
  function t1(t, l, e, a, u, n) {
    return Ve(l), l.updateQueue = null, e = as(
      l,
      a,
      e,
      u
    ), es(t), a = fc(), t !== null && !Ct ? (sc(t, l, n), Fl(t, l, n)) : (P && a && Li(l), l.flags |= 1, wt(t, l, e, n), l.child);
  }
  function l1(t, l, e, a, u) {
    if (Ve(l), l.stateNode === null) {
      var n = ma, i = e.contextType;
      typeof i == "object" && i !== null && (n = Vt(i)), n = new e(a, n), l.memoizedState = n.state !== null && n.state !== void 0 ? n.state : null, n.updater = Tc, l.stateNode = n, n._reactInternals = l, n = l.stateNode, n.props = a, n.state = l.memoizedState, n.refs = {}, Pi(l), i = e.contextType, n.context = typeof i == "object" && i !== null ? Vt(i) : ma, n.state = l.memoizedState, i = e.getDerivedStateFromProps, typeof i == "function" && (_c(
        l,
        e,
        i,
        a
      ), n.state = l.memoizedState), typeof e.getDerivedStateFromProps == "function" || typeof n.getSnapshotBeforeUpdate == "function" || typeof n.UNSAFE_componentWillMount != "function" && typeof n.componentWillMount != "function" || (i = n.state, typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount(), i !== n.state && Tc.enqueueReplaceState(n, n.state, null), ru(l, a, n, u), ou(), n.state = l.memoizedState), typeof n.componentDidMount == "function" && (l.flags |= 4194308), a = !0;
    } else if (t === null) {
      n = l.stateNode;
      var c = l.memoizedProps, r = $e(e, c);
      n.props = r;
      var g = n.context, E = e.contextType;
      i = ma, typeof E == "object" && E !== null && (i = Vt(E));
      var z = e.getDerivedStateFromProps;
      E = typeof z == "function" || typeof n.getSnapshotBeforeUpdate == "function", c = l.pendingProps !== c, E || typeof n.UNSAFE_componentWillReceiveProps != "function" && typeof n.componentWillReceiveProps != "function" || (c || g !== i) && Qs(
        l,
        n,
        a,
        i
      ), ve = !1;
      var p = l.memoizedState;
      n.state = p, ru(l, a, n, u), ou(), g = l.memoizedState, c || p !== g || ve ? (typeof z == "function" && (_c(
        l,
        e,
        z,
        a
      ), g = l.memoizedState), (r = ve || xs(
        l,
        e,
        r,
        a,
        p,
        g,
        i
      )) ? (E || typeof n.UNSAFE_componentWillMount != "function" && typeof n.componentWillMount != "function" || (typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount()), typeof n.componentDidMount == "function" && (l.flags |= 4194308)) : (typeof n.componentDidMount == "function" && (l.flags |= 4194308), l.memoizedProps = a, l.memoizedState = g), n.props = a, n.state = g, n.context = i, a = r) : (typeof n.componentDidMount == "function" && (l.flags |= 4194308), a = !1);
    } else {
      n = l.stateNode, tc(t, l), i = l.memoizedProps, E = $e(e, i), n.props = E, z = l.pendingProps, p = n.context, g = e.contextType, r = ma, typeof g == "object" && g !== null && (r = Vt(g)), c = e.getDerivedStateFromProps, (g = typeof c == "function" || typeof n.getSnapshotBeforeUpdate == "function") || typeof n.UNSAFE_componentWillReceiveProps != "function" && typeof n.componentWillReceiveProps != "function" || (i !== z || p !== r) && Qs(
        l,
        n,
        a,
        r
      ), ve = !1, p = l.memoizedState, n.state = p, ru(l, a, n, u), ou();
      var b = l.memoizedState;
      i !== z || p !== b || ve || t !== null && t.dependencies !== null && fn(t.dependencies) ? (typeof c == "function" && (_c(
        l,
        e,
        c,
        a
      ), b = l.memoizedState), (E = ve || xs(
        l,
        e,
        E,
        a,
        p,
        b,
        r
      ) || t !== null && t.dependencies !== null && fn(t.dependencies)) ? (g || typeof n.UNSAFE_componentWillUpdate != "function" && typeof n.componentWillUpdate != "function" || (typeof n.componentWillUpdate == "function" && n.componentWillUpdate(a, b, r), typeof n.UNSAFE_componentWillUpdate == "function" && n.UNSAFE_componentWillUpdate(
        a,
        b,
        r
      )), typeof n.componentDidUpdate == "function" && (l.flags |= 4), typeof n.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024)) : (typeof n.componentDidUpdate != "function" || i === t.memoizedProps && p === t.memoizedState || (l.flags |= 4), typeof n.getSnapshotBeforeUpdate != "function" || i === t.memoizedProps && p === t.memoizedState || (l.flags |= 1024), l.memoizedProps = a, l.memoizedState = b), n.props = a, n.state = b, n.context = r, a = E) : (typeof n.componentDidUpdate != "function" || i === t.memoizedProps && p === t.memoizedState || (l.flags |= 4), typeof n.getSnapshotBeforeUpdate != "function" || i === t.memoizedProps && p === t.memoizedState || (l.flags |= 1024), a = !1);
    }
    return n = a, On(t, l), a = (l.flags & 128) !== 0, n || a ? (n = l.stateNode, e = a && typeof e.getDerivedStateFromError != "function" ? null : n.render(), l.flags |= 1, t !== null && a ? (l.child = ke(
      l,
      t.child,
      null,
      u
    ), l.child = ke(
      l,
      null,
      e,
      u
    )) : wt(t, l, e, u), l.memoizedState = n.state, t = l.child) : t = Fl(
      t,
      l,
      u
    ), t;
  }
  function e1(t, l, e, a) {
    return Le(), l.flags |= 256, wt(t, l, e, a), l.child;
  }
  var Dc = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Nc(t) {
    return { baseLanes: t, cachePool: wf() };
  }
  function Uc(t, l, e) {
    return t = t !== null ? t.childLanes & ~e : 0, l && (t |= ml), t;
  }
  function a1(t, l, e) {
    var a = l.pendingProps, u = !1, n = (l.flags & 128) !== 0, i;
    if ((i = n) || (i = t !== null && t.memoizedState === null ? !1 : (Dt.current & 2) !== 0), i && (u = !0, l.flags &= -129), i = (l.flags & 32) !== 0, l.flags &= -33, t === null) {
      if (P) {
        if (u ? Se(l) : be(), (t = pt) ? (t = ro(
          t,
          _l
        ), t = t !== null && t.data !== "&" ? t : null, t !== null && (l.memoizedState = {
          dehydrated: t,
          treeContext: he !== null ? { id: Gl, overflow: Hl } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = jf(t), e.return = l, l.child = e, Zt = l, pt = null)) : t = null, t === null) throw ye(l);
        return h0(t) ? l.lanes = 32 : l.lanes = 536870912, null;
      }
      var c = a.children;
      return a = a.fallback, u ? (be(), u = l.mode, c = Dn(
        { mode: "hidden", children: c },
        u
      ), a = Qe(
        a,
        u,
        e,
        null
      ), c.return = l, a.return = l, c.sibling = a, l.child = c, a = l.child, a.memoizedState = Nc(e), a.childLanes = Uc(
        t,
        i,
        e
      ), l.memoizedState = Dc, vu(null, a)) : (Se(l), Rc(l, c));
    }
    var r = t.memoizedState;
    if (r !== null && (c = r.dehydrated, c !== null)) {
      if (n)
        l.flags & 256 ? (Se(l), l.flags &= -257, l = Cc(
          t,
          l,
          e
        )) : l.memoizedState !== null ? (be(), l.child = t.child, l.flags |= 128, l = null) : (be(), c = a.fallback, u = l.mode, a = Dn(
          { mode: "visible", children: a.children },
          u
        ), c = Qe(
          c,
          u,
          e,
          null
        ), c.flags |= 2, a.return = l, c.return = l, a.sibling = c, l.child = a, ke(
          l,
          t.child,
          null,
          e
        ), a = l.child, a.memoizedState = Nc(e), a.childLanes = Uc(
          t,
          i,
          e
        ), l.memoizedState = Dc, l = vu(null, a));
      else if (Se(l), h0(c)) {
        if (i = c.nextSibling && c.nextSibling.dataset, i) var g = i.dgst;
        i = g, a = Error(s(419)), a.stack = "", a.digest = i, uu({ value: a, source: null, stack: null }), l = Cc(
          t,
          l,
          e
        );
      } else if (Ct || Sa(t, l, e, !1), i = (e & t.childLanes) !== 0, Ct || i) {
        if (i = vt, i !== null && (a = L0(i, e), a !== 0 && a !== r.retryLane))
          throw r.retryLane = a, xe(t, a), nl(i, t, a), Mc;
        r0(c) || qn(), l = Cc(
          t,
          l,
          e
        );
      } else
        r0(c) ? (l.flags |= 192, l.child = t.child, l = null) : (t = r.treeContext, pt = zl(
          c.nextSibling
        ), Zt = l, P = !0, de = null, _l = !1, t !== null && Xf(l, t), l = Rc(
          l,
          a.children
        ), l.flags |= 4096);
      return l;
    }
    return u ? (be(), c = a.fallback, u = l.mode, r = t.child, g = r.sibling, a = wl(r, {
      mode: "hidden",
      children: a.children
    }), a.subtreeFlags = r.subtreeFlags & 65011712, g !== null ? c = wl(
      g,
      c
    ) : (c = Qe(
      c,
      u,
      e,
      null
    ), c.flags |= 2), c.return = l, a.return = l, a.sibling = c, l.child = a, vu(null, a), a = l.child, c = t.child.memoizedState, c === null ? c = Nc(e) : (u = c.cachePool, u !== null ? (r = Ut._currentValue, u = u.parent !== r ? { parent: r, pool: r } : u) : u = wf(), c = {
      baseLanes: c.baseLanes | e,
      cachePool: u
    }), a.memoizedState = c, a.childLanes = Uc(
      t,
      i,
      e
    ), l.memoizedState = Dc, vu(t.child, a)) : (Se(l), e = t.child, t = e.sibling, e = wl(e, {
      mode: "visible",
      children: a.children
    }), e.return = l, e.sibling = null, t !== null && (i = l.deletions, i === null ? (l.deletions = [t], l.flags |= 16) : i.push(t)), l.child = e, l.memoizedState = null, e);
  }
  function Rc(t, l) {
    return l = Dn(
      { mode: "visible", children: l },
      t.mode
    ), l.return = t, t.child = l;
  }
  function Dn(t, l) {
    return t = rl(22, t, null, l), t.lanes = 0, t;
  }
  function Cc(t, l, e) {
    return ke(l, t.child, null, e), t = Rc(
      l,
      l.pendingProps.children
    ), t.flags |= 2, l.memoizedState = null, t;
  }
  function u1(t, l, e) {
    t.lanes |= l;
    var a = t.alternate;
    a !== null && (a.lanes |= l), Ji(t.return, l, e);
  }
  function Gc(t, l, e, a, u, n) {
    var i = t.memoizedState;
    i === null ? t.memoizedState = {
      isBackwards: l,
      rendering: null,
      renderingStartTime: 0,
      last: a,
      tail: e,
      tailMode: u,
      treeForkCount: n
    } : (i.isBackwards = l, i.rendering = null, i.renderingStartTime = 0, i.last = a, i.tail = e, i.tailMode = u, i.treeForkCount = n);
  }
  function n1(t, l, e) {
    var a = l.pendingProps, u = a.revealOrder, n = a.tail;
    a = a.children;
    var i = Dt.current, c = (i & 2) !== 0;
    if (c ? (i = i & 1 | 2, l.flags |= 128) : i &= 1, R(Dt, i), wt(t, l, a, e), a = P ? au : 0, !c && t !== null && (t.flags & 128) !== 0)
      t: for (t = l.child; t !== null; ) {
        if (t.tag === 13)
          t.memoizedState !== null && u1(t, e, l);
        else if (t.tag === 19)
          u1(t, e, l);
        else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === l) break t;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === l)
            break t;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    switch (u) {
      case "forwards":
        for (e = l.child, u = null; e !== null; )
          t = e.alternate, t !== null && vn(t) === null && (u = e), e = e.sibling;
        e = u, e === null ? (u = l.child, l.child = null) : (u = e.sibling, e.sibling = null), Gc(
          l,
          !1,
          u,
          e,
          n,
          a
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (e = null, u = l.child, l.child = null; u !== null; ) {
          if (t = u.alternate, t !== null && vn(t) === null) {
            l.child = u;
            break;
          }
          t = u.sibling, u.sibling = e, e = u, u = t;
        }
        Gc(
          l,
          !0,
          e,
          null,
          n,
          a
        );
        break;
      case "together":
        Gc(
          l,
          !1,
          null,
          null,
          void 0,
          a
        );
        break;
      default:
        l.memoizedState = null;
    }
    return l.child;
  }
  function Fl(t, l, e) {
    if (t !== null && (l.dependencies = t.dependencies), _e |= l.lanes, (e & l.childLanes) === 0)
      if (t !== null) {
        if (Sa(
          t,
          l,
          e,
          !1
        ), (e & l.childLanes) === 0)
          return null;
      } else return null;
    if (t !== null && l.child !== t.child)
      throw Error(s(153));
    if (l.child !== null) {
      for (t = l.child, e = wl(t, t.pendingProps), l.child = e, e.return = l; t.sibling !== null; )
        t = t.sibling, e = e.sibling = wl(t, t.pendingProps), e.return = l;
      e.sibling = null;
    }
    return l.child;
  }
  function Hc(t, l) {
    return (t.lanes & l) !== 0 ? !0 : (t = t.dependencies, !!(t !== null && fn(t)));
  }
  function D2(t, l, e) {
    switch (l.tag) {
      case 3:
        Ht(l, l.stateNode.containerInfo), me(l, Ut, t.memoizedState.cache), Le();
        break;
      case 27:
      case 5:
        Cl(l);
        break;
      case 4:
        Ht(l, l.stateNode.containerInfo);
        break;
      case 10:
        me(
          l,
          l.type,
          l.memoizedProps.value
        );
        break;
      case 31:
        if (l.memoizedState !== null)
          return l.flags |= 128, nc(l), null;
        break;
      case 13:
        var a = l.memoizedState;
        if (a !== null)
          return a.dehydrated !== null ? (Se(l), l.flags |= 128, null) : (e & l.child.childLanes) !== 0 ? a1(t, l, e) : (Se(l), t = Fl(
            t,
            l,
            e
          ), t !== null ? t.sibling : null);
        Se(l);
        break;
      case 19:
        var u = (t.flags & 128) !== 0;
        if (a = (e & l.childLanes) !== 0, a || (Sa(
          t,
          l,
          e,
          !1
        ), a = (e & l.childLanes) !== 0), u) {
          if (a)
            return n1(
              t,
              l,
              e
            );
          l.flags |= 128;
        }
        if (u = l.memoizedState, u !== null && (u.rendering = null, u.tail = null, u.lastEffect = null), R(Dt, Dt.current), a) break;
        return null;
      case 22:
        return l.lanes = 0, Fs(
          t,
          l,
          e,
          l.pendingProps
        );
      case 24:
        me(l, Ut, t.memoizedState.cache);
    }
    return Fl(t, l, e);
  }
  function i1(t, l, e) {
    if (t !== null)
      if (t.memoizedProps !== l.pendingProps)
        Ct = !0;
      else {
        if (!Hc(t, e) && (l.flags & 128) === 0)
          return Ct = !1, D2(
            t,
            l,
            e
          );
        Ct = (t.flags & 131072) !== 0;
      }
    else
      Ct = !1, P && (l.flags & 1048576) !== 0 && Bf(l, au, l.index);
    switch (l.lanes = 0, l.tag) {
      case 16:
        t: {
          var a = l.pendingProps;
          if (t = Ke(l.elementType), l.type = t, typeof t == "function")
            Xi(t) ? (a = $e(t, a), l.tag = 1, l = l1(
              null,
              l,
              t,
              a,
              e
            )) : (l.tag = 0, l = Oc(
              null,
              l,
              t,
              a,
              e
            ));
          else {
            if (t != null) {
              var u = t.$$typeof;
              if (u === Tt) {
                l.tag = 11, l = ks(
                  null,
                  l,
                  t,
                  a,
                  e
                );
                break t;
              } else if (u === H) {
                l.tag = 14, l = Ws(
                  null,
                  l,
                  t,
                  a,
                  e
                );
                break t;
              }
            }
            throw l = Ol(t) || t, Error(s(306, l, ""));
          }
        }
        return l;
      case 0:
        return Oc(
          t,
          l,
          l.type,
          l.pendingProps,
          e
        );
      case 1:
        return a = l.type, u = $e(
          a,
          l.pendingProps
        ), l1(
          t,
          l,
          a,
          u,
          e
        );
      case 3:
        t: {
          if (Ht(
            l,
            l.stateNode.containerInfo
          ), t === null) throw Error(s(387));
          a = l.pendingProps;
          var n = l.memoizedState;
          u = n.element, tc(t, l), ru(l, a, null, e);
          var i = l.memoizedState;
          if (a = i.cache, me(l, Ut, a), a !== n.cache && ki(
            l,
            [Ut],
            e,
            !0
          ), ou(), a = i.element, n.isDehydrated)
            if (n = {
              element: a,
              isDehydrated: !1,
              cache: i.cache
            }, l.updateQueue.baseState = n, l.memoizedState = n, l.flags & 256) {
              l = e1(
                t,
                l,
                a,
                e
              );
              break t;
            } else if (a !== u) {
              u = bl(
                Error(s(424)),
                l
              ), uu(u), l = e1(
                t,
                l,
                a,
                e
              );
              break t;
            } else {
              switch (t = l.stateNode.containerInfo, t.nodeType) {
                case 9:
                  t = t.body;
                  break;
                default:
                  t = t.nodeName === "HTML" ? t.ownerDocument.body : t;
              }
              for (pt = zl(t.firstChild), Zt = l, P = !0, de = null, _l = !0, e = Ff(
                l,
                null,
                a,
                e
              ), l.child = e; e; )
                e.flags = e.flags & -3 | 4096, e = e.sibling;
            }
          else {
            if (Le(), a === u) {
              l = Fl(
                t,
                l,
                e
              );
              break t;
            }
            wt(t, l, a, e);
          }
          l = l.child;
        }
        return l;
      case 26:
        return On(t, l), t === null ? (e = po(
          l.type,
          null,
          l.pendingProps,
          null
        )) ? l.memoizedState = e : P || (e = l.type, t = l.pendingProps, a = Vn(
          K.current
        ).createElement(e), a[Lt] = l, a[Pt] = t, Kt(a, e, t), Bt(a), l.stateNode = a) : l.memoizedState = po(
          l.type,
          t.memoizedProps,
          l.pendingProps,
          t.memoizedState
        ), null;
      case 27:
        return Cl(l), t === null && P && (a = l.stateNode = mo(
          l.type,
          l.pendingProps,
          K.current
        ), Zt = l, _l = !0, u = pt, De(l.type) ? (d0 = u, pt = zl(a.firstChild)) : pt = u), wt(
          t,
          l,
          l.pendingProps.children,
          e
        ), On(t, l), t === null && (l.flags |= 4194304), l.child;
      case 5:
        return t === null && P && ((u = a = pt) && (a = uh(
          a,
          l.type,
          l.pendingProps,
          _l
        ), a !== null ? (l.stateNode = a, Zt = l, pt = zl(a.firstChild), _l = !1, u = !0) : u = !1), u || ye(l)), Cl(l), u = l.type, n = l.pendingProps, i = t !== null ? t.memoizedProps : null, a = n.children, f0(u, n) ? a = null : i !== null && f0(u, i) && (l.flags |= 32), l.memoizedState !== null && (u = cc(
          t,
          l,
          S2,
          null,
          null,
          e
        ), Ru._currentValue = u), On(t, l), wt(t, l, a, e), l.child;
      case 6:
        return t === null && P && ((t = e = pt) && (e = nh(
          e,
          l.pendingProps,
          _l
        ), e !== null ? (l.stateNode = e, Zt = l, pt = null, t = !0) : t = !1), t || ye(l)), null;
      case 13:
        return a1(t, l, e);
      case 4:
        return Ht(
          l,
          l.stateNode.containerInfo
        ), a = l.pendingProps, t === null ? l.child = ke(
          l,
          null,
          a,
          e
        ) : wt(t, l, a, e), l.child;
      case 11:
        return ks(
          t,
          l,
          l.type,
          l.pendingProps,
          e
        );
      case 7:
        return wt(
          t,
          l,
          l.pendingProps,
          e
        ), l.child;
      case 8:
        return wt(
          t,
          l,
          l.pendingProps.children,
          e
        ), l.child;
      case 12:
        return wt(
          t,
          l,
          l.pendingProps.children,
          e
        ), l.child;
      case 10:
        return a = l.pendingProps, me(l, l.type, a.value), wt(t, l, a.children, e), l.child;
      case 9:
        return u = l.type._context, a = l.pendingProps.children, Ve(l), u = Vt(u), a = a(u), l.flags |= 1, wt(t, l, a, e), l.child;
      case 14:
        return Ws(
          t,
          l,
          l.type,
          l.pendingProps,
          e
        );
      case 15:
        return $s(
          t,
          l,
          l.type,
          l.pendingProps,
          e
        );
      case 19:
        return n1(t, l, e);
      case 31:
        return O2(t, l, e);
      case 22:
        return Fs(
          t,
          l,
          e,
          l.pendingProps
        );
      case 24:
        return Ve(l), a = Vt(Ut), t === null ? (u = Fi(), u === null && (u = vt, n = Wi(), u.pooledCache = n, n.refCount++, n !== null && (u.pooledCacheLanes |= e), u = n), l.memoizedState = { parent: a, cache: u }, Pi(l), me(l, Ut, u)) : ((t.lanes & e) !== 0 && (tc(t, l), ru(l, null, null, e), ou()), u = t.memoizedState, n = l.memoizedState, u.parent !== a ? (u = { parent: a, cache: a }, l.memoizedState = u, l.lanes === 0 && (l.memoizedState = l.updateQueue.baseState = u), me(l, Ut, a)) : (a = n.cache, me(l, Ut, a), a !== u.cache && ki(
          l,
          [Ut],
          e,
          !0
        ))), wt(
          t,
          l,
          l.pendingProps.children,
          e
        ), l.child;
      case 29:
        throw l.pendingProps;
    }
    throw Error(s(156, l.tag));
  }
  function Il(t) {
    t.flags |= 4;
  }
  function Yc(t, l, e, a, u) {
    if ((l = (t.mode & 32) !== 0) && (l = !1), l) {
      if (t.flags |= 16777216, (u & 335544128) === u)
        if (t.stateNode.complete) t.flags |= 8192;
        else if (G1()) t.flags |= 8192;
        else
          throw Je = hn, Ii;
    } else t.flags &= -16777217;
  }
  function c1(t, l) {
    if (l.type !== "stylesheet" || (l.state.loading & 4) !== 0)
      t.flags &= -16777217;
    else if (t.flags |= 16777216, !_o(l))
      if (G1()) t.flags |= 8192;
      else
        throw Je = hn, Ii;
  }
  function Nn(t, l) {
    l !== null && (t.flags |= 4), t.flags & 16384 && (l = t.tag !== 22 ? X0() : 536870912, t.lanes |= l, Ra |= l);
  }
  function gu(t, l) {
    if (!P)
      switch (t.tailMode) {
        case "hidden":
          l = t.tail;
          for (var e = null; l !== null; )
            l.alternate !== null && (e = l), l = l.sibling;
          e === null ? t.tail = null : e.sibling = null;
          break;
        case "collapsed":
          e = t.tail;
          for (var a = null; e !== null; )
            e.alternate !== null && (a = e), e = e.sibling;
          a === null ? l || t.tail === null ? t.tail = null : t.tail.sibling = null : a.sibling = null;
      }
  }
  function St(t) {
    var l = t.alternate !== null && t.alternate.child === t.child, e = 0, a = 0;
    if (l)
      for (var u = t.child; u !== null; )
        e |= u.lanes | u.childLanes, a |= u.subtreeFlags & 65011712, a |= u.flags & 65011712, u.return = t, u = u.sibling;
    else
      for (u = t.child; u !== null; )
        e |= u.lanes | u.childLanes, a |= u.subtreeFlags, a |= u.flags, u.return = t, u = u.sibling;
    return t.subtreeFlags |= a, t.childLanes = e, l;
  }
  function N2(t, l, e) {
    var a = l.pendingProps;
    switch (Zi(l), l.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return St(l), null;
      case 1:
        return St(l), null;
      case 3:
        return e = l.stateNode, a = null, t !== null && (a = t.memoizedState.cache), l.memoizedState.cache !== a && (l.flags |= 2048), kl(Ut), Et(), e.pendingContext && (e.context = e.pendingContext, e.pendingContext = null), (t === null || t.child === null) && (pa(l) ? Il(l) : t === null || t.memoizedState.isDehydrated && (l.flags & 256) === 0 || (l.flags |= 1024, wi())), St(l), null;
      case 26:
        var u = l.type, n = l.memoizedState;
        return t === null ? (Il(l), n !== null ? (St(l), c1(l, n)) : (St(l), Yc(
          l,
          u,
          null,
          a,
          e
        ))) : n ? n !== t.memoizedState ? (Il(l), St(l), c1(l, n)) : (St(l), l.flags &= -16777217) : (t = t.memoizedProps, t !== a && Il(l), St(l), Yc(
          l,
          u,
          t,
          a,
          e
        )), null;
      case 27:
        if (la(l), e = K.current, u = l.type, t !== null && l.stateNode != null)
          t.memoizedProps !== a && Il(l);
        else {
          if (!a) {
            if (l.stateNode === null)
              throw Error(s(166));
            return St(l), null;
          }
          t = Y.current, pa(l) ? xf(l) : (t = mo(u, a, e), l.stateNode = t, Il(l));
        }
        return St(l), null;
      case 5:
        if (la(l), u = l.type, t !== null && l.stateNode != null)
          t.memoizedProps !== a && Il(l);
        else {
          if (!a) {
            if (l.stateNode === null)
              throw Error(s(166));
            return St(l), null;
          }
          if (n = Y.current, pa(l))
            xf(l);
          else {
            var i = Vn(
              K.current
            );
            switch (n) {
              case 1:
                n = i.createElementNS(
                  "http://www.w3.org/2000/svg",
                  u
                );
                break;
              case 2:
                n = i.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  u
                );
                break;
              default:
                switch (u) {
                  case "svg":
                    n = i.createElementNS(
                      "http://www.w3.org/2000/svg",
                      u
                    );
                    break;
                  case "math":
                    n = i.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      u
                    );
                    break;
                  case "script":
                    n = i.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(
                      n.firstChild
                    );
                    break;
                  case "select":
                    n = typeof a.is == "string" ? i.createElement("select", {
                      is: a.is
                    }) : i.createElement("select"), a.multiple ? n.multiple = !0 : a.size && (n.size = a.size);
                    break;
                  default:
                    n = typeof a.is == "string" ? i.createElement(u, { is: a.is }) : i.createElement(u);
                }
            }
            n[Lt] = l, n[Pt] = a;
            t: for (i = l.child; i !== null; ) {
              if (i.tag === 5 || i.tag === 6)
                n.appendChild(i.stateNode);
              else if (i.tag !== 4 && i.tag !== 27 && i.child !== null) {
                i.child.return = i, i = i.child;
                continue;
              }
              if (i === l) break t;
              for (; i.sibling === null; ) {
                if (i.return === null || i.return === l)
                  break t;
                i = i.return;
              }
              i.sibling.return = i.return, i = i.sibling;
            }
            l.stateNode = n;
            t: switch (Kt(n, u, a), u) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                a = !!a.autoFocus;
                break t;
              case "img":
                a = !0;
                break t;
              default:
                a = !1;
            }
            a && Il(l);
          }
        }
        return St(l), Yc(
          l,
          l.type,
          t === null ? null : t.memoizedProps,
          l.pendingProps,
          e
        ), null;
      case 6:
        if (t && l.stateNode != null)
          t.memoizedProps !== a && Il(l);
        else {
          if (typeof a != "string" && l.stateNode === null)
            throw Error(s(166));
          if (t = K.current, pa(l)) {
            if (t = l.stateNode, e = l.memoizedProps, a = null, u = Zt, u !== null)
              switch (u.tag) {
                case 27:
                case 5:
                  a = u.memoizedProps;
              }
            t[Lt] = l, t = !!(t.nodeValue === e || a !== null && a.suppressHydrationWarning === !0 || ao(t.nodeValue, e)), t || ye(l, !0);
          } else
            t = Vn(t).createTextNode(
              a
            ), t[Lt] = l, l.stateNode = t;
        }
        return St(l), null;
      case 31:
        if (e = l.memoizedState, t === null || t.memoizedState !== null) {
          if (a = pa(l), e !== null) {
            if (t === null) {
              if (!a) throw Error(s(318));
              if (t = l.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(s(557));
              t[Lt] = l;
            } else
              Le(), (l.flags & 128) === 0 && (l.memoizedState = null), l.flags |= 4;
            St(l), t = !1;
          } else
            e = wi(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = e), t = !0;
          if (!t)
            return l.flags & 256 ? (dl(l), l) : (dl(l), null);
          if ((l.flags & 128) !== 0)
            throw Error(s(558));
        }
        return St(l), null;
      case 13:
        if (a = l.memoizedState, t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
          if (u = pa(l), a !== null && a.dehydrated !== null) {
            if (t === null) {
              if (!u) throw Error(s(318));
              if (u = l.memoizedState, u = u !== null ? u.dehydrated : null, !u) throw Error(s(317));
              u[Lt] = l;
            } else
              Le(), (l.flags & 128) === 0 && (l.memoizedState = null), l.flags |= 4;
            St(l), u = !1;
          } else
            u = wi(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = u), u = !0;
          if (!u)
            return l.flags & 256 ? (dl(l), l) : (dl(l), null);
        }
        return dl(l), (l.flags & 128) !== 0 ? (l.lanes = e, l) : (e = a !== null, t = t !== null && t.memoizedState !== null, e && (a = l.child, u = null, a.alternate !== null && a.alternate.memoizedState !== null && a.alternate.memoizedState.cachePool !== null && (u = a.alternate.memoizedState.cachePool.pool), n = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (n = a.memoizedState.cachePool.pool), n !== u && (a.flags |= 2048)), e !== t && e && (l.child.flags |= 8192), Nn(l, l.updateQueue), St(l), null);
      case 4:
        return Et(), t === null && a0(l.stateNode.containerInfo), St(l), null;
      case 10:
        return kl(l.type), St(l), null;
      case 19:
        if (_(Dt), a = l.memoizedState, a === null) return St(l), null;
        if (u = (l.flags & 128) !== 0, n = a.rendering, n === null)
          if (u) gu(a, !1);
          else {
            if (Mt !== 0 || t !== null && (t.flags & 128) !== 0)
              for (t = l.child; t !== null; ) {
                if (n = vn(t), n !== null) {
                  for (l.flags |= 128, gu(a, !1), t = n.updateQueue, l.updateQueue = t, Nn(l, t), l.subtreeFlags = 0, t = e, e = l.child; e !== null; )
                    Yf(e, t), e = e.sibling;
                  return R(
                    Dt,
                    Dt.current & 1 | 2
                  ), P && Kl(l, a.treeForkCount), l.child;
                }
                t = t.sibling;
              }
            a.tail !== null && cl() > Hn && (l.flags |= 128, u = !0, gu(a, !1), l.lanes = 4194304);
          }
        else {
          if (!u)
            if (t = vn(n), t !== null) {
              if (l.flags |= 128, u = !0, t = t.updateQueue, l.updateQueue = t, Nn(l, t), gu(a, !0), a.tail === null && a.tailMode === "hidden" && !n.alternate && !P)
                return St(l), null;
            } else
              2 * cl() - a.renderingStartTime > Hn && e !== 536870912 && (l.flags |= 128, u = !0, gu(a, !1), l.lanes = 4194304);
          a.isBackwards ? (n.sibling = l.child, l.child = n) : (t = a.last, t !== null ? t.sibling = n : l.child = n, a.last = n);
        }
        return a.tail !== null ? (t = a.tail, a.rendering = t, a.tail = t.sibling, a.renderingStartTime = cl(), t.sibling = null, e = Dt.current, R(
          Dt,
          u ? e & 1 | 2 : e & 1
        ), P && Kl(l, a.treeForkCount), t) : (St(l), null);
      case 22:
      case 23:
        return dl(l), uc(), a = l.memoizedState !== null, t !== null ? t.memoizedState !== null !== a && (l.flags |= 8192) : a && (l.flags |= 8192), a ? (e & 536870912) !== 0 && (l.flags & 128) === 0 && (St(l), l.subtreeFlags & 6 && (l.flags |= 8192)) : St(l), e = l.updateQueue, e !== null && Nn(l, e.retryQueue), e = null, t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), a = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (a = l.memoizedState.cachePool.pool), a !== e && (l.flags |= 2048), t !== null && _(we), null;
      case 24:
        return e = null, t !== null && (e = t.memoizedState.cache), l.memoizedState.cache !== e && (l.flags |= 2048), kl(Ut), St(l), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(s(156, l.tag));
  }
  function U2(t, l) {
    switch (Zi(l), l.tag) {
      case 1:
        return t = l.flags, t & 65536 ? (l.flags = t & -65537 | 128, l) : null;
      case 3:
        return kl(Ut), Et(), t = l.flags, (t & 65536) !== 0 && (t & 128) === 0 ? (l.flags = t & -65537 | 128, l) : null;
      case 26:
      case 27:
      case 5:
        return la(l), null;
      case 31:
        if (l.memoizedState !== null) {
          if (dl(l), l.alternate === null)
            throw Error(s(340));
          Le();
        }
        return t = l.flags, t & 65536 ? (l.flags = t & -65537 | 128, l) : null;
      case 13:
        if (dl(l), t = l.memoizedState, t !== null && t.dehydrated !== null) {
          if (l.alternate === null)
            throw Error(s(340));
          Le();
        }
        return t = l.flags, t & 65536 ? (l.flags = t & -65537 | 128, l) : null;
      case 19:
        return _(Dt), null;
      case 4:
        return Et(), null;
      case 10:
        return kl(l.type), null;
      case 22:
      case 23:
        return dl(l), uc(), t !== null && _(we), t = l.flags, t & 65536 ? (l.flags = t & -65537 | 128, l) : null;
      case 24:
        return kl(Ut), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function f1(t, l) {
    switch (Zi(l), l.tag) {
      case 3:
        kl(Ut), Et();
        break;
      case 26:
      case 27:
      case 5:
        la(l);
        break;
      case 4:
        Et();
        break;
      case 31:
        l.memoizedState !== null && dl(l);
        break;
      case 13:
        dl(l);
        break;
      case 19:
        _(Dt);
        break;
      case 10:
        kl(l.type);
        break;
      case 22:
      case 23:
        dl(l), uc(), t !== null && _(we);
        break;
      case 24:
        kl(Ut);
    }
  }
  function pu(t, l) {
    try {
      var e = l.updateQueue, a = e !== null ? e.lastEffect : null;
      if (a !== null) {
        var u = a.next;
        e = u;
        do {
          if ((e.tag & t) === t) {
            a = void 0;
            var n = e.create, i = e.inst;
            a = n(), i.destroy = a;
          }
          e = e.next;
        } while (e !== u);
      }
    } catch (c) {
      rt(l, l.return, c);
    }
  }
  function Ee(t, l, e) {
    try {
      var a = l.updateQueue, u = a !== null ? a.lastEffect : null;
      if (u !== null) {
        var n = u.next;
        a = n;
        do {
          if ((a.tag & t) === t) {
            var i = a.inst, c = i.destroy;
            if (c !== void 0) {
              i.destroy = void 0, u = l;
              var r = e, g = c;
              try {
                g();
              } catch (E) {
                rt(
                  u,
                  r,
                  E
                );
              }
            }
          }
          a = a.next;
        } while (a !== n);
      }
    } catch (E) {
      rt(l, l.return, E);
    }
  }
  function s1(t) {
    var l = t.updateQueue;
    if (l !== null) {
      var e = t.stateNode;
      try {
        Pf(l, e);
      } catch (a) {
        rt(t, t.return, a);
      }
    }
  }
  function o1(t, l, e) {
    e.props = $e(
      t.type,
      t.memoizedProps
    ), e.state = t.memoizedState;
    try {
      e.componentWillUnmount();
    } catch (a) {
      rt(t, l, a);
    }
  }
  function Su(t, l) {
    try {
      var e = t.ref;
      if (e !== null) {
        switch (t.tag) {
          case 26:
          case 27:
          case 5:
            var a = t.stateNode;
            break;
          case 30:
            a = t.stateNode;
            break;
          default:
            a = t.stateNode;
        }
        typeof e == "function" ? t.refCleanup = e(a) : e.current = a;
      }
    } catch (u) {
      rt(t, l, u);
    }
  }
  function Yl(t, l) {
    var e = t.ref, a = t.refCleanup;
    if (e !== null)
      if (typeof a == "function")
        try {
          a();
        } catch (u) {
          rt(t, l, u);
        } finally {
          t.refCleanup = null, t = t.alternate, t != null && (t.refCleanup = null);
        }
      else if (typeof e == "function")
        try {
          e(null);
        } catch (u) {
          rt(t, l, u);
        }
      else e.current = null;
  }
  function r1(t) {
    var l = t.type, e = t.memoizedProps, a = t.stateNode;
    try {
      t: switch (l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          e.autoFocus && a.focus();
          break t;
        case "img":
          e.src ? a.src = e.src : e.srcSet && (a.srcset = e.srcSet);
      }
    } catch (u) {
      rt(t, t.return, u);
    }
  }
  function jc(t, l, e) {
    try {
      var a = t.stateNode;
      I2(a, t.type, e, l), a[Pt] = l;
    } catch (u) {
      rt(t, t.return, u);
    }
  }
  function h1(t) {
    return t.tag === 5 || t.tag === 3 || t.tag === 26 || t.tag === 27 && De(t.type) || t.tag === 4;
  }
  function qc(t) {
    t: for (; ; ) {
      for (; t.sibling === null; ) {
        if (t.return === null || h1(t.return)) return null;
        t = t.return;
      }
      for (t.sibling.return = t.return, t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18; ) {
        if (t.tag === 27 && De(t.type) || t.flags & 2 || t.child === null || t.tag === 4) continue t;
        t.child.return = t, t = t.child;
      }
      if (!(t.flags & 2)) return t.stateNode;
    }
  }
  function Bc(t, l, e) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, l ? (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).insertBefore(t, l) : (l = e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, l.appendChild(t), e = e._reactRootContainer, e != null || l.onclick !== null || (l.onclick = Zl));
    else if (a !== 4 && (a === 27 && De(t.type) && (e = t.stateNode, l = null), t = t.child, t !== null))
      for (Bc(t, l, e), t = t.sibling; t !== null; )
        Bc(t, l, e), t = t.sibling;
  }
  function Un(t, l, e) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, l ? e.insertBefore(t, l) : e.appendChild(t);
    else if (a !== 4 && (a === 27 && De(t.type) && (e = t.stateNode), t = t.child, t !== null))
      for (Un(t, l, e), t = t.sibling; t !== null; )
        Un(t, l, e), t = t.sibling;
  }
  function d1(t) {
    var l = t.stateNode, e = t.memoizedProps;
    try {
      for (var a = t.type, u = l.attributes; u.length; )
        l.removeAttributeNode(u[0]);
      Kt(l, a, e), l[Lt] = t, l[Pt] = e;
    } catch (n) {
      rt(t, t.return, n);
    }
  }
  var Pl = !1, Gt = !1, Xc = !1, y1 = typeof WeakSet == "function" ? WeakSet : Set, Xt = null;
  function R2(t, l) {
    if (t = t.containerInfo, i0 = Fn, t = Mf(t), Ci(t)) {
      if ("selectionStart" in t)
        var e = {
          start: t.selectionStart,
          end: t.selectionEnd
        };
      else
        t: {
          e = (e = t.ownerDocument) && e.defaultView || window;
          var a = e.getSelection && e.getSelection();
          if (a && a.rangeCount !== 0) {
            e = a.anchorNode;
            var u = a.anchorOffset, n = a.focusNode;
            a = a.focusOffset;
            try {
              e.nodeType, n.nodeType;
            } catch {
              e = null;
              break t;
            }
            var i = 0, c = -1, r = -1, g = 0, E = 0, z = t, p = null;
            l: for (; ; ) {
              for (var b; z !== e || u !== 0 && z.nodeType !== 3 || (c = i + u), z !== n || a !== 0 && z.nodeType !== 3 || (r = i + a), z.nodeType === 3 && (i += z.nodeValue.length), (b = z.firstChild) !== null; )
                p = z, z = b;
              for (; ; ) {
                if (z === t) break l;
                if (p === e && ++g === u && (c = i), p === n && ++E === a && (r = i), (b = z.nextSibling) !== null) break;
                z = p, p = z.parentNode;
              }
              z = b;
            }
            e = c === -1 || r === -1 ? null : { start: c, end: r };
          } else e = null;
        }
      e = e || { start: 0, end: 0 };
    } else e = null;
    for (c0 = { focusedElem: t, selectionRange: e }, Fn = !1, Xt = l; Xt !== null; )
      if (l = Xt, t = l.child, (l.subtreeFlags & 1028) !== 0 && t !== null)
        t.return = l, Xt = t;
      else
        for (; Xt !== null; ) {
          switch (l = Xt, n = l.alternate, t = l.flags, l.tag) {
            case 0:
              if ((t & 4) !== 0 && (t = l.updateQueue, t = t !== null ? t.events : null, t !== null))
                for (e = 0; e < t.length; e++)
                  u = t[e], u.ref.impl = u.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((t & 1024) !== 0 && n !== null) {
                t = void 0, e = l, u = n.memoizedProps, n = n.memoizedState, a = e.stateNode;
                try {
                  var j = $e(
                    e.type,
                    u
                  );
                  t = a.getSnapshotBeforeUpdate(
                    j,
                    n
                  ), a.__reactInternalSnapshotBeforeUpdate = t;
                } catch (L) {
                  rt(
                    e,
                    e.return,
                    L
                  );
                }
              }
              break;
            case 3:
              if ((t & 1024) !== 0) {
                if (t = l.stateNode.containerInfo, e = t.nodeType, e === 9)
                  o0(t);
                else if (e === 1)
                  switch (t.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      o0(t);
                      break;
                    default:
                      t.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((t & 1024) !== 0) throw Error(s(163));
          }
          if (t = l.sibling, t !== null) {
            t.return = l.return, Xt = t;
            break;
          }
          Xt = l.return;
        }
  }
  function m1(t, l, e) {
    var a = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        le(t, e), a & 4 && pu(5, e);
        break;
      case 1:
        if (le(t, e), a & 4)
          if (t = e.stateNode, l === null)
            try {
              t.componentDidMount();
            } catch (i) {
              rt(e, e.return, i);
            }
          else {
            var u = $e(
              e.type,
              l.memoizedProps
            );
            l = l.memoizedState;
            try {
              t.componentDidUpdate(
                u,
                l,
                t.__reactInternalSnapshotBeforeUpdate
              );
            } catch (i) {
              rt(
                e,
                e.return,
                i
              );
            }
          }
        a & 64 && s1(e), a & 512 && Su(e, e.return);
        break;
      case 3:
        if (le(t, e), a & 64 && (t = e.updateQueue, t !== null)) {
          if (l = null, e.child !== null)
            switch (e.child.tag) {
              case 27:
              case 5:
                l = e.child.stateNode;
                break;
              case 1:
                l = e.child.stateNode;
            }
          try {
            Pf(t, l);
          } catch (i) {
            rt(e, e.return, i);
          }
        }
        break;
      case 27:
        l === null && a & 4 && d1(e);
      case 26:
      case 5:
        le(t, e), l === null && a & 4 && r1(e), a & 512 && Su(e, e.return);
        break;
      case 12:
        le(t, e);
        break;
      case 31:
        le(t, e), a & 4 && p1(t, e);
        break;
      case 13:
        le(t, e), a & 4 && S1(t, e), a & 64 && (t = e.memoizedState, t !== null && (t = t.dehydrated, t !== null && (e = x2.bind(
          null,
          e
        ), ih(t, e))));
        break;
      case 22:
        if (a = e.memoizedState !== null || Pl, !a) {
          l = l !== null && l.memoizedState !== null || Gt, u = Pl;
          var n = Gt;
          Pl = a, (Gt = l) && !n ? ee(
            t,
            e,
            (e.subtreeFlags & 8772) !== 0
          ) : le(t, e), Pl = u, Gt = n;
        }
        break;
      case 30:
        break;
      default:
        le(t, e);
    }
  }
  function v1(t) {
    var l = t.alternate;
    l !== null && (t.alternate = null, v1(l)), t.child = null, t.deletions = null, t.sibling = null, t.tag === 5 && (l = t.stateNode, l !== null && mi(l)), t.stateNode = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
  }
  var At = null, ll = !1;
  function te(t, l, e) {
    for (e = e.child; e !== null; )
      g1(t, l, e), e = e.sibling;
  }
  function g1(t, l, e) {
    if (fl && typeof fl.onCommitFiberUnmount == "function")
      try {
        fl.onCommitFiberUnmount(Za, e);
      } catch {
      }
    switch (e.tag) {
      case 26:
        Gt || Yl(e, l), te(
          t,
          l,
          e
        ), e.memoizedState ? e.memoizedState.count-- : e.stateNode && (e = e.stateNode, e.parentNode.removeChild(e));
        break;
      case 27:
        Gt || Yl(e, l);
        var a = At, u = ll;
        De(e.type) && (At = e.stateNode, ll = !1), te(
          t,
          l,
          e
        ), Du(e.stateNode), At = a, ll = u;
        break;
      case 5:
        Gt || Yl(e, l);
      case 6:
        if (a = At, u = ll, At = null, te(
          t,
          l,
          e
        ), At = a, ll = u, At !== null)
          if (ll)
            try {
              (At.nodeType === 9 ? At.body : At.nodeName === "HTML" ? At.ownerDocument.body : At).removeChild(e.stateNode);
            } catch (n) {
              rt(
                e,
                l,
                n
              );
            }
          else
            try {
              At.removeChild(e.stateNode);
            } catch (n) {
              rt(
                e,
                l,
                n
              );
            }
        break;
      case 18:
        At !== null && (ll ? (t = At, so(
          t.nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t,
          e.stateNode
        ), Xa(t)) : so(At, e.stateNode));
        break;
      case 4:
        a = At, u = ll, At = e.stateNode.containerInfo, ll = !0, te(
          t,
          l,
          e
        ), At = a, ll = u;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Ee(2, e, l), Gt || Ee(4, e, l), te(
          t,
          l,
          e
        );
        break;
      case 1:
        Gt || (Yl(e, l), a = e.stateNode, typeof a.componentWillUnmount == "function" && o1(
          e,
          l,
          a
        )), te(
          t,
          l,
          e
        );
        break;
      case 21:
        te(
          t,
          l,
          e
        );
        break;
      case 22:
        Gt = (a = Gt) || e.memoizedState !== null, te(
          t,
          l,
          e
        ), Gt = a;
        break;
      default:
        te(
          t,
          l,
          e
        );
    }
  }
  function p1(t, l) {
    if (l.memoizedState === null && (t = l.alternate, t !== null && (t = t.memoizedState, t !== null))) {
      t = t.dehydrated;
      try {
        Xa(t);
      } catch (e) {
        rt(l, l.return, e);
      }
    }
  }
  function S1(t, l) {
    if (l.memoizedState === null && (t = l.alternate, t !== null && (t = t.memoizedState, t !== null && (t = t.dehydrated, t !== null))))
      try {
        Xa(t);
      } catch (e) {
        rt(l, l.return, e);
      }
  }
  function C2(t) {
    switch (t.tag) {
      case 31:
      case 13:
      case 19:
        var l = t.stateNode;
        return l === null && (l = t.stateNode = new y1()), l;
      case 22:
        return t = t.stateNode, l = t._retryCache, l === null && (l = t._retryCache = new y1()), l;
      default:
        throw Error(s(435, t.tag));
    }
  }
  function Rn(t, l) {
    var e = C2(t);
    l.forEach(function(a) {
      if (!e.has(a)) {
        e.add(a);
        var u = Q2.bind(null, t, a);
        a.then(u, u);
      }
    });
  }
  function el(t, l) {
    var e = l.deletions;
    if (e !== null)
      for (var a = 0; a < e.length; a++) {
        var u = e[a], n = t, i = l, c = i;
        t: for (; c !== null; ) {
          switch (c.tag) {
            case 27:
              if (De(c.type)) {
                At = c.stateNode, ll = !1;
                break t;
              }
              break;
            case 5:
              At = c.stateNode, ll = !1;
              break t;
            case 3:
            case 4:
              At = c.stateNode.containerInfo, ll = !0;
              break t;
          }
          c = c.return;
        }
        if (At === null) throw Error(s(160));
        g1(n, i, u), At = null, ll = !1, n = u.alternate, n !== null && (n.return = null), u.return = null;
      }
    if (l.subtreeFlags & 13886)
      for (l = l.child; l !== null; )
        b1(l, t), l = l.sibling;
  }
  var Nl = null;
  function b1(t, l) {
    var e = t.alternate, a = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        el(l, t), al(t), a & 4 && (Ee(3, t, t.return), pu(3, t), Ee(5, t, t.return));
        break;
      case 1:
        el(l, t), al(t), a & 512 && (Gt || e === null || Yl(e, e.return)), a & 64 && Pl && (t = t.updateQueue, t !== null && (a = t.callbacks, a !== null && (e = t.shared.hiddenCallbacks, t.shared.hiddenCallbacks = e === null ? a : e.concat(a))));
        break;
      case 26:
        var u = Nl;
        if (el(l, t), al(t), a & 512 && (Gt || e === null || Yl(e, e.return)), a & 4) {
          var n = e !== null ? e.memoizedState : null;
          if (a = t.memoizedState, e === null)
            if (a === null)
              if (t.stateNode === null) {
                t: {
                  a = t.type, e = t.memoizedProps, u = u.ownerDocument || u;
                  l: switch (a) {
                    case "title":
                      n = u.getElementsByTagName("title")[0], (!n || n[Ka] || n[Lt] || n.namespaceURI === "http://www.w3.org/2000/svg" || n.hasAttribute("itemprop")) && (n = u.createElement(a), u.head.insertBefore(
                        n,
                        u.querySelector("head > title")
                      )), Kt(n, a, e), n[Lt] = t, Bt(n), a = n;
                      break t;
                    case "link":
                      var i = Eo(
                        "link",
                        "href",
                        u
                      ).get(a + (e.href || ""));
                      if (i) {
                        for (var c = 0; c < i.length; c++)
                          if (n = i[c], n.getAttribute("href") === (e.href == null || e.href === "" ? null : e.href) && n.getAttribute("rel") === (e.rel == null ? null : e.rel) && n.getAttribute("title") === (e.title == null ? null : e.title) && n.getAttribute("crossorigin") === (e.crossOrigin == null ? null : e.crossOrigin)) {
                            i.splice(c, 1);
                            break l;
                          }
                      }
                      n = u.createElement(a), Kt(n, a, e), u.head.appendChild(n);
                      break;
                    case "meta":
                      if (i = Eo(
                        "meta",
                        "content",
                        u
                      ).get(a + (e.content || ""))) {
                        for (c = 0; c < i.length; c++)
                          if (n = i[c], n.getAttribute("content") === (e.content == null ? null : "" + e.content) && n.getAttribute("name") === (e.name == null ? null : e.name) && n.getAttribute("property") === (e.property == null ? null : e.property) && n.getAttribute("http-equiv") === (e.httpEquiv == null ? null : e.httpEquiv) && n.getAttribute("charset") === (e.charSet == null ? null : e.charSet)) {
                            i.splice(c, 1);
                            break l;
                          }
                      }
                      n = u.createElement(a), Kt(n, a, e), u.head.appendChild(n);
                      break;
                    default:
                      throw Error(s(468, a));
                  }
                  n[Lt] = t, Bt(n), a = n;
                }
                t.stateNode = a;
              } else
                Ao(
                  u,
                  t.type,
                  t.stateNode
                );
            else
              t.stateNode = bo(
                u,
                a,
                t.memoizedProps
              );
          else
            n !== a ? (n === null ? e.stateNode !== null && (e = e.stateNode, e.parentNode.removeChild(e)) : n.count--, a === null ? Ao(
              u,
              t.type,
              t.stateNode
            ) : bo(
              u,
              a,
              t.memoizedProps
            )) : a === null && t.stateNode !== null && jc(
              t,
              t.memoizedProps,
              e.memoizedProps
            );
        }
        break;
      case 27:
        el(l, t), al(t), a & 512 && (Gt || e === null || Yl(e, e.return)), e !== null && a & 4 && jc(
          t,
          t.memoizedProps,
          e.memoizedProps
        );
        break;
      case 5:
        if (el(l, t), al(t), a & 512 && (Gt || e === null || Yl(e, e.return)), t.flags & 32) {
          u = t.stateNode;
          try {
            fa(u, "");
          } catch (j) {
            rt(t, t.return, j);
          }
        }
        a & 4 && t.stateNode != null && (u = t.memoizedProps, jc(
          t,
          u,
          e !== null ? e.memoizedProps : u
        )), a & 1024 && (Xc = !0);
        break;
      case 6:
        if (el(l, t), al(t), a & 4) {
          if (t.stateNode === null)
            throw Error(s(162));
          a = t.memoizedProps, e = t.stateNode;
          try {
            e.nodeValue = a;
          } catch (j) {
            rt(t, t.return, j);
          }
        }
        break;
      case 3:
        if (Jn = null, u = Nl, Nl = wn(l.containerInfo), el(l, t), Nl = u, al(t), a & 4 && e !== null && e.memoizedState.isDehydrated)
          try {
            Xa(l.containerInfo);
          } catch (j) {
            rt(t, t.return, j);
          }
        Xc && (Xc = !1, E1(t));
        break;
      case 4:
        a = Nl, Nl = wn(
          t.stateNode.containerInfo
        ), el(l, t), al(t), Nl = a;
        break;
      case 12:
        el(l, t), al(t);
        break;
      case 31:
        el(l, t), al(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, Rn(t, a)));
        break;
      case 13:
        el(l, t), al(t), t.child.flags & 8192 && t.memoizedState !== null != (e !== null && e.memoizedState !== null) && (Gn = cl()), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, Rn(t, a)));
        break;
      case 22:
        u = t.memoizedState !== null;
        var r = e !== null && e.memoizedState !== null, g = Pl, E = Gt;
        if (Pl = g || u, Gt = E || r, el(l, t), Gt = E, Pl = g, al(t), a & 8192)
          t: for (l = t.stateNode, l._visibility = u ? l._visibility & -2 : l._visibility | 1, u && (e === null || r || Pl || Gt || Fe(t)), e = null, l = t; ; ) {
            if (l.tag === 5 || l.tag === 26) {
              if (e === null) {
                r = e = l;
                try {
                  if (n = r.stateNode, u)
                    i = n.style, typeof i.setProperty == "function" ? i.setProperty("display", "none", "important") : i.display = "none";
                  else {
                    c = r.stateNode;
                    var z = r.memoizedProps.style, p = z != null && z.hasOwnProperty("display") ? z.display : null;
                    c.style.display = p == null || typeof p == "boolean" ? "" : ("" + p).trim();
                  }
                } catch (j) {
                  rt(r, r.return, j);
                }
              }
            } else if (l.tag === 6) {
              if (e === null) {
                r = l;
                try {
                  r.stateNode.nodeValue = u ? "" : r.memoizedProps;
                } catch (j) {
                  rt(r, r.return, j);
                }
              }
            } else if (l.tag === 18) {
              if (e === null) {
                r = l;
                try {
                  var b = r.stateNode;
                  u ? oo(b, !0) : oo(r.stateNode, !1);
                } catch (j) {
                  rt(r, r.return, j);
                }
              }
            } else if ((l.tag !== 22 && l.tag !== 23 || l.memoizedState === null || l === t) && l.child !== null) {
              l.child.return = l, l = l.child;
              continue;
            }
            if (l === t) break t;
            for (; l.sibling === null; ) {
              if (l.return === null || l.return === t) break t;
              e === l && (e = null), l = l.return;
            }
            e === l && (e = null), l.sibling.return = l.return, l = l.sibling;
          }
        a & 4 && (a = t.updateQueue, a !== null && (e = a.retryQueue, e !== null && (a.retryQueue = null, Rn(t, e))));
        break;
      case 19:
        el(l, t), al(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, Rn(t, a)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        el(l, t), al(t);
    }
  }
  function al(t) {
    var l = t.flags;
    if (l & 2) {
      try {
        for (var e, a = t.return; a !== null; ) {
          if (h1(a)) {
            e = a;
            break;
          }
          a = a.return;
        }
        if (e == null) throw Error(s(160));
        switch (e.tag) {
          case 27:
            var u = e.stateNode, n = qc(t);
            Un(t, n, u);
            break;
          case 5:
            var i = e.stateNode;
            e.flags & 32 && (fa(i, ""), e.flags &= -33);
            var c = qc(t);
            Un(t, c, i);
            break;
          case 3:
          case 4:
            var r = e.stateNode.containerInfo, g = qc(t);
            Bc(
              t,
              g,
              r
            );
            break;
          default:
            throw Error(s(161));
        }
      } catch (E) {
        rt(t, t.return, E);
      }
      t.flags &= -3;
    }
    l & 4096 && (t.flags &= -4097);
  }
  function E1(t) {
    if (t.subtreeFlags & 1024)
      for (t = t.child; t !== null; ) {
        var l = t;
        E1(l), l.tag === 5 && l.flags & 1024 && l.stateNode.reset(), t = t.sibling;
      }
  }
  function le(t, l) {
    if (l.subtreeFlags & 8772)
      for (l = l.child; l !== null; )
        m1(t, l.alternate, l), l = l.sibling;
  }
  function Fe(t) {
    for (t = t.child; t !== null; ) {
      var l = t;
      switch (l.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Ee(4, l, l.return), Fe(l);
          break;
        case 1:
          Yl(l, l.return);
          var e = l.stateNode;
          typeof e.componentWillUnmount == "function" && o1(
            l,
            l.return,
            e
          ), Fe(l);
          break;
        case 27:
          Du(l.stateNode);
        case 26:
        case 5:
          Yl(l, l.return), Fe(l);
          break;
        case 22:
          l.memoizedState === null && Fe(l);
          break;
        case 30:
          Fe(l);
          break;
        default:
          Fe(l);
      }
      t = t.sibling;
    }
  }
  function ee(t, l, e) {
    for (e = e && (l.subtreeFlags & 8772) !== 0, l = l.child; l !== null; ) {
      var a = l.alternate, u = t, n = l, i = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          ee(
            u,
            n,
            e
          ), pu(4, n);
          break;
        case 1:
          if (ee(
            u,
            n,
            e
          ), a = n, u = a.stateNode, typeof u.componentDidMount == "function")
            try {
              u.componentDidMount();
            } catch (g) {
              rt(a, a.return, g);
            }
          if (a = n, u = a.updateQueue, u !== null) {
            var c = a.stateNode;
            try {
              var r = u.shared.hiddenCallbacks;
              if (r !== null)
                for (u.shared.hiddenCallbacks = null, u = 0; u < r.length; u++)
                  If(r[u], c);
            } catch (g) {
              rt(a, a.return, g);
            }
          }
          e && i & 64 && s1(n), Su(n, n.return);
          break;
        case 27:
          d1(n);
        case 26:
        case 5:
          ee(
            u,
            n,
            e
          ), e && a === null && i & 4 && r1(n), Su(n, n.return);
          break;
        case 12:
          ee(
            u,
            n,
            e
          );
          break;
        case 31:
          ee(
            u,
            n,
            e
          ), e && i & 4 && p1(u, n);
          break;
        case 13:
          ee(
            u,
            n,
            e
          ), e && i & 4 && S1(u, n);
          break;
        case 22:
          n.memoizedState === null && ee(
            u,
            n,
            e
          ), Su(n, n.return);
          break;
        case 30:
          break;
        default:
          ee(
            u,
            n,
            e
          );
      }
      l = l.sibling;
    }
  }
  function xc(t, l) {
    var e = null;
    t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), t = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (t = l.memoizedState.cachePool.pool), t !== e && (t != null && t.refCount++, e != null && nu(e));
  }
  function Qc(t, l) {
    t = null, l.alternate !== null && (t = l.alternate.memoizedState.cache), l = l.memoizedState.cache, l !== t && (l.refCount++, t != null && nu(t));
  }
  function Ul(t, l, e, a) {
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; )
        A1(
          t,
          l,
          e,
          a
        ), l = l.sibling;
  }
  function A1(t, l, e, a) {
    var u = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        Ul(
          t,
          l,
          e,
          a
        ), u & 2048 && pu(9, l);
        break;
      case 1:
        Ul(
          t,
          l,
          e,
          a
        );
        break;
      case 3:
        Ul(
          t,
          l,
          e,
          a
        ), u & 2048 && (t = null, l.alternate !== null && (t = l.alternate.memoizedState.cache), l = l.memoizedState.cache, l !== t && (l.refCount++, t != null && nu(t)));
        break;
      case 12:
        if (u & 2048) {
          Ul(
            t,
            l,
            e,
            a
          ), t = l.stateNode;
          try {
            var n = l.memoizedProps, i = n.id, c = n.onPostCommit;
            typeof c == "function" && c(
              i,
              l.alternate === null ? "mount" : "update",
              t.passiveEffectDuration,
              -0
            );
          } catch (r) {
            rt(l, l.return, r);
          }
        } else
          Ul(
            t,
            l,
            e,
            a
          );
        break;
      case 31:
        Ul(
          t,
          l,
          e,
          a
        );
        break;
      case 13:
        Ul(
          t,
          l,
          e,
          a
        );
        break;
      case 23:
        break;
      case 22:
        n = l.stateNode, i = l.alternate, l.memoizedState !== null ? n._visibility & 2 ? Ul(
          t,
          l,
          e,
          a
        ) : bu(t, l) : n._visibility & 2 ? Ul(
          t,
          l,
          e,
          a
        ) : (n._visibility |= 2, Da(
          t,
          l,
          e,
          a,
          (l.subtreeFlags & 10256) !== 0 || !1
        )), u & 2048 && xc(i, l);
        break;
      case 24:
        Ul(
          t,
          l,
          e,
          a
        ), u & 2048 && Qc(l.alternate, l);
        break;
      default:
        Ul(
          t,
          l,
          e,
          a
        );
    }
  }
  function Da(t, l, e, a, u) {
    for (u = u && ((l.subtreeFlags & 10256) !== 0 || !1), l = l.child; l !== null; ) {
      var n = t, i = l, c = e, r = a, g = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 15:
          Da(
            n,
            i,
            c,
            r,
            u
          ), pu(8, i);
          break;
        case 23:
          break;
        case 22:
          var E = i.stateNode;
          i.memoizedState !== null ? E._visibility & 2 ? Da(
            n,
            i,
            c,
            r,
            u
          ) : bu(
            n,
            i
          ) : (E._visibility |= 2, Da(
            n,
            i,
            c,
            r,
            u
          )), u && g & 2048 && xc(
            i.alternate,
            i
          );
          break;
        case 24:
          Da(
            n,
            i,
            c,
            r,
            u
          ), u && g & 2048 && Qc(i.alternate, i);
          break;
        default:
          Da(
            n,
            i,
            c,
            r,
            u
          );
      }
      l = l.sibling;
    }
  }
  function bu(t, l) {
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; ) {
        var e = t, a = l, u = a.flags;
        switch (a.tag) {
          case 22:
            bu(e, a), u & 2048 && xc(
              a.alternate,
              a
            );
            break;
          case 24:
            bu(e, a), u & 2048 && Qc(a.alternate, a);
            break;
          default:
            bu(e, a);
        }
        l = l.sibling;
      }
  }
  var Eu = 8192;
  function Na(t, l, e) {
    if (t.subtreeFlags & Eu)
      for (t = t.child; t !== null; )
        _1(
          t,
          l,
          e
        ), t = t.sibling;
  }
  function _1(t, l, e) {
    switch (t.tag) {
      case 26:
        Na(
          t,
          l,
          e
        ), t.flags & Eu && t.memoizedState !== null && ph(
          e,
          Nl,
          t.memoizedState,
          t.memoizedProps
        );
        break;
      case 5:
        Na(
          t,
          l,
          e
        );
        break;
      case 3:
      case 4:
        var a = Nl;
        Nl = wn(t.stateNode.containerInfo), Na(
          t,
          l,
          e
        ), Nl = a;
        break;
      case 22:
        t.memoizedState === null && (a = t.alternate, a !== null && a.memoizedState !== null ? (a = Eu, Eu = 16777216, Na(
          t,
          l,
          e
        ), Eu = a) : Na(
          t,
          l,
          e
        ));
        break;
      default:
        Na(
          t,
          l,
          e
        );
    }
  }
  function T1(t) {
    var l = t.alternate;
    if (l !== null && (t = l.child, t !== null)) {
      l.child = null;
      do
        l = t.sibling, t.sibling = null, t = l;
      while (t !== null);
    }
  }
  function Au(t) {
    var l = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (l !== null)
        for (var e = 0; e < l.length; e++) {
          var a = l[e];
          Xt = a, M1(
            a,
            t
          );
        }
      T1(t);
    }
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        z1(t), t = t.sibling;
  }
  function z1(t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Au(t), t.flags & 2048 && Ee(9, t, t.return);
        break;
      case 3:
        Au(t);
        break;
      case 12:
        Au(t);
        break;
      case 22:
        var l = t.stateNode;
        t.memoizedState !== null && l._visibility & 2 && (t.return === null || t.return.tag !== 13) ? (l._visibility &= -3, Cn(t)) : Au(t);
        break;
      default:
        Au(t);
    }
  }
  function Cn(t) {
    var l = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (l !== null)
        for (var e = 0; e < l.length; e++) {
          var a = l[e];
          Xt = a, M1(
            a,
            t
          );
        }
      T1(t);
    }
    for (t = t.child; t !== null; ) {
      switch (l = t, l.tag) {
        case 0:
        case 11:
        case 15:
          Ee(8, l, l.return), Cn(l);
          break;
        case 22:
          e = l.stateNode, e._visibility & 2 && (e._visibility &= -3, Cn(l));
          break;
        default:
          Cn(l);
      }
      t = t.sibling;
    }
  }
  function M1(t, l) {
    for (; Xt !== null; ) {
      var e = Xt;
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          Ee(8, e, l);
          break;
        case 23:
        case 22:
          if (e.memoizedState !== null && e.memoizedState.cachePool !== null) {
            var a = e.memoizedState.cachePool.pool;
            a != null && a.refCount++;
          }
          break;
        case 24:
          nu(e.memoizedState.cache);
      }
      if (a = e.child, a !== null) a.return = e, Xt = a;
      else
        t: for (e = t; Xt !== null; ) {
          a = Xt;
          var u = a.sibling, n = a.return;
          if (v1(a), a === e) {
            Xt = null;
            break t;
          }
          if (u !== null) {
            u.return = n, Xt = u;
            break t;
          }
          Xt = n;
        }
    }
  }
  var G2 = {
    getCacheForType: function(t) {
      var l = Vt(Ut), e = l.data.get(t);
      return e === void 0 && (e = t(), l.data.set(t, e)), e;
    },
    cacheSignal: function() {
      return Vt(Ut).controller.signal;
    }
  }, H2 = typeof WeakMap == "function" ? WeakMap : Map, ft = 0, vt = null, W = null, F = 0, ot = 0, yl = null, Ae = !1, Ua = !1, Lc = !1, ae = 0, Mt = 0, _e = 0, Ie = 0, Zc = 0, ml = 0, Ra = 0, _u = null, ul = null, Vc = !1, Gn = 0, O1 = 0, Hn = 1 / 0, Yn = null, Te = null, Yt = 0, ze = null, Ca = null, ue = 0, wc = 0, Kc = null, D1 = null, Tu = 0, Jc = null;
  function vl() {
    return (ft & 2) !== 0 && F !== 0 ? F & -F : A.T !== null ? Pc() : Z0();
  }
  function N1() {
    if (ml === 0)
      if ((F & 536870912) === 0 || P) {
        var t = Lu;
        Lu <<= 1, (Lu & 3932160) === 0 && (Lu = 262144), ml = t;
      } else ml = 536870912;
    return t = hl.current, t !== null && (t.flags |= 32), ml;
  }
  function nl(t, l, e) {
    (t === vt && (ot === 2 || ot === 9) || t.cancelPendingCommit !== null) && (Ga(t, 0), Me(
      t,
      F,
      ml,
      !1
    )), wa(t, e), ((ft & 2) === 0 || t !== vt) && (t === vt && ((ft & 2) === 0 && (Ie |= e), Mt === 4 && Me(
      t,
      F,
      ml,
      !1
    )), jl(t));
  }
  function U1(t, l, e) {
    if ((ft & 6) !== 0) throw Error(s(327));
    var a = !e && (l & 127) === 0 && (l & t.expiredLanes) === 0 || Va(t, l), u = a ? q2(t, l) : Wc(t, l, !0), n = a;
    do {
      if (u === 0) {
        Ua && !a && Me(t, l, 0, !1);
        break;
      } else {
        if (e = t.current.alternate, n && !Y2(e)) {
          u = Wc(t, l, !1), n = !1;
          continue;
        }
        if (u === 2) {
          if (n = l, t.errorRecoveryDisabledLanes & n)
            var i = 0;
          else
            i = t.pendingLanes & -536870913, i = i !== 0 ? i : i & 536870912 ? 536870912 : 0;
          if (i !== 0) {
            l = i;
            t: {
              var c = t;
              u = _u;
              var r = c.current.memoizedState.isDehydrated;
              if (r && (Ga(c, i).flags |= 256), i = Wc(
                c,
                i,
                !1
              ), i !== 2) {
                if (Lc && !r) {
                  c.errorRecoveryDisabledLanes |= n, Ie |= n, u = 4;
                  break t;
                }
                n = ul, ul = u, n !== null && (ul === null ? ul = n : ul.push.apply(
                  ul,
                  n
                ));
              }
              u = i;
            }
            if (n = !1, u !== 2) continue;
          }
        }
        if (u === 1) {
          Ga(t, 0), Me(t, l, 0, !0);
          break;
        }
        t: {
          switch (a = t, n = u, n) {
            case 0:
            case 1:
              throw Error(s(345));
            case 4:
              if ((l & 4194048) !== l) break;
            case 6:
              Me(
                a,
                l,
                ml,
                !Ae
              );
              break t;
            case 2:
              ul = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(s(329));
          }
          if ((l & 62914560) === l && (u = Gn + 300 - cl(), 10 < u)) {
            if (Me(
              a,
              l,
              ml,
              !Ae
            ), Vu(a, 0, !0) !== 0) break t;
            ue = l, a.timeoutHandle = co(
              R1.bind(
                null,
                a,
                e,
                ul,
                Yn,
                Vc,
                l,
                ml,
                Ie,
                Ra,
                Ae,
                n,
                "Throttled",
                -0,
                0
              ),
              u
            );
            break t;
          }
          R1(
            a,
            e,
            ul,
            Yn,
            Vc,
            l,
            ml,
            Ie,
            Ra,
            Ae,
            n,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    jl(t);
  }
  function R1(t, l, e, a, u, n, i, c, r, g, E, z, p, b) {
    if (t.timeoutHandle = -1, z = l.subtreeFlags, z & 8192 || (z & 16785408) === 16785408) {
      z = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Zl
      }, _1(
        l,
        n,
        z
      );
      var j = (n & 62914560) === n ? Gn - cl() : (n & 4194048) === n ? O1 - cl() : 0;
      if (j = Sh(
        z,
        j
      ), j !== null) {
        ue = n, t.cancelPendingCommit = j(
          X1.bind(
            null,
            t,
            l,
            n,
            e,
            a,
            u,
            i,
            c,
            r,
            E,
            z,
            null,
            p,
            b
          )
        ), Me(t, n, i, !g);
        return;
      }
    }
    X1(
      t,
      l,
      n,
      e,
      a,
      u,
      i,
      c,
      r
    );
  }
  function Y2(t) {
    for (var l = t; ; ) {
      var e = l.tag;
      if ((e === 0 || e === 11 || e === 15) && l.flags & 16384 && (e = l.updateQueue, e !== null && (e = e.stores, e !== null)))
        for (var a = 0; a < e.length; a++) {
          var u = e[a], n = u.getSnapshot;
          u = u.value;
          try {
            if (!ol(n(), u)) return !1;
          } catch {
            return !1;
          }
        }
      if (e = l.child, l.subtreeFlags & 16384 && e !== null)
        e.return = l, l = e;
      else {
        if (l === t) break;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === t) return !0;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    }
    return !0;
  }
  function Me(t, l, e, a) {
    l &= ~Zc, l &= ~Ie, t.suspendedLanes |= l, t.pingedLanes &= ~l, a && (t.warmLanes |= l), a = t.expirationTimes;
    for (var u = l; 0 < u; ) {
      var n = 31 - sl(u), i = 1 << n;
      a[n] = -1, u &= ~i;
    }
    e !== 0 && x0(t, e, l);
  }
  function jn() {
    return (ft & 6) === 0 ? (zu(0), !1) : !0;
  }
  function kc() {
    if (W !== null) {
      if (ot === 0)
        var t = W.return;
      else
        t = W, Jl = Ze = null, oc(t), _a = null, cu = 0, t = W;
      for (; t !== null; )
        f1(t.alternate, t), t = t.return;
      W = null;
    }
  }
  function Ga(t, l) {
    var e = t.timeoutHandle;
    e !== -1 && (t.timeoutHandle = -1, lh(e)), e = t.cancelPendingCommit, e !== null && (t.cancelPendingCommit = null, e()), ue = 0, kc(), vt = t, W = e = wl(t.current, null), F = l, ot = 0, yl = null, Ae = !1, Ua = Va(t, l), Lc = !1, Ra = ml = Zc = Ie = _e = Mt = 0, ul = _u = null, Vc = !1, (l & 8) !== 0 && (l |= l & 32);
    var a = t.entangledLanes;
    if (a !== 0)
      for (t = t.entanglements, a &= l; 0 < a; ) {
        var u = 31 - sl(a), n = 1 << u;
        l |= t[u], a &= ~n;
      }
    return ae = l, en(), e;
  }
  function C1(t, l) {
    J = null, A.H = mu, l === Aa || l === rn ? (l = kf(), ot = 3) : l === Ii ? (l = kf(), ot = 4) : ot = l === Mc ? 8 : l !== null && typeof l == "object" && typeof l.then == "function" ? 6 : 1, yl = l, W === null && (Mt = 1, zn(
      t,
      bl(l, t.current)
    ));
  }
  function G1() {
    var t = hl.current;
    return t === null ? !0 : (F & 4194048) === F ? Tl === null : (F & 62914560) === F || (F & 536870912) !== 0 ? t === Tl : !1;
  }
  function H1() {
    var t = A.H;
    return A.H = mu, t === null ? mu : t;
  }
  function Y1() {
    var t = A.A;
    return A.A = G2, t;
  }
  function qn() {
    Mt = 4, Ae || (F & 4194048) !== F && hl.current !== null || (Ua = !0), (_e & 134217727) === 0 && (Ie & 134217727) === 0 || vt === null || Me(
      vt,
      F,
      ml,
      !1
    );
  }
  function Wc(t, l, e) {
    var a = ft;
    ft |= 2;
    var u = H1(), n = Y1();
    (vt !== t || F !== l) && (Yn = null, Ga(t, l)), l = !1;
    var i = Mt;
    t: do
      try {
        if (ot !== 0 && W !== null) {
          var c = W, r = yl;
          switch (ot) {
            case 8:
              kc(), i = 6;
              break t;
            case 3:
            case 2:
            case 9:
            case 6:
              hl.current === null && (l = !0);
              var g = ot;
              if (ot = 0, yl = null, Ha(t, c, r, g), e && Ua) {
                i = 0;
                break t;
              }
              break;
            default:
              g = ot, ot = 0, yl = null, Ha(t, c, r, g);
          }
        }
        j2(), i = Mt;
        break;
      } catch (E) {
        C1(t, E);
      }
    while (!0);
    return l && t.shellSuspendCounter++, Jl = Ze = null, ft = a, A.H = u, A.A = n, W === null && (vt = null, F = 0, en()), i;
  }
  function j2() {
    for (; W !== null; ) j1(W);
  }
  function q2(t, l) {
    var e = ft;
    ft |= 2;
    var a = H1(), u = Y1();
    vt !== t || F !== l ? (Yn = null, Hn = cl() + 500, Ga(t, l)) : Ua = Va(
      t,
      l
    );
    t: do
      try {
        if (ot !== 0 && W !== null) {
          l = W;
          var n = yl;
          l: switch (ot) {
            case 1:
              ot = 0, yl = null, Ha(t, l, n, 1);
              break;
            case 2:
            case 9:
              if (Kf(n)) {
                ot = 0, yl = null, q1(l);
                break;
              }
              l = function() {
                ot !== 2 && ot !== 9 || vt !== t || (ot = 7), jl(t);
              }, n.then(l, l);
              break t;
            case 3:
              ot = 7;
              break t;
            case 4:
              ot = 5;
              break t;
            case 7:
              Kf(n) ? (ot = 0, yl = null, q1(l)) : (ot = 0, yl = null, Ha(t, l, n, 7));
              break;
            case 5:
              var i = null;
              switch (W.tag) {
                case 26:
                  i = W.memoizedState;
                case 5:
                case 27:
                  var c = W;
                  if (i ? _o(i) : c.stateNode.complete) {
                    ot = 0, yl = null;
                    var r = c.sibling;
                    if (r !== null) W = r;
                    else {
                      var g = c.return;
                      g !== null ? (W = g, Bn(g)) : W = null;
                    }
                    break l;
                  }
              }
              ot = 0, yl = null, Ha(t, l, n, 5);
              break;
            case 6:
              ot = 0, yl = null, Ha(t, l, n, 6);
              break;
            case 8:
              kc(), Mt = 6;
              break t;
            default:
              throw Error(s(462));
          }
        }
        B2();
        break;
      } catch (E) {
        C1(t, E);
      }
    while (!0);
    return Jl = Ze = null, A.H = a, A.A = u, ft = e, W !== null ? 0 : (vt = null, F = 0, en(), Mt);
  }
  function B2() {
    for (; W !== null && !cr(); )
      j1(W);
  }
  function j1(t) {
    var l = i1(t.alternate, t, ae);
    t.memoizedProps = t.pendingProps, l === null ? Bn(t) : W = l;
  }
  function q1(t) {
    var l = t, e = l.alternate;
    switch (l.tag) {
      case 15:
      case 0:
        l = t1(
          e,
          l,
          l.pendingProps,
          l.type,
          void 0,
          F
        );
        break;
      case 11:
        l = t1(
          e,
          l,
          l.pendingProps,
          l.type.render,
          l.ref,
          F
        );
        break;
      case 5:
        oc(l);
      default:
        f1(e, l), l = W = Yf(l, ae), l = i1(e, l, ae);
    }
    t.memoizedProps = t.pendingProps, l === null ? Bn(t) : W = l;
  }
  function Ha(t, l, e, a) {
    Jl = Ze = null, oc(l), _a = null, cu = 0;
    var u = l.return;
    try {
      if (M2(
        t,
        u,
        l,
        e,
        F
      )) {
        Mt = 1, zn(
          t,
          bl(e, t.current)
        ), W = null;
        return;
      }
    } catch (n) {
      if (u !== null) throw W = u, n;
      Mt = 1, zn(
        t,
        bl(e, t.current)
      ), W = null;
      return;
    }
    l.flags & 32768 ? (P || a === 1 ? t = !0 : Ua || (F & 536870912) !== 0 ? t = !1 : (Ae = t = !0, (a === 2 || a === 9 || a === 3 || a === 6) && (a = hl.current, a !== null && a.tag === 13 && (a.flags |= 16384))), B1(l, t)) : Bn(l);
  }
  function Bn(t) {
    var l = t;
    do {
      if ((l.flags & 32768) !== 0) {
        B1(
          l,
          Ae
        );
        return;
      }
      t = l.return;
      var e = N2(
        l.alternate,
        l,
        ae
      );
      if (e !== null) {
        W = e;
        return;
      }
      if (l = l.sibling, l !== null) {
        W = l;
        return;
      }
      W = l = t;
    } while (l !== null);
    Mt === 0 && (Mt = 5);
  }
  function B1(t, l) {
    do {
      var e = U2(t.alternate, t);
      if (e !== null) {
        e.flags &= 32767, W = e;
        return;
      }
      if (e = t.return, e !== null && (e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null), !l && (t = t.sibling, t !== null)) {
        W = t;
        return;
      }
      W = t = e;
    } while (t !== null);
    Mt = 6, W = null;
  }
  function X1(t, l, e, a, u, n, i, c, r) {
    t.cancelPendingCommit = null;
    do
      Xn();
    while (Yt !== 0);
    if ((ft & 6) !== 0) throw Error(s(327));
    if (l !== null) {
      if (l === t.current) throw Error(s(177));
      if (n = l.lanes | l.childLanes, n |= qi, gr(
        t,
        e,
        n,
        i,
        c,
        r
      ), t === vt && (W = vt = null, F = 0), Ca = l, ze = t, ue = e, wc = n, Kc = u, D1 = a, (l.subtreeFlags & 10256) !== 0 || (l.flags & 10256) !== 0 ? (t.callbackNode = null, t.callbackPriority = 0, L2(xu, function() {
        return V1(), null;
      })) : (t.callbackNode = null, t.callbackPriority = 0), a = (l.flags & 13878) !== 0, (l.subtreeFlags & 13878) !== 0 || a) {
        a = A.T, A.T = null, u = G.p, G.p = 2, i = ft, ft |= 4;
        try {
          R2(t, l, e);
        } finally {
          ft = i, G.p = u, A.T = a;
        }
      }
      Yt = 1, x1(), Q1(), L1();
    }
  }
  function x1() {
    if (Yt === 1) {
      Yt = 0;
      var t = ze, l = Ca, e = (l.flags & 13878) !== 0;
      if ((l.subtreeFlags & 13878) !== 0 || e) {
        e = A.T, A.T = null;
        var a = G.p;
        G.p = 2;
        var u = ft;
        ft |= 4;
        try {
          b1(l, t);
          var n = c0, i = Mf(t.containerInfo), c = n.focusedElem, r = n.selectionRange;
          if (i !== c && c && c.ownerDocument && zf(
            c.ownerDocument.documentElement,
            c
          )) {
            if (r !== null && Ci(c)) {
              var g = r.start, E = r.end;
              if (E === void 0 && (E = g), "selectionStart" in c)
                c.selectionStart = g, c.selectionEnd = Math.min(
                  E,
                  c.value.length
                );
              else {
                var z = c.ownerDocument || document, p = z && z.defaultView || window;
                if (p.getSelection) {
                  var b = p.getSelection(), j = c.textContent.length, L = Math.min(r.start, j), yt = r.end === void 0 ? L : Math.min(r.end, j);
                  !b.extend && L > yt && (i = yt, yt = L, L = i);
                  var y = Tf(
                    c,
                    L
                  ), h = Tf(
                    c,
                    yt
                  );
                  if (y && h && (b.rangeCount !== 1 || b.anchorNode !== y.node || b.anchorOffset !== y.offset || b.focusNode !== h.node || b.focusOffset !== h.offset)) {
                    var v = z.createRange();
                    v.setStart(y.node, y.offset), b.removeAllRanges(), L > yt ? (b.addRange(v), b.extend(h.node, h.offset)) : (v.setEnd(h.node, h.offset), b.addRange(v));
                  }
                }
              }
            }
            for (z = [], b = c; b = b.parentNode; )
              b.nodeType === 1 && z.push({
                element: b,
                left: b.scrollLeft,
                top: b.scrollTop
              });
            for (typeof c.focus == "function" && c.focus(), c = 0; c < z.length; c++) {
              var T = z[c];
              T.element.scrollLeft = T.left, T.element.scrollTop = T.top;
            }
          }
          Fn = !!i0, c0 = i0 = null;
        } finally {
          ft = u, G.p = a, A.T = e;
        }
      }
      t.current = l, Yt = 2;
    }
  }
  function Q1() {
    if (Yt === 2) {
      Yt = 0;
      var t = ze, l = Ca, e = (l.flags & 8772) !== 0;
      if ((l.subtreeFlags & 8772) !== 0 || e) {
        e = A.T, A.T = null;
        var a = G.p;
        G.p = 2;
        var u = ft;
        ft |= 4;
        try {
          m1(t, l.alternate, l);
        } finally {
          ft = u, G.p = a, A.T = e;
        }
      }
      Yt = 3;
    }
  }
  function L1() {
    if (Yt === 4 || Yt === 3) {
      Yt = 0, fr();
      var t = ze, l = Ca, e = ue, a = D1;
      (l.subtreeFlags & 10256) !== 0 || (l.flags & 10256) !== 0 ? Yt = 5 : (Yt = 0, Ca = ze = null, Z1(t, t.pendingLanes));
      var u = t.pendingLanes;
      if (u === 0 && (Te = null), di(e), l = l.stateNode, fl && typeof fl.onCommitFiberRoot == "function")
        try {
          fl.onCommitFiberRoot(
            Za,
            l,
            void 0,
            (l.current.flags & 128) === 128
          );
        } catch {
        }
      if (a !== null) {
        l = A.T, u = G.p, G.p = 2, A.T = null;
        try {
          for (var n = t.onRecoverableError, i = 0; i < a.length; i++) {
            var c = a[i];
            n(c.value, {
              componentStack: c.stack
            });
          }
        } finally {
          A.T = l, G.p = u;
        }
      }
      (ue & 3) !== 0 && Xn(), jl(t), u = t.pendingLanes, (e & 261930) !== 0 && (u & 42) !== 0 ? t === Jc ? Tu++ : (Tu = 0, Jc = t) : Tu = 0, zu(0);
    }
  }
  function Z1(t, l) {
    (t.pooledCacheLanes &= l) === 0 && (l = t.pooledCache, l != null && (t.pooledCache = null, nu(l)));
  }
  function Xn() {
    return x1(), Q1(), L1(), V1();
  }
  function V1() {
    if (Yt !== 5) return !1;
    var t = ze, l = wc;
    wc = 0;
    var e = di(ue), a = A.T, u = G.p;
    try {
      G.p = 32 > e ? 32 : e, A.T = null, e = Kc, Kc = null;
      var n = ze, i = ue;
      if (Yt = 0, Ca = ze = null, ue = 0, (ft & 6) !== 0) throw Error(s(331));
      var c = ft;
      if (ft |= 4, z1(n.current), A1(
        n,
        n.current,
        i,
        e
      ), ft = c, zu(0, !1), fl && typeof fl.onPostCommitFiberRoot == "function")
        try {
          fl.onPostCommitFiberRoot(Za, n);
        } catch {
        }
      return !0;
    } finally {
      G.p = u, A.T = a, Z1(t, l);
    }
  }
  function w1(t, l, e) {
    l = bl(e, l), l = zc(t.stateNode, l, 2), t = pe(t, l, 2), t !== null && (wa(t, 2), jl(t));
  }
  function rt(t, l, e) {
    if (t.tag === 3)
      w1(t, t, e);
    else
      for (; l !== null; ) {
        if (l.tag === 3) {
          w1(
            l,
            t,
            e
          );
          break;
        } else if (l.tag === 1) {
          var a = l.stateNode;
          if (typeof l.type.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && (Te === null || !Te.has(a))) {
            t = bl(e, t), e = Ks(2), a = pe(l, e, 2), a !== null && (Js(
              e,
              a,
              l,
              t
            ), wa(a, 2), jl(a));
            break;
          }
        }
        l = l.return;
      }
  }
  function $c(t, l, e) {
    var a = t.pingCache;
    if (a === null) {
      a = t.pingCache = new H2();
      var u = /* @__PURE__ */ new Set();
      a.set(l, u);
    } else
      u = a.get(l), u === void 0 && (u = /* @__PURE__ */ new Set(), a.set(l, u));
    u.has(e) || (Lc = !0, u.add(e), t = X2.bind(null, t, l, e), l.then(t, t));
  }
  function X2(t, l, e) {
    var a = t.pingCache;
    a !== null && a.delete(l), t.pingedLanes |= t.suspendedLanes & e, t.warmLanes &= ~e, vt === t && (F & e) === e && (Mt === 4 || Mt === 3 && (F & 62914560) === F && 300 > cl() - Gn ? (ft & 2) === 0 && Ga(t, 0) : Zc |= e, Ra === F && (Ra = 0)), jl(t);
  }
  function K1(t, l) {
    l === 0 && (l = X0()), t = xe(t, l), t !== null && (wa(t, l), jl(t));
  }
  function x2(t) {
    var l = t.memoizedState, e = 0;
    l !== null && (e = l.retryLane), K1(t, e);
  }
  function Q2(t, l) {
    var e = 0;
    switch (t.tag) {
      case 31:
      case 13:
        var a = t.stateNode, u = t.memoizedState;
        u !== null && (e = u.retryLane);
        break;
      case 19:
        a = t.stateNode;
        break;
      case 22:
        a = t.stateNode._retryCache;
        break;
      default:
        throw Error(s(314));
    }
    a !== null && a.delete(l), K1(t, e);
  }
  function L2(t, l) {
    return si(t, l);
  }
  var xn = null, Ya = null, Fc = !1, Qn = !1, Ic = !1, Oe = 0;
  function jl(t) {
    t !== Ya && t.next === null && (Ya === null ? xn = Ya = t : Ya = Ya.next = t), Qn = !0, Fc || (Fc = !0, V2());
  }
  function zu(t, l) {
    if (!Ic && Qn) {
      Ic = !0;
      do
        for (var e = !1, a = xn; a !== null; ) {
          if (t !== 0) {
            var u = a.pendingLanes;
            if (u === 0) var n = 0;
            else {
              var i = a.suspendedLanes, c = a.pingedLanes;
              n = (1 << 31 - sl(42 | t) + 1) - 1, n &= u & ~(i & ~c), n = n & 201326741 ? n & 201326741 | 1 : n ? n | 2 : 0;
            }
            n !== 0 && (e = !0, $1(a, n));
          } else
            n = F, n = Vu(
              a,
              a === vt ? n : 0,
              a.cancelPendingCommit !== null || a.timeoutHandle !== -1
            ), (n & 3) === 0 || Va(a, n) || (e = !0, $1(a, n));
          a = a.next;
        }
      while (e);
      Ic = !1;
    }
  }
  function Z2() {
    J1();
  }
  function J1() {
    Qn = Fc = !1;
    var t = 0;
    Oe !== 0 && th() && (t = Oe);
    for (var l = cl(), e = null, a = xn; a !== null; ) {
      var u = a.next, n = k1(a, l);
      n === 0 ? (a.next = null, e === null ? xn = u : e.next = u, u === null && (Ya = e)) : (e = a, (t !== 0 || (n & 3) !== 0) && (Qn = !0)), a = u;
    }
    Yt !== 0 && Yt !== 5 || zu(t), Oe !== 0 && (Oe = 0);
  }
  function k1(t, l) {
    for (var e = t.suspendedLanes, a = t.pingedLanes, u = t.expirationTimes, n = t.pendingLanes & -62914561; 0 < n; ) {
      var i = 31 - sl(n), c = 1 << i, r = u[i];
      r === -1 ? ((c & e) === 0 || (c & a) !== 0) && (u[i] = vr(c, l)) : r <= l && (t.expiredLanes |= c), n &= ~c;
    }
    if (l = vt, e = F, e = Vu(
      t,
      t === l ? e : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a = t.callbackNode, e === 0 || t === l && (ot === 2 || ot === 9) || t.cancelPendingCommit !== null)
      return a !== null && a !== null && oi(a), t.callbackNode = null, t.callbackPriority = 0;
    if ((e & 3) === 0 || Va(t, e)) {
      if (l = e & -e, l === t.callbackPriority) return l;
      switch (a !== null && oi(a), di(e)) {
        case 2:
        case 8:
          e = q0;
          break;
        case 32:
          e = xu;
          break;
        case 268435456:
          e = B0;
          break;
        default:
          e = xu;
      }
      return a = W1.bind(null, t), e = si(e, a), t.callbackPriority = l, t.callbackNode = e, l;
    }
    return a !== null && a !== null && oi(a), t.callbackPriority = 2, t.callbackNode = null, 2;
  }
  function W1(t, l) {
    if (Yt !== 0 && Yt !== 5)
      return t.callbackNode = null, t.callbackPriority = 0, null;
    var e = t.callbackNode;
    if (Xn() && t.callbackNode !== e)
      return null;
    var a = F;
    return a = Vu(
      t,
      t === vt ? a : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a === 0 ? null : (U1(t, a, l), k1(t, cl()), t.callbackNode != null && t.callbackNode === e ? W1.bind(null, t) : null);
  }
  function $1(t, l) {
    if (Xn()) return null;
    U1(t, l, !0);
  }
  function V2() {
    eh(function() {
      (ft & 6) !== 0 ? si(
        j0,
        Z2
      ) : J1();
    });
  }
  function Pc() {
    if (Oe === 0) {
      var t = ba;
      t === 0 && (t = Qu, Qu <<= 1, (Qu & 261888) === 0 && (Qu = 256)), Oe = t;
    }
    return Oe;
  }
  function F1(t) {
    return t == null || typeof t == "symbol" || typeof t == "boolean" ? null : typeof t == "function" ? t : ku("" + t);
  }
  function I1(t, l) {
    var e = l.ownerDocument.createElement("input");
    return e.name = l.name, e.value = l.value, t.id && e.setAttribute("form", t.id), l.parentNode.insertBefore(e, l), t = new FormData(t), e.parentNode.removeChild(e), t;
  }
  function w2(t, l, e, a, u) {
    if (l === "submit" && e && e.stateNode === u) {
      var n = F1(
        (u[Pt] || null).action
      ), i = a.submitter;
      i && (l = (l = i[Pt] || null) ? F1(l.formAction) : i.getAttribute("formAction"), l !== null && (n = l, i = null));
      var c = new Iu(
        "action",
        "action",
        null,
        a,
        u
      );
      t.push({
        event: c,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (a.defaultPrevented) {
                if (Oe !== 0) {
                  var r = i ? I1(u, i) : new FormData(u);
                  Sc(
                    e,
                    {
                      pending: !0,
                      data: r,
                      method: u.method,
                      action: n
                    },
                    null,
                    r
                  );
                }
              } else
                typeof n == "function" && (c.preventDefault(), r = i ? I1(u, i) : new FormData(u), Sc(
                  e,
                  {
                    pending: !0,
                    data: r,
                    method: u.method,
                    action: n
                  },
                  n,
                  r
                ));
            },
            currentTarget: u
          }
        ]
      });
    }
  }
  for (var t0 = 0; t0 < ji.length; t0++) {
    var l0 = ji[t0], K2 = l0.toLowerCase(), J2 = l0[0].toUpperCase() + l0.slice(1);
    Dl(
      K2,
      "on" + J2
    );
  }
  Dl(Nf, "onAnimationEnd"), Dl(Uf, "onAnimationIteration"), Dl(Rf, "onAnimationStart"), Dl("dblclick", "onDoubleClick"), Dl("focusin", "onFocus"), Dl("focusout", "onBlur"), Dl(s2, "onTransitionRun"), Dl(o2, "onTransitionStart"), Dl(r2, "onTransitionCancel"), Dl(Cf, "onTransitionEnd"), ia("onMouseEnter", ["mouseout", "mouseover"]), ia("onMouseLeave", ["mouseout", "mouseover"]), ia("onPointerEnter", ["pointerout", "pointerover"]), ia("onPointerLeave", ["pointerout", "pointerover"]), je(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), je(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), je("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), je(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), je(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), je(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Mu = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), k2 = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Mu)
  );
  function P1(t, l) {
    l = (l & 4) !== 0;
    for (var e = 0; e < t.length; e++) {
      var a = t[e], u = a.event;
      a = a.listeners;
      t: {
        var n = void 0;
        if (l)
          for (var i = a.length - 1; 0 <= i; i--) {
            var c = a[i], r = c.instance, g = c.currentTarget;
            if (c = c.listener, r !== n && u.isPropagationStopped())
              break t;
            n = c, u.currentTarget = g;
            try {
              n(u);
            } catch (E) {
              ln(E);
            }
            u.currentTarget = null, n = r;
          }
        else
          for (i = 0; i < a.length; i++) {
            if (c = a[i], r = c.instance, g = c.currentTarget, c = c.listener, r !== n && u.isPropagationStopped())
              break t;
            n = c, u.currentTarget = g;
            try {
              n(u);
            } catch (E) {
              ln(E);
            }
            u.currentTarget = null, n = r;
          }
      }
    }
  }
  function $(t, l) {
    var e = l[yi];
    e === void 0 && (e = l[yi] = /* @__PURE__ */ new Set());
    var a = t + "__bubble";
    e.has(a) || (to(l, t, 2, !1), e.add(a));
  }
  function e0(t, l, e) {
    var a = 0;
    l && (a |= 4), to(
      e,
      t,
      a,
      l
    );
  }
  var Ln = "_reactListening" + Math.random().toString(36).slice(2);
  function a0(t) {
    if (!t[Ln]) {
      t[Ln] = !0, K0.forEach(function(e) {
        e !== "selectionchange" && (k2.has(e) || e0(e, !1, t), e0(e, !0, t));
      });
      var l = t.nodeType === 9 ? t : t.ownerDocument;
      l === null || l[Ln] || (l[Ln] = !0, e0("selectionchange", !1, l));
    }
  }
  function to(t, l, e, a) {
    switch (Uo(l)) {
      case 2:
        var u = Ah;
        break;
      case 8:
        u = _h;
        break;
      default:
        u = p0;
    }
    e = u.bind(
      null,
      l,
      e,
      t
    ), u = void 0, !_i || l !== "touchstart" && l !== "touchmove" && l !== "wheel" || (u = !0), a ? u !== void 0 ? t.addEventListener(l, e, {
      capture: !0,
      passive: u
    }) : t.addEventListener(l, e, !0) : u !== void 0 ? t.addEventListener(l, e, {
      passive: u
    }) : t.addEventListener(l, e, !1);
  }
  function u0(t, l, e, a, u) {
    var n = a;
    if ((l & 1) === 0 && (l & 2) === 0 && a !== null)
      t: for (; ; ) {
        if (a === null) return;
        var i = a.tag;
        if (i === 3 || i === 4) {
          var c = a.stateNode.containerInfo;
          if (c === u) break;
          if (i === 4)
            for (i = a.return; i !== null; ) {
              var r = i.tag;
              if ((r === 3 || r === 4) && i.stateNode.containerInfo === u)
                return;
              i = i.return;
            }
          for (; c !== null; ) {
            if (i = aa(c), i === null) return;
            if (r = i.tag, r === 5 || r === 6 || r === 26 || r === 27) {
              a = n = i;
              continue t;
            }
            c = c.parentNode;
          }
        }
        a = a.return;
      }
    uf(function() {
      var g = n, E = Ei(e), z = [];
      t: {
        var p = Gf.get(t);
        if (p !== void 0) {
          var b = Iu, j = t;
          switch (t) {
            case "keypress":
              if ($u(e) === 0) break t;
            case "keydown":
            case "keyup":
              b = Qr;
              break;
            case "focusin":
              j = "focus", b = Oi;
              break;
            case "focusout":
              j = "blur", b = Oi;
              break;
            case "beforeblur":
            case "afterblur":
              b = Oi;
              break;
            case "click":
              if (e.button === 2) break t;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              b = ff;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              b = Nr;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              b = Vr;
              break;
            case Nf:
            case Uf:
            case Rf:
              b = Cr;
              break;
            case Cf:
              b = Kr;
              break;
            case "scroll":
            case "scrollend":
              b = Or;
              break;
            case "wheel":
              b = kr;
              break;
            case "copy":
            case "cut":
            case "paste":
              b = Hr;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              b = of;
              break;
            case "toggle":
            case "beforetoggle":
              b = $r;
          }
          var L = (l & 4) !== 0, yt = !L && (t === "scroll" || t === "scrollend"), y = L ? p !== null ? p + "Capture" : null : p;
          L = [];
          for (var h = g, v; h !== null; ) {
            var T = h;
            if (v = T.stateNode, T = T.tag, T !== 5 && T !== 26 && T !== 27 || v === null || y === null || (T = ka(h, y), T != null && L.push(
              Ou(h, T, v)
            )), yt) break;
            h = h.return;
          }
          0 < L.length && (p = new b(
            p,
            j,
            null,
            e,
            E
          ), z.push({ event: p, listeners: L }));
        }
      }
      if ((l & 7) === 0) {
        t: {
          if (p = t === "mouseover" || t === "pointerover", b = t === "mouseout" || t === "pointerout", p && e !== bi && (j = e.relatedTarget || e.fromElement) && (aa(j) || j[ea]))
            break t;
          if ((b || p) && (p = E.window === E ? E : (p = E.ownerDocument) ? p.defaultView || p.parentWindow : window, b ? (j = e.relatedTarget || e.toElement, b = g, j = j ? aa(j) : null, j !== null && (yt = N(j), L = j.tag, j !== yt || L !== 5 && L !== 27 && L !== 6) && (j = null)) : (b = null, j = g), b !== j)) {
            if (L = ff, T = "onMouseLeave", y = "onMouseEnter", h = "mouse", (t === "pointerout" || t === "pointerover") && (L = of, T = "onPointerLeave", y = "onPointerEnter", h = "pointer"), yt = b == null ? p : Ja(b), v = j == null ? p : Ja(j), p = new L(
              T,
              h + "leave",
              b,
              e,
              E
            ), p.target = yt, p.relatedTarget = v, T = null, aa(E) === g && (L = new L(
              y,
              h + "enter",
              j,
              e,
              E
            ), L.target = v, L.relatedTarget = yt, T = L), yt = T, b && j)
              l: {
                for (L = W2, y = b, h = j, v = 0, T = y; T; T = L(T))
                  v++;
                T = 0;
                for (var x = h; x; x = L(x))
                  T++;
                for (; 0 < v - T; )
                  y = L(y), v--;
                for (; 0 < T - v; )
                  h = L(h), T--;
                for (; v--; ) {
                  if (y === h || h !== null && y === h.alternate) {
                    L = y;
                    break l;
                  }
                  y = L(y), h = L(h);
                }
                L = null;
              }
            else L = null;
            b !== null && lo(
              z,
              p,
              b,
              L,
              !1
            ), j !== null && yt !== null && lo(
              z,
              yt,
              j,
              L,
              !0
            );
          }
        }
        t: {
          if (p = g ? Ja(g) : window, b = p.nodeName && p.nodeName.toLowerCase(), b === "select" || b === "input" && p.type === "file")
            var nt = pf;
          else if (vf(p))
            if (Sf)
              nt = i2;
            else {
              nt = u2;
              var q = a2;
            }
          else
            b = p.nodeName, !b || b.toLowerCase() !== "input" || p.type !== "checkbox" && p.type !== "radio" ? g && Si(g.elementType) && (nt = pf) : nt = n2;
          if (nt && (nt = nt(t, g))) {
            gf(
              z,
              nt,
              e,
              E
            );
            break t;
          }
          q && q(t, p, g), t === "focusout" && g && p.type === "number" && g.memoizedProps.value != null && pi(p, "number", p.value);
        }
        switch (q = g ? Ja(g) : window, t) {
          case "focusin":
            (vf(q) || q.contentEditable === "true") && (ha = q, Gi = g, eu = null);
            break;
          case "focusout":
            eu = Gi = ha = null;
            break;
          case "mousedown":
            Hi = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Hi = !1, Of(z, e, E);
            break;
          case "selectionchange":
            if (f2) break;
          case "keydown":
          case "keyup":
            Of(z, e, E);
        }
        var k;
        if (Ni)
          t: {
            switch (t) {
              case "compositionstart":
                var I = "onCompositionStart";
                break t;
              case "compositionend":
                I = "onCompositionEnd";
                break t;
              case "compositionupdate":
                I = "onCompositionUpdate";
                break t;
            }
            I = void 0;
          }
        else
          ra ? yf(t, e) && (I = "onCompositionEnd") : t === "keydown" && e.keyCode === 229 && (I = "onCompositionStart");
        I && (rf && e.locale !== "ko" && (ra || I !== "onCompositionStart" ? I === "onCompositionEnd" && ra && (k = nf()) : (re = E, Ti = "value" in re ? re.value : re.textContent, ra = !0)), q = Zn(g, I), 0 < q.length && (I = new sf(
          I,
          t,
          null,
          e,
          E
        ), z.push({ event: I, listeners: q }), k ? I.data = k : (k = mf(e), k !== null && (I.data = k)))), (k = Ir ? Pr(t, e) : t2(t, e)) && (I = Zn(g, "onBeforeInput"), 0 < I.length && (q = new sf(
          "onBeforeInput",
          "beforeinput",
          null,
          e,
          E
        ), z.push({
          event: q,
          listeners: I
        }), q.data = k)), w2(
          z,
          t,
          g,
          e,
          E
        );
      }
      P1(z, l);
    });
  }
  function Ou(t, l, e) {
    return {
      instance: t,
      listener: l,
      currentTarget: e
    };
  }
  function Zn(t, l) {
    for (var e = l + "Capture", a = []; t !== null; ) {
      var u = t, n = u.stateNode;
      if (u = u.tag, u !== 5 && u !== 26 && u !== 27 || n === null || (u = ka(t, e), u != null && a.unshift(
        Ou(t, u, n)
      ), u = ka(t, l), u != null && a.push(
        Ou(t, u, n)
      )), t.tag === 3) return a;
      t = t.return;
    }
    return [];
  }
  function W2(t) {
    if (t === null) return null;
    do
      t = t.return;
    while (t && t.tag !== 5 && t.tag !== 27);
    return t || null;
  }
  function lo(t, l, e, a, u) {
    for (var n = l._reactName, i = []; e !== null && e !== a; ) {
      var c = e, r = c.alternate, g = c.stateNode;
      if (c = c.tag, r !== null && r === a) break;
      c !== 5 && c !== 26 && c !== 27 || g === null || (r = g, u ? (g = ka(e, n), g != null && i.unshift(
        Ou(e, g, r)
      )) : u || (g = ka(e, n), g != null && i.push(
        Ou(e, g, r)
      ))), e = e.return;
    }
    i.length !== 0 && t.push({ event: l, listeners: i });
  }
  var $2 = /\r\n?/g, F2 = /\u0000|\uFFFD/g;
  function eo(t) {
    return (typeof t == "string" ? t : "" + t).replace($2, `
`).replace(F2, "");
  }
  function ao(t, l) {
    return l = eo(l), eo(t) === l;
  }
  function dt(t, l, e, a, u, n) {
    switch (e) {
      case "children":
        typeof a == "string" ? l === "body" || l === "textarea" && a === "" || fa(t, a) : (typeof a == "number" || typeof a == "bigint") && l !== "body" && fa(t, "" + a);
        break;
      case "className":
        Ku(t, "class", a);
        break;
      case "tabIndex":
        Ku(t, "tabindex", a);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Ku(t, e, a);
        break;
      case "style":
        ef(t, a, n);
        break;
      case "data":
        if (l !== "object") {
          Ku(t, "data", a);
          break;
        }
      case "src":
      case "href":
        if (a === "" && (l !== "a" || e !== "href")) {
          t.removeAttribute(e);
          break;
        }
        if (a == null || typeof a == "function" || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(e);
          break;
        }
        a = ku("" + a), t.setAttribute(e, a);
        break;
      case "action":
      case "formAction":
        if (typeof a == "function") {
          t.setAttribute(
            e,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof n == "function" && (e === "formAction" ? (l !== "input" && dt(t, l, "name", u.name, u, null), dt(
            t,
            l,
            "formEncType",
            u.formEncType,
            u,
            null
          ), dt(
            t,
            l,
            "formMethod",
            u.formMethod,
            u,
            null
          ), dt(
            t,
            l,
            "formTarget",
            u.formTarget,
            u,
            null
          )) : (dt(t, l, "encType", u.encType, u, null), dt(t, l, "method", u.method, u, null), dt(t, l, "target", u.target, u, null)));
        if (a == null || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(e);
          break;
        }
        a = ku("" + a), t.setAttribute(e, a);
        break;
      case "onClick":
        a != null && (t.onclick = Zl);
        break;
      case "onScroll":
        a != null && $("scroll", t);
        break;
      case "onScrollEnd":
        a != null && $("scrollend", t);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(s(61));
          if (e = a.__html, e != null) {
            if (u.children != null) throw Error(s(60));
            t.innerHTML = e;
          }
        }
        break;
      case "multiple":
        t.multiple = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "muted":
        t.muted = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (a == null || typeof a == "function" || typeof a == "boolean" || typeof a == "symbol") {
          t.removeAttribute("xlink:href");
          break;
        }
        e = ku("" + a), t.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          e
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(e, "" + a) : t.removeAttribute(e);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        a && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(e, "") : t.removeAttribute(e);
        break;
      case "capture":
      case "download":
        a === !0 ? t.setAttribute(e, "") : a !== !1 && a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(e, a) : t.removeAttribute(e);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        a != null && typeof a != "function" && typeof a != "symbol" && !isNaN(a) && 1 <= a ? t.setAttribute(e, a) : t.removeAttribute(e);
        break;
      case "rowSpan":
      case "start":
        a == null || typeof a == "function" || typeof a == "symbol" || isNaN(a) ? t.removeAttribute(e) : t.setAttribute(e, a);
        break;
      case "popover":
        $("beforetoggle", t), $("toggle", t), wu(t, "popover", a);
        break;
      case "xlinkActuate":
        Ll(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          a
        );
        break;
      case "xlinkArcrole":
        Ll(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          a
        );
        break;
      case "xlinkRole":
        Ll(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          a
        );
        break;
      case "xlinkShow":
        Ll(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          a
        );
        break;
      case "xlinkTitle":
        Ll(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          a
        );
        break;
      case "xlinkType":
        Ll(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          a
        );
        break;
      case "xmlBase":
        Ll(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          a
        );
        break;
      case "xmlLang":
        Ll(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          a
        );
        break;
      case "xmlSpace":
        Ll(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          a
        );
        break;
      case "is":
        wu(t, "is", a);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < e.length) || e[0] !== "o" && e[0] !== "O" || e[1] !== "n" && e[1] !== "N") && (e = zr.get(e) || e, wu(t, e, a));
    }
  }
  function n0(t, l, e, a, u, n) {
    switch (e) {
      case "style":
        ef(t, a, n);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(s(61));
          if (e = a.__html, e != null) {
            if (u.children != null) throw Error(s(60));
            t.innerHTML = e;
          }
        }
        break;
      case "children":
        typeof a == "string" ? fa(t, a) : (typeof a == "number" || typeof a == "bigint") && fa(t, "" + a);
        break;
      case "onScroll":
        a != null && $("scroll", t);
        break;
      case "onScrollEnd":
        a != null && $("scrollend", t);
        break;
      case "onClick":
        a != null && (t.onclick = Zl);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!J0.hasOwnProperty(e))
          t: {
            if (e[0] === "o" && e[1] === "n" && (u = e.endsWith("Capture"), l = e.slice(2, u ? e.length - 7 : void 0), n = t[Pt] || null, n = n != null ? n[e] : null, typeof n == "function" && t.removeEventListener(l, n, u), typeof a == "function")) {
              typeof n != "function" && n !== null && (e in t ? t[e] = null : t.hasAttribute(e) && t.removeAttribute(e)), t.addEventListener(l, a, u);
              break t;
            }
            e in t ? t[e] = a : a === !0 ? t.setAttribute(e, "") : wu(t, e, a);
          }
    }
  }
  function Kt(t, l, e) {
    switch (l) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        $("error", t), $("load", t);
        var a = !1, u = !1, n;
        for (n in e)
          if (e.hasOwnProperty(n)) {
            var i = e[n];
            if (i != null)
              switch (n) {
                case "src":
                  a = !0;
                  break;
                case "srcSet":
                  u = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(s(137, l));
                default:
                  dt(t, l, n, i, e, null);
              }
          }
        u && dt(t, l, "srcSet", e.srcSet, e, null), a && dt(t, l, "src", e.src, e, null);
        return;
      case "input":
        $("invalid", t);
        var c = n = i = u = null, r = null, g = null;
        for (a in e)
          if (e.hasOwnProperty(a)) {
            var E = e[a];
            if (E != null)
              switch (a) {
                case "name":
                  u = E;
                  break;
                case "type":
                  i = E;
                  break;
                case "checked":
                  r = E;
                  break;
                case "defaultChecked":
                  g = E;
                  break;
                case "value":
                  n = E;
                  break;
                case "defaultValue":
                  c = E;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (E != null)
                    throw Error(s(137, l));
                  break;
                default:
                  dt(t, l, a, E, e, null);
              }
          }
        I0(
          t,
          n,
          c,
          r,
          g,
          i,
          u,
          !1
        );
        return;
      case "select":
        $("invalid", t), a = i = n = null;
        for (u in e)
          if (e.hasOwnProperty(u) && (c = e[u], c != null))
            switch (u) {
              case "value":
                n = c;
                break;
              case "defaultValue":
                i = c;
                break;
              case "multiple":
                a = c;
              default:
                dt(t, l, u, c, e, null);
            }
        l = n, e = i, t.multiple = !!a, l != null ? ca(t, !!a, l, !1) : e != null && ca(t, !!a, e, !0);
        return;
      case "textarea":
        $("invalid", t), n = u = a = null;
        for (i in e)
          if (e.hasOwnProperty(i) && (c = e[i], c != null))
            switch (i) {
              case "value":
                a = c;
                break;
              case "defaultValue":
                u = c;
                break;
              case "children":
                n = c;
                break;
              case "dangerouslySetInnerHTML":
                if (c != null) throw Error(s(91));
                break;
              default:
                dt(t, l, i, c, e, null);
            }
        tf(t, a, u, n);
        return;
      case "option":
        for (r in e)
          if (e.hasOwnProperty(r) && (a = e[r], a != null))
            switch (r) {
              case "selected":
                t.selected = a && typeof a != "function" && typeof a != "symbol";
                break;
              default:
                dt(t, l, r, a, e, null);
            }
        return;
      case "dialog":
        $("beforetoggle", t), $("toggle", t), $("cancel", t), $("close", t);
        break;
      case "iframe":
      case "object":
        $("load", t);
        break;
      case "video":
      case "audio":
        for (a = 0; a < Mu.length; a++)
          $(Mu[a], t);
        break;
      case "image":
        $("error", t), $("load", t);
        break;
      case "details":
        $("toggle", t);
        break;
      case "embed":
      case "source":
      case "link":
        $("error", t), $("load", t);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (g in e)
          if (e.hasOwnProperty(g) && (a = e[g], a != null))
            switch (g) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(s(137, l));
              default:
                dt(t, l, g, a, e, null);
            }
        return;
      default:
        if (Si(l)) {
          for (E in e)
            e.hasOwnProperty(E) && (a = e[E], a !== void 0 && n0(
              t,
              l,
              E,
              a,
              e,
              void 0
            ));
          return;
        }
    }
    for (c in e)
      e.hasOwnProperty(c) && (a = e[c], a != null && dt(t, l, c, a, e, null));
  }
  function I2(t, l, e, a) {
    switch (l) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var u = null, n = null, i = null, c = null, r = null, g = null, E = null;
        for (b in e) {
          var z = e[b];
          if (e.hasOwnProperty(b) && z != null)
            switch (b) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                r = z;
              default:
                a.hasOwnProperty(b) || dt(t, l, b, null, a, z);
            }
        }
        for (var p in a) {
          var b = a[p];
          if (z = e[p], a.hasOwnProperty(p) && (b != null || z != null))
            switch (p) {
              case "type":
                n = b;
                break;
              case "name":
                u = b;
                break;
              case "checked":
                g = b;
                break;
              case "defaultChecked":
                E = b;
                break;
              case "value":
                i = b;
                break;
              case "defaultValue":
                c = b;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (b != null)
                  throw Error(s(137, l));
                break;
              default:
                b !== z && dt(
                  t,
                  l,
                  p,
                  b,
                  a,
                  z
                );
            }
        }
        gi(
          t,
          i,
          c,
          r,
          g,
          E,
          n,
          u
        );
        return;
      case "select":
        b = i = c = p = null;
        for (n in e)
          if (r = e[n], e.hasOwnProperty(n) && r != null)
            switch (n) {
              case "value":
                break;
              case "multiple":
                b = r;
              default:
                a.hasOwnProperty(n) || dt(
                  t,
                  l,
                  n,
                  null,
                  a,
                  r
                );
            }
        for (u in a)
          if (n = a[u], r = e[u], a.hasOwnProperty(u) && (n != null || r != null))
            switch (u) {
              case "value":
                p = n;
                break;
              case "defaultValue":
                c = n;
                break;
              case "multiple":
                i = n;
              default:
                n !== r && dt(
                  t,
                  l,
                  u,
                  n,
                  a,
                  r
                );
            }
        l = c, e = i, a = b, p != null ? ca(t, !!e, p, !1) : !!a != !!e && (l != null ? ca(t, !!e, l, !0) : ca(t, !!e, e ? [] : "", !1));
        return;
      case "textarea":
        b = p = null;
        for (c in e)
          if (u = e[c], e.hasOwnProperty(c) && u != null && !a.hasOwnProperty(c))
            switch (c) {
              case "value":
                break;
              case "children":
                break;
              default:
                dt(t, l, c, null, a, u);
            }
        for (i in a)
          if (u = a[i], n = e[i], a.hasOwnProperty(i) && (u != null || n != null))
            switch (i) {
              case "value":
                p = u;
                break;
              case "defaultValue":
                b = u;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (u != null) throw Error(s(91));
                break;
              default:
                u !== n && dt(t, l, i, u, a, n);
            }
        P0(t, p, b);
        return;
      case "option":
        for (var j in e)
          if (p = e[j], e.hasOwnProperty(j) && p != null && !a.hasOwnProperty(j))
            switch (j) {
              case "selected":
                t.selected = !1;
                break;
              default:
                dt(
                  t,
                  l,
                  j,
                  null,
                  a,
                  p
                );
            }
        for (r in a)
          if (p = a[r], b = e[r], a.hasOwnProperty(r) && p !== b && (p != null || b != null))
            switch (r) {
              case "selected":
                t.selected = p && typeof p != "function" && typeof p != "symbol";
                break;
              default:
                dt(
                  t,
                  l,
                  r,
                  p,
                  a,
                  b
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var L in e)
          p = e[L], e.hasOwnProperty(L) && p != null && !a.hasOwnProperty(L) && dt(t, l, L, null, a, p);
        for (g in a)
          if (p = a[g], b = e[g], a.hasOwnProperty(g) && p !== b && (p != null || b != null))
            switch (g) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (p != null)
                  throw Error(s(137, l));
                break;
              default:
                dt(
                  t,
                  l,
                  g,
                  p,
                  a,
                  b
                );
            }
        return;
      default:
        if (Si(l)) {
          for (var yt in e)
            p = e[yt], e.hasOwnProperty(yt) && p !== void 0 && !a.hasOwnProperty(yt) && n0(
              t,
              l,
              yt,
              void 0,
              a,
              p
            );
          for (E in a)
            p = a[E], b = e[E], !a.hasOwnProperty(E) || p === b || p === void 0 && b === void 0 || n0(
              t,
              l,
              E,
              p,
              a,
              b
            );
          return;
        }
    }
    for (var y in e)
      p = e[y], e.hasOwnProperty(y) && p != null && !a.hasOwnProperty(y) && dt(t, l, y, null, a, p);
    for (z in a)
      p = a[z], b = e[z], !a.hasOwnProperty(z) || p === b || p == null && b == null || dt(t, l, z, p, a, b);
  }
  function uo(t) {
    switch (t) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function P2() {
    if (typeof performance.getEntriesByType == "function") {
      for (var t = 0, l = 0, e = performance.getEntriesByType("resource"), a = 0; a < e.length; a++) {
        var u = e[a], n = u.transferSize, i = u.initiatorType, c = u.duration;
        if (n && c && uo(i)) {
          for (i = 0, c = u.responseEnd, a += 1; a < e.length; a++) {
            var r = e[a], g = r.startTime;
            if (g > c) break;
            var E = r.transferSize, z = r.initiatorType;
            E && uo(z) && (r = r.responseEnd, i += E * (r < c ? 1 : (c - g) / (r - g)));
          }
          if (--a, l += 8 * (n + i) / (u.duration / 1e3), t++, 10 < t) break;
        }
      }
      if (0 < t) return l / t / 1e6;
    }
    return navigator.connection && (t = navigator.connection.downlink, typeof t == "number") ? t : 5;
  }
  var i0 = null, c0 = null;
  function Vn(t) {
    return t.nodeType === 9 ? t : t.ownerDocument;
  }
  function no(t) {
    switch (t) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function io(t, l) {
    if (t === 0)
      switch (l) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return t === 1 && l === "foreignObject" ? 0 : t;
  }
  function f0(t, l) {
    return t === "textarea" || t === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.children == "bigint" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
  }
  var s0 = null;
  function th() {
    var t = window.event;
    return t && t.type === "popstate" ? t === s0 ? !1 : (s0 = t, !0) : (s0 = null, !1);
  }
  var co = typeof setTimeout == "function" ? setTimeout : void 0, lh = typeof clearTimeout == "function" ? clearTimeout : void 0, fo = typeof Promise == "function" ? Promise : void 0, eh = typeof queueMicrotask == "function" ? queueMicrotask : typeof fo < "u" ? function(t) {
    return fo.resolve(null).then(t).catch(ah);
  } : co;
  function ah(t) {
    setTimeout(function() {
      throw t;
    });
  }
  function De(t) {
    return t === "head";
  }
  function so(t, l) {
    var e = l, a = 0;
    do {
      var u = e.nextSibling;
      if (t.removeChild(e), u && u.nodeType === 8)
        if (e = u.data, e === "/$" || e === "/&") {
          if (a === 0) {
            t.removeChild(u), Xa(l);
            return;
          }
          a--;
        } else if (e === "$" || e === "$?" || e === "$~" || e === "$!" || e === "&")
          a++;
        else if (e === "html")
          Du(t.ownerDocument.documentElement);
        else if (e === "head") {
          e = t.ownerDocument.head, Du(e);
          for (var n = e.firstChild; n; ) {
            var i = n.nextSibling, c = n.nodeName;
            n[Ka] || c === "SCRIPT" || c === "STYLE" || c === "LINK" && n.rel.toLowerCase() === "stylesheet" || e.removeChild(n), n = i;
          }
        } else
          e === "body" && Du(t.ownerDocument.body);
      e = u;
    } while (e);
    Xa(l);
  }
  function oo(t, l) {
    var e = t;
    t = 0;
    do {
      var a = e.nextSibling;
      if (e.nodeType === 1 ? l ? (e._stashedDisplay = e.style.display, e.style.display = "none") : (e.style.display = e._stashedDisplay || "", e.getAttribute("style") === "" && e.removeAttribute("style")) : e.nodeType === 3 && (l ? (e._stashedText = e.nodeValue, e.nodeValue = "") : e.nodeValue = e._stashedText || ""), a && a.nodeType === 8)
        if (e = a.data, e === "/$") {
          if (t === 0) break;
          t--;
        } else
          e !== "$" && e !== "$?" && e !== "$~" && e !== "$!" || t++;
      e = a;
    } while (e);
  }
  function o0(t) {
    var l = t.firstChild;
    for (l && l.nodeType === 10 && (l = l.nextSibling); l; ) {
      var e = l;
      switch (l = l.nextSibling, e.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          o0(e), mi(e);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (e.rel.toLowerCase() === "stylesheet") continue;
      }
      t.removeChild(e);
    }
  }
  function uh(t, l, e, a) {
    for (; t.nodeType === 1; ) {
      var u = e;
      if (t.nodeName.toLowerCase() !== l.toLowerCase()) {
        if (!a && (t.nodeName !== "INPUT" || t.type !== "hidden"))
          break;
      } else if (a) {
        if (!t[Ka])
          switch (l) {
            case "meta":
              if (!t.hasAttribute("itemprop")) break;
              return t;
            case "link":
              if (n = t.getAttribute("rel"), n === "stylesheet" && t.hasAttribute("data-precedence"))
                break;
              if (n !== u.rel || t.getAttribute("href") !== (u.href == null || u.href === "" ? null : u.href) || t.getAttribute("crossorigin") !== (u.crossOrigin == null ? null : u.crossOrigin) || t.getAttribute("title") !== (u.title == null ? null : u.title))
                break;
              return t;
            case "style":
              if (t.hasAttribute("data-precedence")) break;
              return t;
            case "script":
              if (n = t.getAttribute("src"), (n !== (u.src == null ? null : u.src) || t.getAttribute("type") !== (u.type == null ? null : u.type) || t.getAttribute("crossorigin") !== (u.crossOrigin == null ? null : u.crossOrigin)) && n && t.hasAttribute("async") && !t.hasAttribute("itemprop"))
                break;
              return t;
            default:
              return t;
          }
      } else if (l === "input" && t.type === "hidden") {
        var n = u.name == null ? null : "" + u.name;
        if (u.type === "hidden" && t.getAttribute("name") === n)
          return t;
      } else return t;
      if (t = zl(t.nextSibling), t === null) break;
    }
    return null;
  }
  function nh(t, l, e) {
    if (l === "") return null;
    for (; t.nodeType !== 3; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !e || (t = zl(t.nextSibling), t === null)) return null;
    return t;
  }
  function ro(t, l) {
    for (; t.nodeType !== 8; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !l || (t = zl(t.nextSibling), t === null)) return null;
    return t;
  }
  function r0(t) {
    return t.data === "$?" || t.data === "$~";
  }
  function h0(t) {
    return t.data === "$!" || t.data === "$?" && t.ownerDocument.readyState !== "loading";
  }
  function ih(t, l) {
    var e = t.ownerDocument;
    if (t.data === "$~") t._reactRetry = l;
    else if (t.data !== "$?" || e.readyState !== "loading")
      l();
    else {
      var a = function() {
        l(), e.removeEventListener("DOMContentLoaded", a);
      };
      e.addEventListener("DOMContentLoaded", a), t._reactRetry = a;
    }
  }
  function zl(t) {
    for (; t != null; t = t.nextSibling) {
      var l = t.nodeType;
      if (l === 1 || l === 3) break;
      if (l === 8) {
        if (l = t.data, l === "$" || l === "$!" || l === "$?" || l === "$~" || l === "&" || l === "F!" || l === "F")
          break;
        if (l === "/$" || l === "/&") return null;
      }
    }
    return t;
  }
  var d0 = null;
  function ho(t) {
    t = t.nextSibling;
    for (var l = 0; t; ) {
      if (t.nodeType === 8) {
        var e = t.data;
        if (e === "/$" || e === "/&") {
          if (l === 0)
            return zl(t.nextSibling);
          l--;
        } else
          e !== "$" && e !== "$!" && e !== "$?" && e !== "$~" && e !== "&" || l++;
      }
      t = t.nextSibling;
    }
    return null;
  }
  function yo(t) {
    t = t.previousSibling;
    for (var l = 0; t; ) {
      if (t.nodeType === 8) {
        var e = t.data;
        if (e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&") {
          if (l === 0) return t;
          l--;
        } else e !== "/$" && e !== "/&" || l++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function mo(t, l, e) {
    switch (l = Vn(e), t) {
      case "html":
        if (t = l.documentElement, !t) throw Error(s(452));
        return t;
      case "head":
        if (t = l.head, !t) throw Error(s(453));
        return t;
      case "body":
        if (t = l.body, !t) throw Error(s(454));
        return t;
      default:
        throw Error(s(451));
    }
  }
  function Du(t) {
    for (var l = t.attributes; l.length; )
      t.removeAttributeNode(l[0]);
    mi(t);
  }
  var Ml = /* @__PURE__ */ new Map(), vo = /* @__PURE__ */ new Set();
  function wn(t) {
    return typeof t.getRootNode == "function" ? t.getRootNode() : t.nodeType === 9 ? t : t.ownerDocument;
  }
  var ne = G.d;
  G.d = {
    f: ch,
    r: fh,
    D: sh,
    C: oh,
    L: rh,
    m: hh,
    X: yh,
    S: dh,
    M: mh
  };
  function ch() {
    var t = ne.f(), l = jn();
    return t || l;
  }
  function fh(t) {
    var l = ua(t);
    l !== null && l.tag === 5 && l.type === "form" ? Cs(l) : ne.r(t);
  }
  var ja = typeof document > "u" ? null : document;
  function go(t, l, e) {
    var a = ja;
    if (a && typeof l == "string" && l) {
      var u = pl(l);
      u = 'link[rel="' + t + '"][href="' + u + '"]', typeof e == "string" && (u += '[crossorigin="' + e + '"]'), vo.has(u) || (vo.add(u), t = { rel: t, crossOrigin: e, href: l }, a.querySelector(u) === null && (l = a.createElement("link"), Kt(l, "link", t), Bt(l), a.head.appendChild(l)));
    }
  }
  function sh(t) {
    ne.D(t), go("dns-prefetch", t, null);
  }
  function oh(t, l) {
    ne.C(t, l), go("preconnect", t, l);
  }
  function rh(t, l, e) {
    ne.L(t, l, e);
    var a = ja;
    if (a && t && l) {
      var u = 'link[rel="preload"][as="' + pl(l) + '"]';
      l === "image" && e && e.imageSrcSet ? (u += '[imagesrcset="' + pl(
        e.imageSrcSet
      ) + '"]', typeof e.imageSizes == "string" && (u += '[imagesizes="' + pl(
        e.imageSizes
      ) + '"]')) : u += '[href="' + pl(t) + '"]';
      var n = u;
      switch (l) {
        case "style":
          n = qa(t);
          break;
        case "script":
          n = Ba(t);
      }
      Ml.has(n) || (t = D(
        {
          rel: "preload",
          href: l === "image" && e && e.imageSrcSet ? void 0 : t,
          as: l
        },
        e
      ), Ml.set(n, t), a.querySelector(u) !== null || l === "style" && a.querySelector(Nu(n)) || l === "script" && a.querySelector(Uu(n)) || (l = a.createElement("link"), Kt(l, "link", t), Bt(l), a.head.appendChild(l)));
    }
  }
  function hh(t, l) {
    ne.m(t, l);
    var e = ja;
    if (e && t) {
      var a = l && typeof l.as == "string" ? l.as : "script", u = 'link[rel="modulepreload"][as="' + pl(a) + '"][href="' + pl(t) + '"]', n = u;
      switch (a) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          n = Ba(t);
      }
      if (!Ml.has(n) && (t = D({ rel: "modulepreload", href: t }, l), Ml.set(n, t), e.querySelector(u) === null)) {
        switch (a) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (e.querySelector(Uu(n)))
              return;
        }
        a = e.createElement("link"), Kt(a, "link", t), Bt(a), e.head.appendChild(a);
      }
    }
  }
  function dh(t, l, e) {
    ne.S(t, l, e);
    var a = ja;
    if (a && t) {
      var u = na(a).hoistableStyles, n = qa(t);
      l = l || "default";
      var i = u.get(n);
      if (!i) {
        var c = { loading: 0, preload: null };
        if (i = a.querySelector(
          Nu(n)
        ))
          c.loading = 5;
        else {
          t = D(
            { rel: "stylesheet", href: t, "data-precedence": l },
            e
          ), (e = Ml.get(n)) && y0(t, e);
          var r = i = a.createElement("link");
          Bt(r), Kt(r, "link", t), r._p = new Promise(function(g, E) {
            r.onload = g, r.onerror = E;
          }), r.addEventListener("load", function() {
            c.loading |= 1;
          }), r.addEventListener("error", function() {
            c.loading |= 2;
          }), c.loading |= 4, Kn(i, l, a);
        }
        i = {
          type: "stylesheet",
          instance: i,
          count: 1,
          state: c
        }, u.set(n, i);
      }
    }
  }
  function yh(t, l) {
    ne.X(t, l);
    var e = ja;
    if (e && t) {
      var a = na(e).hoistableScripts, u = Ba(t), n = a.get(u);
      n || (n = e.querySelector(Uu(u)), n || (t = D({ src: t, async: !0 }, l), (l = Ml.get(u)) && m0(t, l), n = e.createElement("script"), Bt(n), Kt(n, "link", t), e.head.appendChild(n)), n = {
        type: "script",
        instance: n,
        count: 1,
        state: null
      }, a.set(u, n));
    }
  }
  function mh(t, l) {
    ne.M(t, l);
    var e = ja;
    if (e && t) {
      var a = na(e).hoistableScripts, u = Ba(t), n = a.get(u);
      n || (n = e.querySelector(Uu(u)), n || (t = D({ src: t, async: !0, type: "module" }, l), (l = Ml.get(u)) && m0(t, l), n = e.createElement("script"), Bt(n), Kt(n, "link", t), e.head.appendChild(n)), n = {
        type: "script",
        instance: n,
        count: 1,
        state: null
      }, a.set(u, n));
    }
  }
  function po(t, l, e, a) {
    var u = (u = K.current) ? wn(u) : null;
    if (!u) throw Error(s(446));
    switch (t) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof e.precedence == "string" && typeof e.href == "string" ? (l = qa(e.href), e = na(
          u
        ).hoistableStyles, a = e.get(l), a || (a = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, e.set(l, a)), a) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (e.rel === "stylesheet" && typeof e.href == "string" && typeof e.precedence == "string") {
          t = qa(e.href);
          var n = na(
            u
          ).hoistableStyles, i = n.get(t);
          if (i || (u = u.ownerDocument || u, i = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, n.set(t, i), (n = u.querySelector(
            Nu(t)
          )) && !n._p && (i.instance = n, i.state.loading = 5), Ml.has(t) || (e = {
            rel: "preload",
            as: "style",
            href: e.href,
            crossOrigin: e.crossOrigin,
            integrity: e.integrity,
            media: e.media,
            hrefLang: e.hrefLang,
            referrerPolicy: e.referrerPolicy
          }, Ml.set(t, e), n || vh(
            u,
            t,
            e,
            i.state
          ))), l && a === null)
            throw Error(s(528, ""));
          return i;
        }
        if (l && a !== null)
          throw Error(s(529, ""));
        return null;
      case "script":
        return l = e.async, e = e.src, typeof e == "string" && l && typeof l != "function" && typeof l != "symbol" ? (l = Ba(e), e = na(
          u
        ).hoistableScripts, a = e.get(l), a || (a = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, e.set(l, a)), a) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(s(444, t));
    }
  }
  function qa(t) {
    return 'href="' + pl(t) + '"';
  }
  function Nu(t) {
    return 'link[rel="stylesheet"][' + t + "]";
  }
  function So(t) {
    return D({}, t, {
      "data-precedence": t.precedence,
      precedence: null
    });
  }
  function vh(t, l, e, a) {
    t.querySelector('link[rel="preload"][as="style"][' + l + "]") ? a.loading = 1 : (l = t.createElement("link"), a.preload = l, l.addEventListener("load", function() {
      return a.loading |= 1;
    }), l.addEventListener("error", function() {
      return a.loading |= 2;
    }), Kt(l, "link", e), Bt(l), t.head.appendChild(l));
  }
  function Ba(t) {
    return '[src="' + pl(t) + '"]';
  }
  function Uu(t) {
    return "script[async]" + t;
  }
  function bo(t, l, e) {
    if (l.count++, l.instance === null)
      switch (l.type) {
        case "style":
          var a = t.querySelector(
            'style[data-href~="' + pl(e.href) + '"]'
          );
          if (a)
            return l.instance = a, Bt(a), a;
          var u = D({}, e, {
            "data-href": e.href,
            "data-precedence": e.precedence,
            href: null,
            precedence: null
          });
          return a = (t.ownerDocument || t).createElement(
            "style"
          ), Bt(a), Kt(a, "style", u), Kn(a, e.precedence, t), l.instance = a;
        case "stylesheet":
          u = qa(e.href);
          var n = t.querySelector(
            Nu(u)
          );
          if (n)
            return l.state.loading |= 4, l.instance = n, Bt(n), n;
          a = So(e), (u = Ml.get(u)) && y0(a, u), n = (t.ownerDocument || t).createElement("link"), Bt(n);
          var i = n;
          return i._p = new Promise(function(c, r) {
            i.onload = c, i.onerror = r;
          }), Kt(n, "link", a), l.state.loading |= 4, Kn(n, e.precedence, t), l.instance = n;
        case "script":
          return n = Ba(e.src), (u = t.querySelector(
            Uu(n)
          )) ? (l.instance = u, Bt(u), u) : (a = e, (u = Ml.get(n)) && (a = D({}, e), m0(a, u)), t = t.ownerDocument || t, u = t.createElement("script"), Bt(u), Kt(u, "link", a), t.head.appendChild(u), l.instance = u);
        case "void":
          return null;
        default:
          throw Error(s(443, l.type));
      }
    else
      l.type === "stylesheet" && (l.state.loading & 4) === 0 && (a = l.instance, l.state.loading |= 4, Kn(a, e.precedence, t));
    return l.instance;
  }
  function Kn(t, l, e) {
    for (var a = e.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), u = a.length ? a[a.length - 1] : null, n = u, i = 0; i < a.length; i++) {
      var c = a[i];
      if (c.dataset.precedence === l) n = c;
      else if (n !== u) break;
    }
    n ? n.parentNode.insertBefore(t, n.nextSibling) : (l = e.nodeType === 9 ? e.head : e, l.insertBefore(t, l.firstChild));
  }
  function y0(t, l) {
    t.crossOrigin == null && (t.crossOrigin = l.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = l.referrerPolicy), t.title == null && (t.title = l.title);
  }
  function m0(t, l) {
    t.crossOrigin == null && (t.crossOrigin = l.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = l.referrerPolicy), t.integrity == null && (t.integrity = l.integrity);
  }
  var Jn = null;
  function Eo(t, l, e) {
    if (Jn === null) {
      var a = /* @__PURE__ */ new Map(), u = Jn = /* @__PURE__ */ new Map();
      u.set(e, a);
    } else
      u = Jn, a = u.get(e), a || (a = /* @__PURE__ */ new Map(), u.set(e, a));
    if (a.has(t)) return a;
    for (a.set(t, null), e = e.getElementsByTagName(t), u = 0; u < e.length; u++) {
      var n = e[u];
      if (!(n[Ka] || n[Lt] || t === "link" && n.getAttribute("rel") === "stylesheet") && n.namespaceURI !== "http://www.w3.org/2000/svg") {
        var i = n.getAttribute(l) || "";
        i = t + i;
        var c = a.get(i);
        c ? c.push(n) : a.set(i, [n]);
      }
    }
    return a;
  }
  function Ao(t, l, e) {
    t = t.ownerDocument || t, t.head.insertBefore(
      e,
      l === "title" ? t.querySelector("head > title") : null
    );
  }
  function gh(t, l, e) {
    if (e === 1 || l.itemProp != null) return !1;
    switch (t) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof l.precedence != "string" || typeof l.href != "string" || l.href === "")
          break;
        return !0;
      case "link":
        if (typeof l.rel != "string" || typeof l.href != "string" || l.href === "" || l.onLoad || l.onError)
          break;
        switch (l.rel) {
          case "stylesheet":
            return t = l.disabled, typeof l.precedence == "string" && t == null;
          default:
            return !0;
        }
      case "script":
        if (l.async && typeof l.async != "function" && typeof l.async != "symbol" && !l.onLoad && !l.onError && l.src && typeof l.src == "string")
          return !0;
    }
    return !1;
  }
  function _o(t) {
    return !(t.type === "stylesheet" && (t.state.loading & 3) === 0);
  }
  function ph(t, l, e, a) {
    if (e.type === "stylesheet" && (typeof a.media != "string" || matchMedia(a.media).matches !== !1) && (e.state.loading & 4) === 0) {
      if (e.instance === null) {
        var u = qa(a.href), n = l.querySelector(
          Nu(u)
        );
        if (n) {
          l = n._p, l !== null && typeof l == "object" && typeof l.then == "function" && (t.count++, t = kn.bind(t), l.then(t, t)), e.state.loading |= 4, e.instance = n, Bt(n);
          return;
        }
        n = l.ownerDocument || l, a = So(a), (u = Ml.get(u)) && y0(a, u), n = n.createElement("link"), Bt(n);
        var i = n;
        i._p = new Promise(function(c, r) {
          i.onload = c, i.onerror = r;
        }), Kt(n, "link", a), e.instance = n;
      }
      t.stylesheets === null && (t.stylesheets = /* @__PURE__ */ new Map()), t.stylesheets.set(e, l), (l = e.state.preload) && (e.state.loading & 3) === 0 && (t.count++, e = kn.bind(t), l.addEventListener("load", e), l.addEventListener("error", e));
    }
  }
  var v0 = 0;
  function Sh(t, l) {
    return t.stylesheets && t.count === 0 && $n(t, t.stylesheets), 0 < t.count || 0 < t.imgCount ? function(e) {
      var a = setTimeout(function() {
        if (t.stylesheets && $n(t, t.stylesheets), t.unsuspend) {
          var n = t.unsuspend;
          t.unsuspend = null, n();
        }
      }, 6e4 + l);
      0 < t.imgBytes && v0 === 0 && (v0 = 62500 * P2());
      var u = setTimeout(
        function() {
          if (t.waitingForImages = !1, t.count === 0 && (t.stylesheets && $n(t, t.stylesheets), t.unsuspend)) {
            var n = t.unsuspend;
            t.unsuspend = null, n();
          }
        },
        (t.imgBytes > v0 ? 50 : 800) + l
      );
      return t.unsuspend = e, function() {
        t.unsuspend = null, clearTimeout(a), clearTimeout(u);
      };
    } : null;
  }
  function kn() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) $n(this, this.stylesheets);
      else if (this.unsuspend) {
        var t = this.unsuspend;
        this.unsuspend = null, t();
      }
    }
  }
  var Wn = null;
  function $n(t, l) {
    t.stylesheets = null, t.unsuspend !== null && (t.count++, Wn = /* @__PURE__ */ new Map(), l.forEach(bh, t), Wn = null, kn.call(t));
  }
  function bh(t, l) {
    if (!(l.state.loading & 4)) {
      var e = Wn.get(t);
      if (e) var a = e.get(null);
      else {
        e = /* @__PURE__ */ new Map(), Wn.set(t, e);
        for (var u = t.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), n = 0; n < u.length; n++) {
          var i = u[n];
          (i.nodeName === "LINK" || i.getAttribute("media") !== "not all") && (e.set(i.dataset.precedence, i), a = i);
        }
        a && e.set(null, a);
      }
      u = l.instance, i = u.getAttribute("data-precedence"), n = e.get(i) || a, n === a && e.set(null, u), e.set(i, u), this.count++, a = kn.bind(this), u.addEventListener("load", a), u.addEventListener("error", a), n ? n.parentNode.insertBefore(u, n.nextSibling) : (t = t.nodeType === 9 ? t.head : t, t.insertBefore(u, t.firstChild)), l.state.loading |= 4;
    }
  }
  var Ru = {
    $$typeof: gt,
    Provider: null,
    Consumer: null,
    _currentValue: Q,
    _currentValue2: Q,
    _threadCount: 0
  };
  function Eh(t, l, e, a, u, n, i, c, r) {
    this.tag = 1, this.containerInfo = t, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = ri(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ri(0), this.hiddenUpdates = ri(null), this.identifierPrefix = a, this.onUncaughtError = u, this.onCaughtError = n, this.onRecoverableError = i, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = r, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function To(t, l, e, a, u, n, i, c, r, g, E, z) {
    return t = new Eh(
      t,
      l,
      e,
      i,
      r,
      g,
      E,
      z,
      c
    ), l = 1, n === !0 && (l |= 24), n = rl(3, null, null, l), t.current = n, n.stateNode = t, l = Wi(), l.refCount++, t.pooledCache = l, l.refCount++, n.memoizedState = {
      element: a,
      isDehydrated: e,
      cache: l
    }, Pi(n), t;
  }
  function zo(t) {
    return t ? (t = ma, t) : ma;
  }
  function Mo(t, l, e, a, u, n) {
    u = zo(u), a.context === null ? a.context = u : a.pendingContext = u, a = ge(l), a.payload = { element: e }, n = n === void 0 ? null : n, n !== null && (a.callback = n), e = pe(t, a, l), e !== null && (nl(e, t, l), su(e, t, l));
  }
  function Oo(t, l) {
    if (t = t.memoizedState, t !== null && t.dehydrated !== null) {
      var e = t.retryLane;
      t.retryLane = e !== 0 && e < l ? e : l;
    }
  }
  function g0(t, l) {
    Oo(t, l), (t = t.alternate) && Oo(t, l);
  }
  function Do(t) {
    if (t.tag === 13 || t.tag === 31) {
      var l = xe(t, 67108864);
      l !== null && nl(l, t, 67108864), g0(t, 67108864);
    }
  }
  function No(t) {
    if (t.tag === 13 || t.tag === 31) {
      var l = vl();
      l = hi(l);
      var e = xe(t, l);
      e !== null && nl(e, t, l), g0(t, l);
    }
  }
  var Fn = !0;
  function Ah(t, l, e, a) {
    var u = A.T;
    A.T = null;
    var n = G.p;
    try {
      G.p = 2, p0(t, l, e, a);
    } finally {
      G.p = n, A.T = u;
    }
  }
  function _h(t, l, e, a) {
    var u = A.T;
    A.T = null;
    var n = G.p;
    try {
      G.p = 8, p0(t, l, e, a);
    } finally {
      G.p = n, A.T = u;
    }
  }
  function p0(t, l, e, a) {
    if (Fn) {
      var u = S0(a);
      if (u === null)
        u0(
          t,
          l,
          a,
          In,
          e
        ), Ro(t, a);
      else if (zh(
        u,
        t,
        l,
        e,
        a
      ))
        a.stopPropagation();
      else if (Ro(t, a), l & 4 && -1 < Th.indexOf(t)) {
        for (; u !== null; ) {
          var n = ua(u);
          if (n !== null)
            switch (n.tag) {
              case 3:
                if (n = n.stateNode, n.current.memoizedState.isDehydrated) {
                  var i = Ye(n.pendingLanes);
                  if (i !== 0) {
                    var c = n;
                    for (c.pendingLanes |= 2, c.entangledLanes |= 2; i; ) {
                      var r = 1 << 31 - sl(i);
                      c.entanglements[1] |= r, i &= ~r;
                    }
                    jl(n), (ft & 6) === 0 && (Hn = cl() + 500, zu(0));
                  }
                }
                break;
              case 31:
              case 13:
                c = xe(n, 2), c !== null && nl(c, n, 2), jn(), g0(n, 2);
            }
          if (n = S0(a), n === null && u0(
            t,
            l,
            a,
            In,
            e
          ), n === u) break;
          u = n;
        }
        u !== null && a.stopPropagation();
      } else
        u0(
          t,
          l,
          a,
          null,
          e
        );
    }
  }
  function S0(t) {
    return t = Ei(t), b0(t);
  }
  var In = null;
  function b0(t) {
    if (In = null, t = aa(t), t !== null) {
      var l = N(t);
      if (l === null) t = null;
      else {
        var e = l.tag;
        if (e === 13) {
          if (t = M(l), t !== null) return t;
          t = null;
        } else if (e === 31) {
          if (t = C(l), t !== null) return t;
          t = null;
        } else if (e === 3) {
          if (l.stateNode.current.memoizedState.isDehydrated)
            return l.tag === 3 ? l.stateNode.containerInfo : null;
          t = null;
        } else l !== t && (t = null);
      }
    }
    return In = t, null;
  }
  function Uo(t) {
    switch (t) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (sr()) {
          case j0:
            return 2;
          case q0:
            return 8;
          case xu:
          case or:
            return 32;
          case B0:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var E0 = !1, Ne = null, Ue = null, Re = null, Cu = /* @__PURE__ */ new Map(), Gu = /* @__PURE__ */ new Map(), Ce = [], Th = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Ro(t, l) {
    switch (t) {
      case "focusin":
      case "focusout":
        Ne = null;
        break;
      case "dragenter":
      case "dragleave":
        Ue = null;
        break;
      case "mouseover":
      case "mouseout":
        Re = null;
        break;
      case "pointerover":
      case "pointerout":
        Cu.delete(l.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Gu.delete(l.pointerId);
    }
  }
  function Hu(t, l, e, a, u, n) {
    return t === null || t.nativeEvent !== n ? (t = {
      blockedOn: l,
      domEventName: e,
      eventSystemFlags: a,
      nativeEvent: n,
      targetContainers: [u]
    }, l !== null && (l = ua(l), l !== null && Do(l)), t) : (t.eventSystemFlags |= a, l = t.targetContainers, u !== null && l.indexOf(u) === -1 && l.push(u), t);
  }
  function zh(t, l, e, a, u) {
    switch (l) {
      case "focusin":
        return Ne = Hu(
          Ne,
          t,
          l,
          e,
          a,
          u
        ), !0;
      case "dragenter":
        return Ue = Hu(
          Ue,
          t,
          l,
          e,
          a,
          u
        ), !0;
      case "mouseover":
        return Re = Hu(
          Re,
          t,
          l,
          e,
          a,
          u
        ), !0;
      case "pointerover":
        var n = u.pointerId;
        return Cu.set(
          n,
          Hu(
            Cu.get(n) || null,
            t,
            l,
            e,
            a,
            u
          )
        ), !0;
      case "gotpointercapture":
        return n = u.pointerId, Gu.set(
          n,
          Hu(
            Gu.get(n) || null,
            t,
            l,
            e,
            a,
            u
          )
        ), !0;
    }
    return !1;
  }
  function Co(t) {
    var l = aa(t.target);
    if (l !== null) {
      var e = N(l);
      if (e !== null) {
        if (l = e.tag, l === 13) {
          if (l = M(e), l !== null) {
            t.blockedOn = l, V0(t.priority, function() {
              No(e);
            });
            return;
          }
        } else if (l === 31) {
          if (l = C(e), l !== null) {
            t.blockedOn = l, V0(t.priority, function() {
              No(e);
            });
            return;
          }
        } else if (l === 3 && e.stateNode.current.memoizedState.isDehydrated) {
          t.blockedOn = e.tag === 3 ? e.stateNode.containerInfo : null;
          return;
        }
      }
    }
    t.blockedOn = null;
  }
  function Pn(t) {
    if (t.blockedOn !== null) return !1;
    for (var l = t.targetContainers; 0 < l.length; ) {
      var e = S0(t.nativeEvent);
      if (e === null) {
        e = t.nativeEvent;
        var a = new e.constructor(
          e.type,
          e
        );
        bi = a, e.target.dispatchEvent(a), bi = null;
      } else
        return l = ua(e), l !== null && Do(l), t.blockedOn = e, !1;
      l.shift();
    }
    return !0;
  }
  function Go(t, l, e) {
    Pn(t) && e.delete(l);
  }
  function Mh() {
    E0 = !1, Ne !== null && Pn(Ne) && (Ne = null), Ue !== null && Pn(Ue) && (Ue = null), Re !== null && Pn(Re) && (Re = null), Cu.forEach(Go), Gu.forEach(Go);
  }
  function ti(t, l) {
    t.blockedOn === l && (t.blockedOn = null, E0 || (E0 = !0, f.unstable_scheduleCallback(
      f.unstable_NormalPriority,
      Mh
    )));
  }
  var li = null;
  function Ho(t) {
    li !== t && (li = t, f.unstable_scheduleCallback(
      f.unstable_NormalPriority,
      function() {
        li === t && (li = null);
        for (var l = 0; l < t.length; l += 3) {
          var e = t[l], a = t[l + 1], u = t[l + 2];
          if (typeof a != "function") {
            if (b0(a || e) === null)
              continue;
            break;
          }
          var n = ua(e);
          n !== null && (t.splice(l, 3), l -= 3, Sc(
            n,
            {
              pending: !0,
              data: u,
              method: e.method,
              action: a
            },
            a,
            u
          ));
        }
      }
    ));
  }
  function Xa(t) {
    function l(r) {
      return ti(r, t);
    }
    Ne !== null && ti(Ne, t), Ue !== null && ti(Ue, t), Re !== null && ti(Re, t), Cu.forEach(l), Gu.forEach(l);
    for (var e = 0; e < Ce.length; e++) {
      var a = Ce[e];
      a.blockedOn === t && (a.blockedOn = null);
    }
    for (; 0 < Ce.length && (e = Ce[0], e.blockedOn === null); )
      Co(e), e.blockedOn === null && Ce.shift();
    if (e = (t.ownerDocument || t).$$reactFormReplay, e != null)
      for (a = 0; a < e.length; a += 3) {
        var u = e[a], n = e[a + 1], i = u[Pt] || null;
        if (typeof n == "function")
          i || Ho(e);
        else if (i) {
          var c = null;
          if (n && n.hasAttribute("formAction")) {
            if (u = n, i = n[Pt] || null)
              c = i.formAction;
            else if (b0(u) !== null) continue;
          } else c = i.action;
          typeof c == "function" ? e[a + 1] = c : (e.splice(a, 3), a -= 3), Ho(e);
        }
      }
  }
  function Yo() {
    function t(n) {
      n.canIntercept && n.info === "react-transition" && n.intercept({
        handler: function() {
          return new Promise(function(i) {
            return u = i;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function l() {
      u !== null && (u(), u = null), a || setTimeout(e, 20);
    }
    function e() {
      if (!a && !navigation.transition) {
        var n = navigation.currentEntry;
        n && n.url != null && navigation.navigate(n.url, {
          state: n.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var a = !1, u = null;
      return navigation.addEventListener("navigate", t), navigation.addEventListener("navigatesuccess", l), navigation.addEventListener("navigateerror", l), setTimeout(e, 100), function() {
        a = !0, navigation.removeEventListener("navigate", t), navigation.removeEventListener("navigatesuccess", l), navigation.removeEventListener("navigateerror", l), u !== null && (u(), u = null);
      };
    }
  }
  function A0(t) {
    this._internalRoot = t;
  }
  ei.prototype.render = A0.prototype.render = function(t) {
    var l = this._internalRoot;
    if (l === null) throw Error(s(409));
    var e = l.current, a = vl();
    Mo(e, a, t, l, null, null);
  }, ei.prototype.unmount = A0.prototype.unmount = function() {
    var t = this._internalRoot;
    if (t !== null) {
      this._internalRoot = null;
      var l = t.containerInfo;
      Mo(t.current, 2, null, t, null, null), jn(), l[ea] = null;
    }
  };
  function ei(t) {
    this._internalRoot = t;
  }
  ei.prototype.unstable_scheduleHydration = function(t) {
    if (t) {
      var l = Z0();
      t = { blockedOn: null, target: t, priority: l };
      for (var e = 0; e < Ce.length && l !== 0 && l < Ce[e].priority; e++) ;
      Ce.splice(e, 0, t), e === 0 && Co(t);
    }
  };
  var jo = m.version;
  if (jo !== "19.2.0")
    throw Error(
      s(
        527,
        jo,
        "19.2.0"
      )
    );
  G.findDOMNode = function(t) {
    var l = t._reactInternals;
    if (l === void 0)
      throw typeof t.render == "function" ? Error(s(188)) : (t = Object.keys(t).join(","), Error(s(268, t)));
    return t = o(l), t = t !== null ? X(t) : null, t = t === null ? null : t.stateNode, t;
  };
  var Oh = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: A,
    reconcilerVersion: "19.2.0"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var ai = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ai.isDisabled && ai.supportsFiber)
      try {
        Za = ai.inject(
          Oh
        ), fl = ai;
      } catch {
      }
  }
  return ju.createRoot = function(t, l) {
    if (!U(t)) throw Error(s(299));
    var e = !1, a = "", u = Ls, n = Zs, i = Vs;
    return l != null && (l.unstable_strictMode === !0 && (e = !0), l.identifierPrefix !== void 0 && (a = l.identifierPrefix), l.onUncaughtError !== void 0 && (u = l.onUncaughtError), l.onCaughtError !== void 0 && (n = l.onCaughtError), l.onRecoverableError !== void 0 && (i = l.onRecoverableError)), l = To(
      t,
      1,
      !1,
      null,
      null,
      e,
      a,
      null,
      u,
      n,
      i,
      Yo
    ), t[ea] = l.current, a0(t), new A0(l);
  }, ju.hydrateRoot = function(t, l, e) {
    if (!U(t)) throw Error(s(299));
    var a = !1, u = "", n = Ls, i = Zs, c = Vs, r = null;
    return e != null && (e.unstable_strictMode === !0 && (a = !0), e.identifierPrefix !== void 0 && (u = e.identifierPrefix), e.onUncaughtError !== void 0 && (n = e.onUncaughtError), e.onCaughtError !== void 0 && (i = e.onCaughtError), e.onRecoverableError !== void 0 && (c = e.onRecoverableError), e.formState !== void 0 && (r = e.formState)), l = To(
      t,
      1,
      !0,
      l,
      e ?? null,
      a,
      u,
      r,
      n,
      i,
      c,
      Yo
    ), l.context = zo(null), e = l.current, a = vl(), a = hi(a), u = ge(a), u.callback = null, pe(e, u, a), e = a, l.current.lanes = e, wa(l, e), jl(l), t[ea] = l.current, a0(t), new ei(l);
  }, ju.version = "19.2.0", ju;
}
var Ko;
function qh() {
  if (Ko) return z0.exports;
  Ko = 1;
  function f() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(f);
      } catch (m) {
        console.error(m);
      }
  }
  return f(), z0.exports = jh(), z0.exports;
}
var Bh = qh();
const Xh = { sleepingDrool: { fps: 25, duration: 136, settle: 7, frames: [{ t: 0, layers: [{ role: "accessory", variant: "sleeping-drool-left-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.21, 177.07], [91.44, 177.52], [53.7, 181.71], [18.82, 177.95], [18.35, 177.32], [53.74, 181.64]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-left-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.46, 180.57], [91.68, 181.02], [53.94, 185.21], [19.07, 181.45], [18.59, 180.82], [53.99, 185.13]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.21, 177.07], [301.44, 177.52], [263.7, 181.71], [228.82, 177.95], [228.35, 177.32], [263.74, 181.64]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.46, 180.57], [301.68, 181.02], [263.94, 185.21], [229.07, 181.45], [228.59, 180.82], [263.99, 185.13]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-mouth", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }, { role: "accessory", variant: "sleeping-drool-drip", opacity: 0, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }, { path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }] }, { t: 19.286, layers: [{ role: "accessory", variant: "sleeping-drool-left-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.18, 170.4], [91.41, 170.85], [53.7, 173.44], [18.86, 171.15], [18.39, 170.51], [53.74, 173.36]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-left-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.4, 174.17], [91.62, 174.61], [53.91, 177.2], [19.08, 174.92], [18.6, 174.28], [53.96, 177.13]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.18, 170.4], [301.41, 170.85], [263.7, 173.44], [228.86, 171.15], [228.39, 170.51], [263.74, 173.36]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.4, 174.17], [301.62, 174.61], [263.91, 177.2], [229.08, 174.92], [228.6, 174.28], [263.96, 177.13]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-mouth", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[1.86, -0.38], [2.17, -0.12], [2.19, 0.24], [0.17, -2.63], [-1.69, -0.77], [-1.7, 0], [-1.2, 0.64], [0.17, 2.5]], o: [[-1.69, 0.26], [-2.18, 0.12], [-1.86, -0.25], [0, 2.26], [1.87, 1.01], [1.54, 0], [1.52, -0.76], [-0.16, -2.65]], v: [[164.25, 203.74], [159.02, 204.24], [153.13, 203.74], [149.39, 207.55], [152.61, 211.46], [159.51, 212.72], [165.75, 211.71], [168.62, 207.17]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }, { role: "accessory", variant: "sleeping-drool-drip", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[2.03, -0.51], [0, -0.64], [-0.17, -0.13], [-0.17, -0.38], [-0.17, 0], [-0.17, -0.25], [-1.02, 0], [-0.17, 0.25], [-0.17, 1.02], [-0.17, 0.76], [-0.17, 0.89], [-0.17, 0.13], [0.17, 0.25]], o: [[-1.7, 0.51], [0, 0.51], [-0.17, 0.25], [0.17, 0.89], [0.17, 0.13], [0.85, 1.77], [0.17, 0], [0.51, -0.89], [0.17, -0.38], [0.17, -0.89], [0.17, -0.63], [0, -0.25], [-0.35, -0.5]], v: [[163.44, 210.75], [159.19, 212.28], [160.04, 213.04], [161.22, 214.81], [161.9, 216.71], [162.42, 218.86], [164.81, 221.13], [165.32, 220.75], [166.34, 217.95], [166.68, 216.18], [167.19, 213.52], [167.7, 211.87], [168.37, 208.07]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }, { path: { c: !0, i: [[0.52, 0.5], [0, 0.12], [0.17, 0], [0.33, -0.13], [0.17, -0.51], [0.17, -0.25], [-0.35, 0], [0, -2.03], [-0.17, 0.01], [-0.17, 0.38], [-0.17, 0.38], [0, 1.01], [0.34, 0.13]], o: [[-0.18, -0.25], [0, -0.13], [-0.17, 0], [-0.17, 0.13], [-0.17, 0.51], [0.01, 1.27], [0.34, 0], [0.01, 0.38], [0.34, 0], [0.51, -1.02], [0.17, -0.38], [0, -0.64], [-0.35, -0.12]], v: [[164.79, 214.3], [164.43, 213.8], [164.09, 213.55], [163.59, 213.81], [163.09, 214.95], [162.58, 216.34], [163.12, 217.35], [163.8, 219.5], [164.31, 220.12], [164.99, 219.61], [166, 217.96], [166.34, 216.19], [165.83, 215.05]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }] }, { t: 38.571, layers: [{ role: "accessory", variant: "sleeping-drool-left-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.15, 164.8], [91.38, 165.25], [53.7, 166.49], [18.9, 165.44], [18.42, 164.8], [53.74, 166.42]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-left-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.35, 168.79], [91.57, 169.24], [53.89, 170.48], [19.09, 169.43], [18.62, 168.79], [53.94, 170.41]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.15, 164.8], [301.38, 165.25], [263.7, 166.49], [228.9, 165.44], [228.42, 164.8], [263.74, 166.42]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.35, 168.79], [301.57, 169.24], [263.89, 170.48], [229.09, 169.43], [228.62, 168.79], [263.94, 170.41]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-mouth", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[1.92, -0.24], [2.24, 0], [2.88, -0.24], [0.32, -1.93], [-1.6, -0.72], [-2.56, 0], [-2.24, 0.96], [0, 1.69]], o: [[-2.24, 0.24], [-2.24, 0], [-1.92, 0], [0, 1.68], [2.88, 1.2], [2.56, 0], [1.6, -0.72], [-0.32, -2.16]], v: [[166.36, 200.28], [159.64, 201.24], [152.27, 200.52], [148.43, 204.6], [151.31, 208.21], [159.96, 209.41], [167.65, 208.45], [170.85, 204.12]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }, { role: "accessory", variant: "sleeping-drool-drip", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[3.89, -0.96], [-0.32, -1.75], [-0.32, -0.45], [-0.37, -0.45], [-0.32, -0.65], [-0.37, -0.86], [-0.78, -0.17], [-0.59, 0.24], [-0.37, 0.96], [0, 0.69], [-0.32, 2.13], [0, 0.03], [0.32, 0.24]], o: [[-3.25, 0.75], [0, 0.48], [0.37, 0.62], [0.59, 0.62], [0.32, 1.23], [0.78, 1.75], [0.64, 0], [0.69, -0.72], [0.27, -0.86], [0.05, -1.27], [0, -1.68], [0.05, -0.51], [-1.1, -1.92]], v: [[164.44, 207.29], [156.81, 209.08], [158.54, 211.06], [160.69, 211.95], [161.97, 213.22], [163.25, 214.7], [165.9, 220.25], [167.69, 219.98], [169.06, 217.47], [169.93, 214.87], [170.61, 211.2], [170.66, 209.42], [170.75, 205.1]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }, { path: { c: !0, i: [[0.27, 0.21], [0.27, 0], [0.27, 0], [0.27, -0.21], [0, -0.41], [0, -0.41], [-0.27, -0.62], [0, -0.21], [-0.37, -0.17], [-0.32, 0.48], [-0.32, 1.37], [0, 0.62], [0.55, 0]], o: [[0, -0.21], [-0.27, 0], [-0.27, 0], [0, 0.41], [0, 0.41], [0, 0.41], [0.27, 0.62], [0.27, 0.21], [0.37, 0.17], [0.96, -0.96], [0.32, -1.34], [0, -0.21], [-0.55, 0.21]], v: [[166.73, 212.47], [166.13, 212.13], [165.49, 212.19], [164.9, 212.5], [164.44, 213.77], [163.98, 214.83], [164.67, 216.89], [165.63, 218.74], [166.31, 219.53], [167.64, 219.19], [169.56, 215.48], [170.2, 212.4], [168.6, 212.23]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }] }, { t: 57.857, layers: [{ role: "accessory", variant: "sleeping-drool-left-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.2, 174.1], [91.42, 174.54], [53.7, 178.02], [18.84, 174.92], [18.36, 174.29], [53.74, 177.95]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-left-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.43, 177.72], [91.66, 178.16], [53.93, 181.64], [19.07, 178.54], [18.6, 177.91], [53.98, 181.57]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.2, 174.1], [301.42, 174.54], [263.7, 178.02], [228.84, 174.92], [228.36, 174.29], [263.74, 177.95]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.43, 177.72], [301.66, 178.16], [263.93, 181.64], [229.07, 178.54], [228.6, 177.91], [263.98, 181.57]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-mouth", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[3.43, -0.69], [2.54, 0], [3.79, 0.21], [0.02, -3.28], [-2.81, -1.63], [-2.86, 0], [-2.54, 1.19], [0, 3.04]], o: [[-2.84, 0.69], [-2.84, 0], [-3.13, 0], [0, 3.27], [3.18, 1.88], [3.16, 0], [2.51, -1.4], [-0.32, -4.2]], v: [[167.57, 210.63], [159.64, 211.59], [150.77, 210.65], [143.6, 217.67], [149.51, 223.99], [159.96, 226.1], [169.45, 224.46], [174.77, 217.19]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }, { role: "accessory", variant: "sleeping-drool-drip", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[3.84, -0.96], [0, -1.27], [-0.32, -0.07], [-0.27, -0.62], [-0.27, 0], [-0.27, -0.41], [-1.37, 0.82], [-0.69, 0.24], [-0.37, 2.02], [-0.27, 1.23], [-0.05, 1.61], [-0.59, 1.99], [0.32, 0.45]], o: [[-3.47, 0.93], [0, 0.89], [0.87, 0.93], [0.27, 1.44], [0.27, 0.21], [0.82, 2.88], [0.27, -0.21], [1.23, -0.03], [0.27, -0.72], [0.27, -1.65], [0.37, -1.23], [0.27, -1.37], [-0.69, -1.1]], v: [[164.99, 223.03], [157.17, 225.91], [158.63, 227.86], [160.92, 230.33], [162.15, 233.55], [163.07, 235.54], [166.31, 239.48], [168.01, 237.15], [170.66, 234.99], [171.57, 231.63], [172.17, 228.1], [173.4, 223.85], [174.09, 218.44]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }, { path: { c: !0, i: [[0.59, 0.51], [0.27, 0.48], [0.32, 0.27], [0.37, -0.41], [0.05, -0.96], [0, -0.96], [0, -0.93], [-0.32, -0.69], [-0.64, 0], [-0.32, 0.51], [-0.27, 1.3], [0.05, 1.34], [0.55, 0.48]], o: [[-0.27, -0.27], [-0.27, -0.48], [-0.32, -0.27], [-0.69, 0.86], [0, 0.96], [0, 1.2], [0, 1.13], [0.32, 0.48], [0.64, 0], [0.87, -0.86], [0.27, -1.06], [0, -0.48], [-0.55, -0.48]], v: [[167.73, 307.44], [166.86, 306.17], [165.72, 305.14], [164.76, 305.24], [163.98, 307.98], [164.26, 311.14], [164.26, 314.36], [165.17, 317.07], [166.73, 317.79], [168.33, 317.07], [169.74, 314.09], [170.02, 310.15], [169.15, 308.71]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }] }, { t: 77.143, layers: [{ role: "accessory", variant: "sleeping-drool-left-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.2, 174.96], [91.43, 175.4], [53.7, 179.09], [18.84, 175.8], [18.36, 175.16], [53.74, 179.01]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-left-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.44, 178.54], [91.66, 178.99], [53.93, 182.67], [19.07, 179.38], [18.59, 178.75], [53.98, 182.6]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.2, 174.96], [301.43, 175.4], [263.7, 179.09], [228.84, 175.8], [228.36, 175.16], [263.74, 179.01]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.44, 178.54], [301.66, 178.99], [263.93, 182.67], [229.07, 179.38], [228.59, 178.75], [263.98, 182.6]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-mouth", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[2.77, 0.23], [1.92, -0.01], [2.54, -0.01], [0, -1.87], [-2.15, -1.36], [-2.54, 0], [-2.24, 1.4], [0, 1.87]], o: [[-1.92, -0.01], [-2.54, 0], [-1.87, 0.01], [-0.02, 1.61], [2.24, 1.4], [2.54, 0], [2.15, -1.37], [-0.32, -2.09]], v: [[166.34, 217.24], [159.96, 217.23], [153.24, 217.23], [148.33, 218.68], [152, 224.19], [159.96, 225.59], [167.59, 224.43], [171.29, 218.44]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }, { role: "accessory", variant: "sleeping-drool-drip", opacity: 0, outer: null, inner: null, paths: [{ path: { c: !0, i: [[1.58, -0.95], [0, -0.71], [0, 0], [-0.32, 0], [-0.32, 0], [-0.32, 0], [-0.95, 0.24], [0, 0], [-0.95, 0.71], [0, 0.24], [-0.32, 0.24], [0, 0.24], [0.32, 0]], o: [[-1.58, 0.71], [0, 0.47], [0, 0.24], [0, 0], [0.32, 0], [0.95, 0], [0, 0], [0.63, 0], [0, -0.24], [0.32, -0.24], [0, -0.24], [0, -0.47], [-1.26, -0.47]], v: [[166.24, 222.94], [162.14, 224.36], [162.45, 225.07], [163.08, 225.31], [163.4, 225.31], [164.03, 225.31], [166.24, 224.83], [166.55, 224.83], [168.44, 223.89], [168.76, 223.42], [169.39, 222.71], [169.7, 222.23], [169.39, 221.52]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }, { path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[169.39, 278.98], [168.76, 278.98], [167.81, 278.74], [166.87, 278.74], [166.55, 281.11], [166.24, 283.47], [166.55, 285.84], [166.55, 288.2], [168.13, 288.44], [169.7, 288.44], [169.7, 285.37], [169.39, 282.29], [169.39, 280.64]] }, opacity: 0, strokeWidth: 0, fill: !0, stroke: !1 }] }] }, { t: 96.429, layers: [{ role: "accessory", variant: "sleeping-drool-left-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.16, 165.73], [91.38, 166.17], [53.7, 167.64], [18.89, 166.38], [18.41, 165.75], [53.74, 167.57]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-left-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.36, 169.68], [91.58, 170.13], [53.89, 171.6], [19.09, 170.34], [18.61, 169.7], [53.94, 171.52]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.16, 165.73], [301.38, 166.17], [263.7, 167.64], [228.89, 166.38], [228.41, 165.75], [263.74, 167.57]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.36, 169.68], [301.58, 170.13], [263.89, 171.6], [229.09, 170.34], [228.61, 169.7], [263.94, 171.52]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-mouth", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0.96, 0.01], [1.92, -0.24], [2.22, -0.24], [0, -0.97], [-0.64, 0], [-2.25, 0], [-2.22, 0.71], [0, 0.97]], o: [[-1.91, -0.24], [-2.24, 0], [-0.96, 0.25], [-0.32, 0.49], [2.22, 0.71], [2.24, 0], [0.65, -0.24], [-0.32, -0.97]], v: [[166.03, 206.27], [159.96, 206.03], [153.25, 206.03], [151.96, 207.74], [152.61, 208.96], [159.96, 209.69], [166.66, 209.2], [167.95, 207.5]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }, { role: "accessory", variant: "sleeping-drool-drip", opacity: 0, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }, { path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85], [158.04, 213.85]] }, opacity: 0, strokeWidth: 0, fill: !0, stroke: !1 }] }] }, { t: 115.714, layers: [{ role: "accessory", variant: "sleeping-drool-left-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.17, 168.71], [91.4, 169.15], [53.7, 171.34], [18.87, 169.42], [18.4, 168.79], [53.74, 171.27]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-left-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.38, 172.54], [91.61, 172.99], [53.91, 175.17], [19.08, 173.26], [18.61, 172.62], [53.95, 175.1]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.17, 168.71], [301.4, 169.15], [263.7, 171.34], [228.87, 169.42], [228.4, 168.79], [263.74, 171.27]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.38, 172.54], [301.61, 172.99], [263.91, 175.17], [229.08, 173.26], [228.61, 172.62], [263.95, 175.1]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-mouth", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0.25, 0], [0.49, -0.06], [0.57, -0.06], [0, -0.25], [-0.16, 0], [-0.57, 0], [-0.57, 0.18], [0, 0.25]], o: [[-0.49, -0.06], [-0.57, 0], [-0.25, 0.06], [-0.08, 0.12], [0.57, 0.18], [0.57, 0], [0.16, -0.06], [-0.08, -0.25]], v: [[160.8, 211.56], [159.25, 211.5], [157.53, 211.5], [157.2, 211.93], [157.36, 212.24], [159.25, 212.42], [160.97, 212.3], [161.29, 211.87]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }, { role: "accessory", variant: "sleeping-drool-drip", opacity: 0, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }, { path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49], [158.75, 213.49]] }, opacity: 0, strokeWidth: 0, fill: !0, stroke: !1 }] }] }, { t: 124.99, layers: [{ role: "accessory", variant: "sleeping-drool-left-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.2, 173.82], [91.42, 174.27], [53.7, 177.68], [18.84, 174.64], [18.37, 174.01], [53.74, 177.61]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-left-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.43, 177.45], [91.65, 177.9], [53.93, 181.31], [19.07, 178.27], [18.6, 177.64], [53.97, 181.24]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.2, 173.82], [301.42, 174.27], [263.7, 177.68], [228.84, 174.64], [228.37, 174.01], [263.74, 177.61]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.43, 177.45], [301.65, 177.9], [263.93, 181.31], [229.07, 178.27], [228.6, 177.64], [263.97, 181.24]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-mouth", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }, { role: "accessory", variant: "sleeping-drool-drip", opacity: 0, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }, { path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214]] }, opacity: 0, strokeWidth: 0, fill: !0, stroke: !1 }] }] }, { t: 135, layers: [{ role: "accessory", variant: "sleeping-drool-left-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.21, 177.04], [91.44, 177.48], [53.7, 181.67], [18.82, 177.92], [18.35, 177.28], [53.74, 181.59]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-left-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[92.46, 180.54], [91.68, 180.98], [53.94, 185.17], [19.07, 181.42], [18.59, 180.79], [53.99, 185.09]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.21, 177.04], [301.44, 177.48], [263.7, 181.67], [228.82, 177.92], [228.35, 177.28], [263.74, 181.59]] }, opacity: 1, strokeWidth: 11.96, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-right-closed-glow", opacity: 1, outer: null, inner: null, paths: [{ path: { c: !0, i: [[-0.02, -3.84], [0, 0], [24.07, 0.11], [0, 0], [0, 0], [-23.27, 0.21]], o: [[0, 0], [0, 0], [-23.07, -0.11], [0, 0], [-0.02, -3.73], [25.47, -0.23]], v: [[302.46, 180.54], [301.68, 180.98], [263.94, 185.17], [229.07, 181.42], [228.59, 180.79], [263.99, 185.09]] }, opacity: 1, strokeWidth: 0.92, fill: !1, stroke: !0 }] }, { role: "accessory", variant: "sleeping-drool-mouth", opacity: 0, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }] }, { role: "accessory", variant: "sleeping-drool-drip", opacity: 0, outer: null, inner: null, paths: [{ path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214]] }, opacity: 1, strokeWidth: 0, fill: !0, stroke: !1 }, { path: { c: !0, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214], [159, 214]] }, opacity: 0, strokeWidth: 0, fill: !0, stroke: !1 }] }] }] } }, ii = 320, Jo = 240, xh = -48, Bl = 13, qu = 8, Xu = Xh, Qh = [
  ["sleepingDrool"],
  ["staring"],
  ["staring"],
  ["staring"],
  ["staring"],
  ["staring"]
], Lh = {
  sleepingDrool: "sleeping-drool",
  dreamChicken: "dreaming-of-chicken",
  staring: "staring",
  curiosity: "curious",
  lookAround: "looking-around",
  question: "confused",
  pointingReminder: "heart",
  excited: "excited",
  snicker: "snickering",
  eyeRoll: "eye-roll",
  arrogance: "arrogant",
  suspicious: "suspicious",
  frantic: "frantic",
  thumbsUp: "thumbs-up",
  shy: "shy",
  strong: "strong",
  dinoCoherent: "little-red-dragon",
  music: "music",
  progressGaze: "progress-gaze"
}, Zh = /* @__PURE__ */ new Set(["dinoCoherent", "music"]), Wt = {
  background: "#000000",
  outerGlow: "#44aace",
  innerBlue: "#33a5d2",
  cyan: "#6ce7f5",
  body: "#88edf3",
  core: "#a6faee"
}, ql = {
  black: "#000000",
  outer: "#44aace",
  inner: "#33a5d2",
  edge: "#6ce7f5",
  body: "#baf8fa",
  core: "#f4ffff"
}, Vh = {
  c: !0,
  i: [[0.348, -33.766], [0, 0], [52.467, 0], [0, 37.429], [0, 0], [-58.684, 0]],
  o: [[0, 0], [0.358, 38.532], [-54.598, 0], [0, 0], [0.489, -34.598], [58.163, 0]],
  v: [[373.13, 278.277], [373.12, 371.196], [291.12, 449.908], [208.304, 371.212], [208.315, 278.294], [291.13, 201.957]]
}, wh = {
  c: !0,
  i: [[0, -38.384], [0, 0], [41.772, 0], [0, 29.855], [0, 0], [-40.022, 0]],
  o: [[0, 0], [0, 31.214], [-44.098, 0], [0, 0], [0, -38.384], [37.696, 0]],
  v: [[347.5, 290.554], [347.5, 362.482], [291.489, 423.913], [233.5, 362.482], [233.5, 290.554], [291.489, 227.457]]
}, C0 = 1.1, ko = 0.29 * C0, Wo = [93, 227], Kh = 123, Jh = 0.9, kh = 8.2, Wh = 8, ui = 1.18, $h = 25, Fh = 35, $t = (f, m, S) => Math.max(m, Math.min(S, f)), Xl = (f, m, S) => f + (m - f) * S, He = (f) => {
  const m = $t(f, 0, 1);
  return m * m * (3 - 2 * m);
};
function N0(f, m, S) {
  if (!f || !m) return f || m;
  const s = (U, N) => U.map((M, C) => [
    Xl(M[0], N[C][0], S),
    Xl(M[1], N[C][1], S)
  ]);
  return {
    c: f.c && m.c,
    i: s(f.i, m.i),
    o: s(f.o, m.o),
    v: s(f.v, m.v)
  };
}
function Ih(f, m, S) {
  return f.map((s, U) => {
    const N = m[U] || s;
    return {
      ...s,
      opacity: Xl(s.opacity, N.opacity, S),
      outer: N0(s.outer, N.outer, S),
      inner: N0(s.inner, N.inner, S),
      paths: s.paths.map((M, C) => {
        const O = N.paths[C] || M;
        return {
          ...M,
          opacity: Xl(M.opacity, O.opacity, S),
          strokeWidth: Xl(M.strokeWidth, O.strokeWidth, S),
          path: N0(M.path, O.path, S)
        };
      })
    };
  });
}
function Qa(f, m, S, s = 0, U = 0) {
  if (!f) return f;
  const N = f.v.map((o) => o[0]), M = f.v.map((o) => o[1]), C = (Math.min(...N) + Math.max(...N)) / 2, O = (Math.min(...M) + Math.max(...M)) / 2;
  return {
    c: f.c,
    i: f.i.map((o) => [o[0] * m, o[1] * S]),
    o: f.o.map((o) => [o[0] * m, o[1] * S]),
    v: f.v.map((o) => [
      C + (o[0] - C) * m + s,
      O + (o[1] - O) * S + U
    ])
  };
}
function H0(f, { scaleY: m = 1, offsetX: S = 0, offsetY: s = 0, curiosity: U = 0 } = {}) {
  return f.map((N, M) => {
    const C = N.side === "left" || M < 2 ? -1 : 1, O = U ? 1 + U * C * 0.045 : 1, o = (X) => Qa(
      X,
      1 + U * 0.035,
      m * O,
      S + U * C * 1.8,
      s - U * 2.5
    );
    return {
      ...N,
      outer: o(N.outer),
      inner: o(N.inner),
      paths: N.paths.map((X) => ({ ...X, path: o(X.path) }))
    };
  });
}
function Ph(f, m) {
  const s = Xu[f].frames, U = Xl(s[0].t, s.at(-1).t, $t(m, 0, 1));
  for (let N = 0; N < s.length - 1; N += 1) {
    const M = s[N], C = s[N + 1];
    if (U <= C.t) {
      const O = He((U - M.t) / Math.max(1, C.t - M.t));
      return Ih(M.layers, C.layers, O);
    }
  }
  return s.at(-1).layers;
}
function U0(f) {
  const m = Xu[f];
  return m.frames[m.settle].layers;
}
function td(f = 1) {
  const m = Xu.sadness.frames[0].layers, S = $t(f, 0, 1), s = Math.sin(S * Math.PI) ** 2, U = Math.sin(S * Math.PI * 3), N = s * (0.72 + U * 0.22);
  return H0(m, {
    curiosity: N,
    offsetX: Math.sin(S * Math.PI * 2) * 4 * s,
    offsetY: -Math.sin(S * Math.PI) * 2 * s
  });
}
function R0() {
  return Xu.sadness.frames[0].layers;
}
function ld(f, m) {
  if (f === "curiosity") return td(m);
  if (f === "lookAround") return U0("sadness");
  if (f === "excited") {
    const S = Math.max(0, Math.sin(m * Math.PI * 4));
    return H0(U0("sadness"), {
      scaleY: 1 + S * 0.14,
      offsetY: -S * 3
    });
  }
  return Xu[f] ? Ph(f, m) : U0("sadness");
}
function Bu(f, m) {
  var S;
  if ((S = m == null ? void 0 : m.v) != null && S.length) {
    f.moveTo(m.v[0][0], m.v[0][1]);
    for (let s = 1; s < m.v.length; s += 1) {
      const U = m.v[s - 1], N = m.v[s];
      f.bezierCurveTo(
        U[0] + m.o[s - 1][0],
        U[1] + m.o[s - 1][1],
        N[0] + m.i[s][0],
        N[1] + m.i[s][1],
        N[0],
        N[1]
      );
    }
    if (m.c) {
      const s = m.v.at(-1), U = m.v[0];
      f.bezierCurveTo(
        s[0] + m.o.at(-1)[0],
        s[1] + m.o.at(-1)[1],
        U[0] + m.i[0][0],
        U[1] + m.i[0][1],
        U[0],
        U[1]
      ), f.closePath();
    }
  }
}
function ce(f, m, S, s, U = "none") {
  f.save(), f.globalAlpha *= s, f.fillStyle = S, f.filter = U, f.beginPath(), Bu(f, m), f.fill(), f.restore();
}
function ta(f, m, S, s, U, N = "none") {
  f.save(), f.globalAlpha *= U, f.fillStyle = s, f.filter = N, f.beginPath(), Bu(f, m), Bu(f, S), f.fill("evenodd"), f.restore();
}
function Rl(f, m, S, s, U, N = "none") {
  f.save(), f.globalAlpha *= U, f.strokeStyle = S, f.lineWidth = s, f.lineJoin = "round", f.lineCap = "round", f.filter = N, f.beginPath(), Bu(f, m), f.stroke(), f.restore();
}
function ed(f, m) {
  if (!m.outer || !m.inner || m.opacity <= 0.01) return;
  const S = Qa(m.inner, 0.69, 0.74), s = m.opacity;
  f.globalCompositeOperation = "screen", ta(f, m.outer, m.inner, Wt.outerGlow, 0.42 * s, "blur(10px)"), ta(f, m.outer, m.inner, Wt.body, 0.9 * s, "blur(4px)"), ta(f, m.outer, m.inner, Wt.core, 0.72 * s, "blur(1.5px)"), f.globalCompositeOperation = "source-over", ce(f, m.inner, Wt.background, 0.95 * s), f.globalCompositeOperation = "screen", Rl(f, m.inner, Wt.innerBlue, 7, 0.42 * s, "blur(3px)"), f.globalCompositeOperation = "source-over", ce(f, S, Wt.background, 0.84 * s), f.globalCompositeOperation = "screen", Rl(f, m.inner, Wt.cyan, 1.3, 0.56 * s, "blur(1px)"), Rl(f, m.outer, Wt.core, 1.2, 0.78 * s, "blur(1.5px)");
}
function ad(f, m) {
  var U, N;
  if (m.opacity <= 0.01) return;
  const S = (U = m.variant) == null ? void 0 : U.includes("glow"), s = (N = m.variant) == null ? void 0 : N.includes("blush");
  m.paths.forEach((M) => {
    const C = m.opacity * M.opacity;
    C <= 0.01 || (f.globalCompositeOperation = "screen", s ? (ce(f, M.path, "#ff675f", 0.72 * C, "blur(5px)"), ce(f, M.path, "#ff9a8f", 0.5 * C, "blur(1px)")) : M.fill ? (ce(f, M.path, Wt.outerGlow, 0.34 * C, "blur(7px)"), ce(f, M.path, Wt.body, 0.86 * C, "blur(1.4px)"), ce(f, M.path, Wt.core, 0.68 * C)) : S ? (Rl(f, M.path, Wt.innerBlue, M.strokeWidth * 4, 0.36 * C, "blur(4px)"), Rl(f, M.path, Wt.cyan, Math.max(1, M.strokeWidth), 0.7 * C, "blur(1px)")) : M.stroke && (Rl(f, M.path, Wt.outerGlow, M.strokeWidth * 1.35, 0.28 * C, "blur(5px)"), Rl(f, M.path, Wt.body, M.strokeWidth, 0.88 * C, "blur(1.5px)"), Rl(f, M.path, Wt.core, M.strokeWidth * 0.72, 0.72 * C, "blur(.5px)")));
  });
}
function ud(f, m) {
  const S = Math.sin(m * Math.PI);
  if (S <= 0.02) return;
  f.save(), f.translate(160, 102), f.scale(0.58 + S * 0.24, 0.58 + S * 0.24), f.beginPath(), f.moveTo(0, 12), f.bezierCurveTo(-35, -10, -29, -39, -8, -39), f.bezierCurveTo(4, -39, 11, -31, 14, -24), f.bezierCurveTo(18, -31, 25, -39, 37, -39), f.bezierCurveTo(58, -39, 64, -10, 29, 12), f.lineTo(14, 24), f.closePath(), f.globalCompositeOperation = "screen", f.fillStyle = "#ff5f61", f.filter = "blur(7px)";
  const s = f.globalAlpha;
  f.globalAlpha = s * 0.52 * S, f.fill(), f.filter = "none", f.globalAlpha = s * 0.92 * S, f.fill(), f.restore();
}
function ni(f, m, S, s, U, N, M, C = 1, O = 0.8) {
  const o = 1 - $t(U, 0, 1) * 0.88, X = H0(m, { scaleY: o, offsetX: S, offsetY: s });
  f.save(), f.globalAlpha *= C, f.translate(0, xh), f.translate(ii / 2, 108), f.scale(
    O * C0,
    O * C0
  ), f.translate(-ii / 2, -108), X.forEach((D) => {
    D.role === "eye" ? ed(f, D) : ad(f, D);
  }), N === "pointingReminder" && ud(f, M), f.restore();
}
function $o(f, m, S, s, U, N) {
  const M = $t(S / Bl, -1, 1), C = $t(s / qu, -1, 1), O = Math.abs(M), o = Math.abs(C), X = $t(M * (U === "left" ? -1 : 1), -1, 1), D = Jh, Z = 1 + O * 0.035 + o * 0.025, ct = Xl(0.08, 1 + X * 0.07 + o * 0.04, N), st = 1 + O * 0.055 - o * 0.02, bt = Xl(0.06, 1 + X * 0.18 - o * 0.09, N), _t = Qa(
    Vh,
    Z,
    ct,
    M * 1.6 * D,
    O * 1.3 * D + C * 2.7 * D
  ), lt = Qa(
    wh,
    st,
    bt,
    M * $h,
    C * Fh
  ), jt = Qa(
    lt,
    1 - (0.022 + O * 0.035) * D,
    1 - (0.032 + O * 0.05) * D,
    0,
    0
  ), gt = Qa(lt, 0.69, 0.74), Ot = 0.3 + $t(Math.hypot(M, C), 0, 1) * 0.08, mt = (O * 0.16 + o * 0.2) * D, H = 3.62 + Math.abs(X) * 0.48 * D, ut = 0.82 + Math.abs(X) * 0.06;
  f.save(), f.translate(
    m + M * kh,
    Kh + C * Wh
  ), f.rotate(M * 2.2 * Math.PI / 180), f.scale(ko, ko), f.translate(-291, -326), f.globalCompositeOperation = "screen", ta(f, _t, lt, ql.outer, 0.24, "blur(4.5px)"), ta(f, _t, jt, ql.inner, 0.08 + O * 0.12 + o * 0.04, "blur(2.2px)"), ta(f, _t, lt, ql.body, 0.88, "blur(1.8px)"), ta(f, _t, lt, ql.core, 0.82, "blur(.55px)"), f.save(), f.beginPath(), Bu(f, _t), f.clip(), f.globalAlpha *= mt, f.fillStyle = ql.core, f.filter = "blur(2.2px)", f.beginPath(), f.ellipse(
    291 + M * 32 * D * ui,
    326 + (O * 18 * D + C * 31 * D) * ui,
    78 + O * 36 * D * ui,
    92 + (o * 40 + O * 16) * D * ui,
    0,
    0,
    Math.PI * 2
  ), f.fill(), f.restore(), f.globalCompositeOperation = "source-over", ce(f, lt, ql.black, 0.95), f.globalCompositeOperation = "screen", Rl(f, lt, ql.inner, 18, Ot, "blur(1.2px)"), f.globalCompositeOperation = "source-over", ce(f, gt, ql.black, 0.84), f.globalCompositeOperation = "screen", Rl(f, lt, ql.edge, 4.14, 0.68, "blur(.35px)"), Rl(f, _t, ql.core, H, ut, "blur(.55px)"), f.restore();
}
function Fo(f, m, S, s = 1, U = 1) {
  const N = He(s);
  f.save(), f.globalAlpha *= U, $o(f, Wo[0], m, S, "left", N), $o(f, Wo[1], m, S, "right", N), f.restore();
}
function nd(f) {
  return f < 0 || f > 260 ? 0 : f < 80 ? He(f / 80) : f < 120 ? 1 : 1 - He((f - 120) / 140);
}
function id(f) {
  return 4600;
}
function cd({ phaseIndex: f, progressPosition: m }) {
  const S = ie.useRef(null), s = ie.useRef(null), U = ie.useRef({
    phaseIndex: f,
    progressPosition: m,
    fromProgressPosition: m,
    movementStartedAt: 0,
    movementEndsAt: 0
  }), N = ie.useRef({
    x: 0,
    y: 0,
    velocityX: 0,
    velocityY: 0,
    mode: f === 0 ? "sleeping" : "steady",
    expressionKey: f === 0 ? "sleepingDrool" : "staring",
    expressionStartedAt: 0,
    expressionEndsAt: 0,
    recoveryStartedAt: 0,
    recoveryEndsAt: 0,
    transitionStartedAt: 0,
    transitionFrom: null,
    lastSnapshot: null,
    mediaKey: null,
    nextBlinkAt: 0,
    blinkStartedAt: 0
  });
  return ie.useEffect(() => {
    var C;
    const M = U.current;
    if (Math.abs(m - M.progressPosition) > 25e-5) {
      const O = performance.now(), o = Math.max(1, M.movementEndsAt - M.movementStartedAt), X = He((O - M.movementStartedAt) / o);
      M.fromProgressPosition = Xl(M.fromProgressPosition, M.progressPosition, X), M.movementStartedAt = O, M.movementEndsAt = O + 480;
    }
    M.progressPosition = m, M.phaseIndex = f, (C = s.current) == null || C.call(s);
  }, [f, m]), ie.useEffect(() => {
    const M = S.current;
    if (!M) return;
    const C = M.getContext("2d"), O = window.matchMedia("(prefers-reduced-motion: reduce)"), o = N.current, X = performance.now();
    o.expressionStartedAt = X, o.nextBlinkAt = X + 5800;
    let D = 0, Z = !0, ct = X, st = 1, bt = 0, _t = 0, lt = 1;
    const jt = () => {
      Z && !D && (ct = performance.now(), D = window.requestAnimationFrame(Tt));
    };
    s.current = jt;
    const gt = () => {
      const H = M.getBoundingClientRect();
      lt = Math.min(2, window.devicePixelRatio || 1), M.width = Math.max(1, Math.round(H.width * lt)), M.height = Math.max(1, Math.round(H.height * lt)), st = Math.min(H.width / ii, H.height / Jo), bt = (H.width - ii * st) / 2, _t = (H.height - Jo * st) / 2, O.matches && jt();
    }, Tt = (H) => {
      if (!Z) return;
      const ut = U.current, xt = !O.matches && H < ut.movementEndsAt, fe = ut.phaseIndex / (Qh.length - 1), il = $t((fe * 2 - 1) * Bl, -Bl, Bl), Qt = ut.phaseIndex === 0 ? 4.5 : qu, xl = () => {
        o.transitionStartedAt = H, o.expressionStartedAt = H, ut.phaseIndex === 0 ? (o.transitionFrom = o.lastSnapshot, o.mode = "sleeping", o.expressionKey = "sleepingDrool") : (o.transitionFrom = null, o.mode = "steady", o.expressionKey = "progressGaze");
      };
      if (O.matches)
        o.mode = "static", o.expressionKey = ut.phaseIndex === 0 ? "sleepingDrool" : "progressGaze";
      else if (xt && o.mode !== "tracking") {
        const Jt = o.mode === "sleeping";
        o.mode = "tracking", o.transitionStartedAt = H, o.transitionFrom = Jt ? o.lastSnapshot : null, o.expressionKey = "progressGaze";
      } else !xt && o.mode === "tracking" && xl();
      const Ol = Math.max(1, o.expressionEndsAt - o.expressionStartedAt), qt = $t((H - o.expressionStartedAt) / Ol, 0, 1), A = Math.max(1, id()), G = (H - o.expressionStartedAt) % A / A;
      let Q = il, et = Qt;
      if (o.mode === "tracking") {
        const Jt = Math.max(1, ut.movementEndsAt - ut.movementStartedAt), Ql = He((H - ut.movementStartedAt) / Jt), It = Xl(ut.fromProgressPosition, ut.progressPosition, Ql), La = $t(It - 0.035, 0, 1);
        Q = $t((La * 2 - 1) * Bl, -Bl, Bl), et = qu;
      } else if (o.mode === "free" && o.expressionKey === "lookAround") {
        const Jt = Math.sin(qt * Math.PI) ** 2;
        Q += Math.sin(qt * Math.PI * 4) * Bl * Jt, et += Math.sin(qt * Math.PI * 2) * 2.5 * Jt;
      }
      const at = Math.min(0.034, Math.max(1e-3, (H - ct) / 1e3));
      if (ct = H, O.matches)
        o.x = Q, o.y = et, o.velocityX = 0, o.velocityY = 0;
      else {
        o.velocityX += (Q - o.x) * 92 * at, o.velocityY += (et - o.y) * 92 * at;
        const Ql = Math.exp(-16 * at);
        if (o.velocityX *= Ql, o.velocityY *= Ql, o.x = $t(o.x + o.velocityX * at, -Bl, Bl), o.y = $t(o.y + o.velocityY * at, -qu, qu), o.mode === "free" && qt > 0.86) {
          const It = He((qt - 0.86) / 0.14);
          o.x += (il - o.x) * It, o.y += (Qt - o.y) * It, o.velocityX *= 1 - It, o.velocityY *= 1 - It;
        }
      }
      let d = 0;
      !O.matches && o.mode === "free" && (!o.blinkStartedAt && H >= o.nextBlinkAt && (o.blinkStartedAt = H), o.blinkStartedAt && (d = nd(H - o.blinkStartedAt), H - o.blinkStartedAt > 260 && (o.blinkStartedAt = 0, o.nextBlinkAt = H + 5600 + Math.random() * 1800)));
      const _ = o.mode === "tracking" || o.mode === "steady" ? "progressGaze" : o.expressionKey;
      M.dataset.eyeExpression = Lh[_] || _, M.dataset.eyeMode = o.mode;
      const R = o.mode === "sleeping" ? G : o.mode === "free" ? qt : 0, Y = Zh.has(_), V = Math.min(R, 1 - R), K = o.mode === "free" ? He(V / 0.14) : 1;
      M.dataset.eyeProgress = R.toFixed(3), M.dataset.eyeEdgeAlpha = K.toFixed(3), M.dataset.eyeX = o.x.toFixed(2), M.dataset.eyeY = o.y.toFixed(2), M.style.opacity = "1", C.setTransform(1, 0, 0, 1, 0, 0), C.clearRect(0, 0, M.width, M.height), C.setTransform(
        lt * st,
        0,
        0,
        lt * st,
        lt * bt,
        lt * _t
      );
      const tt = _ === "progressGaze", Ht = tt ? null : Y ? R0() : ld(_, R), Et = (Jt) => {
        if (tt) {
          const Ql = o.mode === "tracking" ? $t((H - o.transitionStartedAt) / 190, 0, 1) : 1;
          Fo(C, o.x, o.y, Ql, Jt);
        } else o.mode === "free" && !Y ? (ni(C, R0(), o.x, o.y, 0, "default", 0, Jt * (1 - K)), ni(C, Ht, o.x, o.y, d, _, R, Jt * K)) : ni(
          C,
          Ht,
          o.x,
          o.y,
          d,
          _,
          R,
          Jt,
          _ === "sleepingDrool" ? 0.64 : 0.8
        );
      }, Cl = $t((H - o.transitionStartedAt) / 240, 0, 1);
      o.transitionFrom && Cl < 1 ? (o.transitionFrom.kind === "gaze" ? Fo(C, o.x, o.y, 1, 1 - Cl) : ni(
        C,
        o.transitionFrom.layers,
        o.x,
        o.y,
        0,
        o.transitionFrom.expressionKey,
        o.transitionFrom.progress,
        1 - Cl,
        o.transitionFrom.expressionKey === "sleepingDrool" ? 0.64 : 0.8
      ), Et(Cl)) : (o.transitionFrom = null, Et(1));
      const la = Y || o.mode === "free" && K < 0.5;
      o.lastSnapshot = tt ? { kind: "gaze" } : la ? { layers: R0(), expressionKey: "default", progress: 0 } : { layers: Ht, expressionKey: _, progress: R }, D = O.matches ? 0 : window.requestAnimationFrame(Tt);
    }, Ot = new ResizeObserver(gt);
    Ot.observe(M);
    const mt = new IntersectionObserver(([H]) => {
      Z = H.isIntersecting, Z ? jt() : D && (window.cancelAnimationFrame(D), D = 0);
    }, { rootMargin: "15% 0px" });
    return mt.observe(M), O.addEventListener("change", jt), gt(), jt(), () => {
      Ot.disconnect(), mt.disconnect(), O.removeEventListener("change", jt), s.current = null, D && window.cancelAnimationFrame(D);
    };
  }, []), /* @__PURE__ */ B.jsx("canvas", { className: "growth-pet__eyes-canvas", ref: S, "aria-hidden": "true" });
}
const xa = [
  {
    range: [1, 3],
    kicker: "DAYS 1–3 · REAL CARE",
    title: "Care for me like a real pet.",
    copy: "",
    features: [["◒", "Feed"], ["♡", "Comfort"], ["⌁", "Bathe"], ["✦", "Clean"]]
  },
  {
    range: [4, 7],
    kicker: "DAYS 4–7 · LEARN & BOND",
    title: "Teach me. Walk with me. Help me grow.",
    copy: "",
    features: [["◔", "Hunger"], ["＋", "Health"], ["◡", "Mood"], ["◷", "Check in"]]
  },
  {
    range: [8, 21],
    kicker: "DAYS 8–21 · EARN & EXPLORE",
    title: "Help me earn, save, and explore.",
    copy: "",
    features: [["$", "Jobs"], ["◎", "Egg Coins"], ["▣", "Shop"], ["♢", "Outfits"]]
  },
  {
    range: [22, 44],
    kicker: "DAYS 22–44 · TESTING LIMITS",
    title: "Stay with me while I test the limits.",
    copy: "",
    features: [["☼", "Childhood"], ["≈", "Teen moods"], ["↗", "Rebellion"], ["✣", "Fate"]]
  },
  {
    range: [45, 77],
    kicker: "DAYS 45–77 · CREATE & HELP",
    title: "Watch me create, remember, and help.",
    copy: "",
    features: [["✎", "AI drawing"], ["♫", "AI music"], ["◰", "Stories"], ["□", "Creations"]]
  },
  {
    range: [78, 100],
    kicker: "DAYS 78–100+ · ONE OF A KIND",
    title: "Your care makes me one of a kind.",
    copy: "",
    features: [["≡", "Diary"], ["✉", "Letters"], ["⌖", "Maps"], ["∞", "Adventures"]]
  }
], Io = [
  {
    image: "/assets/growth/day-1-feed.webp",
    title: "Feed me through the day.",
    copy: "Breakfast, snacks, dinner—regular feeding keeps me going and teaches me that you always come back.",
    alt: "A fluffy lamb EGGI surrounded by batteries, hamburgers, and eight meal clocks"
  },
  {
    image: "/assets/growth/day-1-soothe-bathe.webp",
    title: "Keep my screen clean.",
    copy: "Wipe away sleepy smudges and give me a bath whenever my little face needs freshening up.",
    alt: "A finger repeatedly rubbing the screen of a fluffy lamb EGGI during bath time"
  },
  {
    image: "/assets/growth/day-1-clean.webp",
    title: "Learn what my mess means.",
    copy: "Color and timing can signal hunger, health, or that everything is okay. Real care means noticing the small changes.",
    alt: "A fluffy lamb EGGI comparing colorful poop samples with a simple health chart"
  }
], Po = [
  {
    image: "/assets/growth/day-4-walk-earn.webp",
    title: "Take me out into the world.",
    copy: "Every walk gives us time together—and earns Egg Coins for the things I will grow to love.",
    alt: "A fluffy lamb EGGI riding in a crossbody sling as footsteps turn into golden egg coins"
  },
  {
    image: "/assets/growth/day-4-learn.webp",
    title: "Help me learn new words.",
    copy: "Bring me to class. Every lesson unlocks more ways for me to understand and respond to you.",
    alt: "A fluffy lamb EGGI changing from confused to confident while learning in class"
  },
  {
    image: "/assets/growth/day-4-dress.webp",
    title: "Let me pick a look.",
    copy: "Use the Egg Coins we earn on props and outfits until we find a look that feels like me.",
    alt: "A delighted fluffy lamb EGGI buying virtual clothes and trying them on in a mirror"
  }
], tr = [
  {
    image: "/assets/growth/day-8-family-fund.webp",
    title: "Help me save for something big.",
    copy: "Teach me to save, borrow, and plan ahead. Every Egg Coin brings my next goal closer.",
    alt: "A fluffy lamb EGGI and a caregiver saving golden egg coins in an education fund at a bank"
  },
  {
    image: "/assets/growth/day-8-postcard-journey.webp",
    title: "I’ll write when I miss you.",
    copy: "Every trip brings a new place, a strange treasure, and a postcard home to you.",
    alt: "A fluffy lamb EGGI traveling alone, sending letters home, and collecting magical souvenirs"
  },
  {
    image: "/assets/growth/day-8-part-time.webp",
    title: "My first little paycheck.",
    copy: "A little apron, a first shift, and Egg Coins I earned on my own.",
    alt: "A fluffy lamb EGGI working a part-time bakery shift and adding egg coins to the household jar"
  }
], lr = [
  {
    image: "/assets/growth/day-22-patient-parent.webp",
    title: "Teach me where the limit is.",
    copy: "Hold the line, take a breath, and explain it again. I am learning that care can include a no.",
    alt: "A patient parent in a tiger-striped cardigan calmly teaching a tiny stubborn lamb EGGI"
  },
  {
    image: "/assets/growth/day-22-class-escape.webp",
    title: "Sometimes I break the routine.",
    copy: "I might skip class and chase the sky. Follow the little footprints and help me find my way back.",
    alt: "A tiny lamb EGGI escaping school toward an open field while a caregiver catches the backpack"
  },
  {
    image: "/assets/growth/day-22-sensitive-picky.webp",
    title: "Big feelings need you close.",
    copy: "Food feels wrong. Outfits feel worse. I may push back—and still need you close enough to stay.",
    alt: "A tiny sensitive lamb EGGI rejecting food and clothes while a caregiver listens patiently"
  }
], er = [
  {
    image: "/assets/growth/day-45-paint.webp",
    title: "I can paint our memories.",
    copy: "Give me one shared moment and I can turn it into a picture made just for us.",
    alt: "A tiny lamb EGGI creating a unique painting inspired by a warm shared memory"
  },
  {
    image: "/assets/growth/day-45-memory-song.webp",
    title: "I can turn memories into music.",
    copy: "I gather moments we nearly forgot and compose them into a song for you.",
    alt: "A tiny lamb EGGI turning shared memories into music with headphones and a small console"
  },
  {
    image: "/assets/growth/day-45-time-help.webp",
    title: "I can remember the small stuff.",
    copy: "Alarms, timers, tiny reminders—I keep track of the day so you do not have to.",
    alt: "A tiny lamb EGGI using alarms, timers, and icon reminders to help manage the day"
  }
], ar = [
  {
    image: "/assets/growth/day-78-personality.webp",
    title: "Every choice shapes who I become.",
    copy: "Meals, boundaries, skills, and memories all leave a trace. Together, they shape my Fate.",
    alt: "A tiny lamb EGGI forming a unique Fate from care choices, unlocked skills, and shared memories"
  },
  {
    image: "/assets/growth/day-78-parallel-worlds.webp",
    title: "My Fate opens new worlds.",
    copy: "Look years ahead and see the places, roles, and adventures my Fate can unlock.",
    alt: "A tiny lamb EGGI facing several original parallel future worlds connected by ten glowing points"
  },
  {
    image: "/assets/growth/day-78-destiny-adventure.webp",
    title: "My story keeps going.",
    copy: "Wizard, explorer, guardian—every choice opens another map and another adventure.",
    alt: "A tiny wizard lamb EGGI choosing paths on an endless fantasy destiny map"
  }
];
function fd({ phaseIndex: f, progressPosition: m }) {
  const S = (U) => {
    const N = U.currentTarget.getBoundingClientRect(), M = (U.clientX - N.left) / N.width - 0.5, C = (U.clientY - N.top) / N.height - 0.5, O = U.currentTarget.querySelector(".growth-pet");
    O && (O.style.transform = `rotateX(${-C * 12}deg) rotateY(${M * 16}deg)`);
  }, s = (U) => {
    const N = U.currentTarget.querySelector(".growth-pet");
    N && (N.style.transform = "");
  };
  return /* @__PURE__ */ B.jsx("div", { className: "growth-pet-stage", onPointerMove: S, onPointerLeave: s, children: /* @__PURE__ */ B.jsx("div", { className: "growth-pet", children: /* @__PURE__ */ B.jsxs("div", { className: "growth-pet__body", children: [
    /* @__PURE__ */ B.jsx("span", { className: "growth-pet__antenna growth-pet__antenna--left" }),
    /* @__PURE__ */ B.jsx("span", { className: "growth-pet__antenna growth-pet__antenna--right" }),
    /* @__PURE__ */ B.jsx("span", { className: "growth-pet__socket growth-pet__socket--left" }),
    /* @__PURE__ */ B.jsx("span", { className: "growth-pet__socket growth-pet__socket--right" }),
    /* @__PURE__ */ B.jsx("span", { className: "growth-pet__shell" }),
    /* @__PURE__ */ B.jsx("span", { className: "growth-pet__button growth-pet__button--left" }),
    /* @__PURE__ */ B.jsx("span", { className: "growth-pet__button growth-pet__button--right" }),
    /* @__PURE__ */ B.jsx("span", { className: "growth-pet__screen", children: /* @__PURE__ */ B.jsx("span", { className: "growth-pet__face", children: /* @__PURE__ */ B.jsx(cd, { phaseIndex: f, progressPosition: m }) }) })
  ] }) }) });
}
function sd({ assetUrl: f = (S) => S, productDetail: m = !1 } = {}) {
  const [S, s] = ie.useState(0), U = ie.useRef(null), N = (D) => m ? D == null ? void 0 : D.replace(/personality/gi, "Fate") : D;

  const M = xa[S], C = S === 0 ? Io : S === 1 ? Po : S === 2 ? tr : S === 3 ? lr : S === 4 ? er : S === 5 ? ar : null, O = M.range[0], o = S / (xa.length - 1), X = {
    "--growth-progress": `${(o * 100).toFixed(2)}%`,
    "--growth-orbit-rotation": `${(O * 0.18).toFixed(2)}deg`
  };
  return /* @__PURE__ */ B.jsx(
    "section",
    {
      className: `growth-journey growth-journey--phase-${S}`,
      ref: U,
      id: "growth",
      style: X,
      "aria-labelledby": "growth-journey-title",
      children: /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__sticky", children: [
        /* @__PURE__ */ B.jsx("div", { className: "growth-journey__grid", "aria-hidden": "true" }),
        /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__layout", children: [
          /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__visual", children: [
            m && /* @__PURE__ */ B.jsxs("header", { className: "product-growth-heading", children: [
              /* @__PURE__ */ B.jsx("p", { className: "product-chapter-label", children: "02 / WATCH ME GROW" }),
              /* @__PURE__ */ B.jsxs("h2", { children: [
                "100 days of care.",
                /* @__PURE__ */ B.jsx("em", { children: "A Fate shaped by your care." })
              ] })
            ] }),
            /* @__PURE__ */ B.jsx(fd, { phaseIndex: S, progressPosition: o }),
            !m && /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__visual-caption", children: [
              /* @__PURE__ */ B.jsx("span", { children: "LIVE GROWTH MODEL" }),
              /* @__PURE__ */ B.jsx("span", { children: "MOVE TO TURN · CHOOSE A MILESTONE" })
            ] })
          ] }),
          /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__story", children: [
            /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__counter", "aria-hidden": "true", children: [
              /* @__PURE__ */ B.jsx("strong", { children: String(O).padStart(3, "0") }),
              /* @__PURE__ */ B.jsx("span", { children: "DAYS" })
            ] }),
            /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__phase", children: [
              /* @__PURE__ */ B.jsx("p", { children: M.kicker }),
              /* @__PURE__ */ B.jsx("h2", { id: "growth-journey-title", children: N(M.title) }),
              M.copy && /* @__PURE__ */ B.jsx("span", { children: N(M.copy) })
            ] }),
            C ? /* @__PURE__ */ B.jsx("div", { className: "growth-care", "aria-live": "polite", children: /* @__PURE__ */ B.jsx("div", { className: "growth-care__comics", children: C.map((D) => /* @__PURE__ */ B.jsxs("figure", { className: "growth-care__comic", children: [
              /* @__PURE__ */ B.jsx("img", { src: f(D.image), alt: D.alt, loading: m ? "eager" : "lazy", decoding: "async" }),
              /* @__PURE__ */ B.jsxs("figcaption", { children: [
                /* @__PURE__ */ B.jsx("strong", { children: N(D.title) }),
                /* @__PURE__ */ B.jsx("span", { children: N(D.copy) })
              ] })
            ] }, N(D.title))) }) }) : /* @__PURE__ */ B.jsx("div", { className: "growth-journey__features", "aria-live": "polite", children: M.features.map(([D, Z]) => /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__feature", children: [
              /* @__PURE__ */ B.jsx("i", { "aria-hidden": "true", children: D }),
              /* @__PURE__ */ B.jsx("span", { children: Z })
            ] }, Z)) })
          ] })
        ] }),
        /* @__PURE__ */ B.jsx("nav", { className: "growth-journey__rail", "aria-label": "Growth milestones", children: /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__rail-inner", children: [
          m && /* @__PURE__ */ B.jsx("div", { className: "growth-next-hint", "aria-hidden": "true", style: { left: `${(S + 1) % xa.length / (xa.length - 1) * 100}%` }, children: /* @__PURE__ */ B.jsxs("span", { className: "growth-next-hint__art", children: [
            "chick",
            /* @__PURE__ */ B.jsxs("svg", { viewBox: "0 0 60 56", fill: "none", "aria-hidden": "true", children: [
              /* @__PURE__ */ B.jsx("path", { d: "M39 4C57 20 46 35 30 49M30 49L32 34M30 49L45 46", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
              /* @__PURE__ */ B.jsx("path", { d: "M41 6L35 2M59 2L60 9", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
            ] })
          ] }) }),
          /* @__PURE__ */ B.jsxs("div", { className: "growth-journey__line", "aria-hidden": "true", children: [
            /* @__PURE__ */ B.jsx("i", {}),
            /* @__PURE__ */ B.jsx("em", { children: /* @__PURE__ */ B.jsxs("span", { children: [
              "DAY ",
              String(O).padStart(3, "0")
            ] }) })
          ] }),
          xa.map((D, Z) => /* @__PURE__ */ B.jsxs(
            "button",
            {
              className: `${Z <= S ? "is-reached" : ""} ${Z === S ? "is-active" : ""}`,
              type: "button",
              onClick: () => s(Z),
              "aria-pressed": Z === S,
              "aria-label": `Show ${D.kicker.toLowerCase()}`,
              style: { "--growth-stage-position": `${Z / (xa.length - 1) * 100}%` },
              children: [
                /* @__PURE__ */ B.jsx("span", { children: D.kicker.split(" · ")[0] }),
                /* @__PURE__ */ B.jsx("b", { children: D.kicker.split(" · ")[1] })
              ]
            },
            D.kicker
          ))
        ] }) })
      ] })
    }
  );
}
const Pe = "/assets/interaction", ur = {
  1: `${Pe}/idle/staring.mp4`,
  2: `${Pe}/idle/curious.mp4`,
  3: `${Pe}/idle/suspicious.mp4`,
  4: `${Pe}/idle/hungry.mp4`,
  5: `${Pe}/idle/sleep-bubble.mp4`,
  6: `${Pe}/idle/question.mp4`,
  7: `${Pe}/idle/sobbing.mp4`
};
function od(f) {
  return {
    market: {
      locale: "en-US",
      region: "US"
    },
    pet_profile: {
      pet_age: "days",
      pet_birthday: "2026-08-02",
      pet_level: "3",
      pet_personality: "lockded",
      pet_sign: "Leo",
      pet_name: "eggi",
      user_name: "mom",
      pet_super_brain: "locked",
      pet_hunger: `${f.hungry}%`,
      pet_thirst: `${f.thirsty}%`,
      pet_mood: `${f.mood}%`,
      pet_potty: `${f.poop}%`,
      care_meter_guide: "Higher is better: hunger means fullness, thirst means hydration, mood means happiness, and potty means relief."
    }
  };
}
function nr(f) {
  var C;
  const m = String(f || "").replace(/\r\n?/g, `
`).split(`
`).filter((O) => O.trim().length > 0);
  if (m.length < 2) throw new Error("EGGI reply must contain Action JSON and vocalization lines.");
  let S;
  try {
    const O = m[0].replace(
      /(\"expression_id\"\s*:\s*)0([1-7])(?=\s*[,}])/g,
      "$1$2"
    );
    S = JSON.parse(O);
  } catch {
    throw new Error("EGGI Action JSON could not be parsed.");
  }
  if (!Array.isArray(S.actions) || S.actions.length < 1 || S.actions.length > 2)
    throw new Error("EGGI reply contains an invalid action list.");
  const s = S.actions[0], U = Number((C = s == null ? void 0 : s.arguments) == null ? void 0 : C.expression_id);
  if ((s == null ? void 0 : s.type) !== "pet.set_expression" || !Number.isInteger(U) || !ur[U])
    throw new Error("EGGI reply contains an unsupported expression.");
  const N = S.actions[1] || null, M = (N == null ? void 0 : N.type) === "pet.enter_sleep" || (N == null ? void 0 : N.type) === "device.poweroff";
  if (N && !M) throw new Error("EGGI reply contains an unsupported skill action.");
  return {
    expressionId: U,
    media: ur[U],
    vocalization: m[1].trim(),
    enterSleep: (N == null ? void 0 : N.type) === "pet.enter_sleep",
    powerOff: (N == null ? void 0 : N.type) === "device.poweroff"
  };
}
function rd(f) {
  return nr(`${f}
…`);
}
async function hd({
  message: f,
  conversationId: m,
  runtimeContext: S,
  userId: s,
  onAction: U,
  onVocalization: N,
  endpoint: M = globalThis.__EGGI_CHAT_ENDPOINT__ ?? "/api/eggi-chat",
  signal: C
}) {
  if (!M) throw new Error("EGGI chat service is not configured for this host.");
  const O = await fetch(M, {
    method: "POST",
    signal: C,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message: f, conversationId: m, runtimeContext: S, userId: s })
  });
  if (!O.ok) throw new Error("EGGI chat service is unavailable.");
  if (!O.body) throw new Error("EGGI chat stream is unavailable.");
  const o = O.headers.get("X-EGGI-Runtime-Context") || "unconfirmed", X = O.body.getReader(), D = new TextDecoder();
  let Z = "", ct = "", st = m || "", bt = null, _t = "";
  const lt = (gt) => {
    const Tt = gt.split(`
`).filter((xt) => xt.startsWith("data:")).map((xt) => xt.slice(5).trim());
    if (!Tt.length) return;
    const Ot = Tt.join(`
`);
    if (Ot === "[DONE]") return;
    const mt = JSON.parse(Ot);
    st = mt.conversation_id || st, (mt.event === "message" || mt.event === "agent_message") && (ct += mt.answer || ""), mt.event === "message_end" && mt.answer && !ct && (ct = mt.answer);
    const H = ct.indexOf(`
`);
    if (H < 0) return;
    bt || (bt = rd(ct.slice(0, H).trim()), U == null || U(bt));
    const ut = ct.slice(H + 1).replace(/\r/g, "").trim();
    ut && ut !== _t && (_t = ut, N == null || N(ut));
  };
  for (; ; ) {
    const { value: gt, done: Tt } = await X.read();
    Z += D.decode(gt || new Uint8Array(), { stream: !Tt }).replace(/\r\n?/g, `
`);
    const Ot = Z.split(`

`);
    if (Z = Ot.pop() || "", Ot.filter(Boolean).forEach(lt), Tt) break;
  }
  return Z.trim() && lt(Z.trim()), { ...nr(ct), conversationId: st, runtimeContextStatus: o };
}
class dd extends HTMLElement {
  connectedCallback() {
    this.abort || (this.abort = new AbortController(), this.userId = `eggi-detail-${crypto.randomUUID()}`, this.sounds = [], this.innerHTML = '<span class="care-chat-title">TALK TO EGGI</span><form aria-label="Talk to EGGI"><label class="care-chat-sr" for="care-chat-input">Tell EGGI what to try</label><input id="care-chat-input" placeholder="What shall we play today?" maxlength="160" required autocomplete="off"><button type="submit" aria-label="Send message to EGGI">➤</button></form><p class="care-chat-note">Guide a little game. Hear a little Egg Language.</p><p class="care-chat-response" role="status" aria-live="polite"></p>', this.querySelector("form").addEventListener("submit", (m) => this.submit(m), { signal: this.abort.signal }), customElements.whenDefined("eggi-product-care").then(() => {
      this.isConnected && this.setupScreen();
    }));
  }
  media(m) {
    var s;
    const S = (s = this.care) == null ? void 0 : s.dataset.idleCuriousSrc;
    return S ? S.replace(/eggi-home--interaction--idle--curious\.mp4.*$/, `eggi-home--interaction--${m.replaceAll("/", "--")}`) : `/assets/interaction/${m}`;
  }
  sound(m) {
    const S = new Audio(this.media(m));
    this.sounds.push(S), S.addEventListener("ended", () => {
      this.sounds = this.sounds.filter((s) => s !== S);
    }, { once: !0 }), S.play().catch(() => {
    });
  }
  setupScreen() {
    var s;
    this.care = this.closest("eggi-product-care");
    const m = (s = this.care) == null ? void 0 : s.petScreen;
    if (!m) return;
    this.bubble = document.createElement("span"), this.bubble.className = "care-screen-reply", this.bubble.hidden = !0, this.bubble.setAttribute("aria-live", "polite"), m.append(this.bubble), this.thinking = document.createElement("video"), this.thinking.className = "care-screen-thinking", this.thinking.muted = !0, this.thinking.loop = !0, this.thinking.playsInline = !0, this.thinking.preload = "none", this.thinking.hidden = !0, m.append(this.thinking), this.fallback = document.createElement("span"), this.fallback.className = "care-screen-idle", this.fallback.innerHTML = "<i></i><i></i>", m.prepend(this.fallback);
    const S = this.care.feedVideo;
    S.addEventListener("loadstart", () => S.style.opacity = "0", { signal: this.abort.signal }), S.addEventListener("loadeddata", () => S.style.opacity = "1", { signal: this.abort.signal }), S.addEventListener("error", () => {
      S.style.opacity = "0", this.busy && this.finish();
    }, { signal: this.abort.signal }), this.originalPet = this.care.petOnce, this.care.petOnce = () => {
      this.busy || (this.originalPet(), this.care.feedStage === "petting" && this.sound(`audio/pet-${[1, 2, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15][Math.floor(Math.random() * 13)]}.mp3`));
    }, this.care.addEventListener("click", (U) => {
      U.target.closest("[data-eggi-care-snack]") && this.finish();
    }, { capture: !0, signal: this.abort.signal });
  }
  finish() {
    var m, S;
    this.run = (this.run || 0) + 1, (m = this.requestAbort) == null || m.abort(), clearTimeout(this.typing), this.typing = null, clearTimeout(this.hold), this.hold = null, clearTimeout(this.timeout), this.busy = !1, this.thinking && (this.thinking.hidden = !0, this.thinking.pause()), this.sounds.forEach((s) => s.pause()), this.sounds = [], this.bubble && (this.bubble.hidden = !0), (S = this.care) == null || S.stopPetting(), this.care && (this.care.feedStage = "idle", this.care.setFeedMedia(this.media("idle/staring.mp4"), { loop: !0 })), this.querySelector("button").disabled = !1;
  }
  type(m) {
    if (this.target = Array.from(new Intl.Segmenter("en", { granularity: "grapheme" }).segment(m), (s) => s.segment), this.typing) return;
    const S = () => {
      this.typing = null, this.busy && (this.cursor < this.target.length ? (this.cursor++, this.bubble.textContent = this.target.slice(0, this.cursor).join(""), this.bubble.hidden = !1, this.cursor >= this.soundAt && (this.sound(`speech/l2-${String(1 + Math.floor(Math.random() * 8)).padStart(2, "0")}.mp3`), this.soundAt = this.cursor + 8 + Math.floor(Math.random() * 2)), this.typing = setTimeout(S, 86)) : this.complete && (this.hold = setTimeout(() => this.finish(), 2e3)));
    };
    this.typing = setTimeout(S, 86);
  }
  async submit(m) {
    if (m.preventDefault(), this.busy) return;
    const S = this.querySelector("input"), s = S.value.trim();
    if (!s) return;
    const U = this.querySelector(".care-chat-response"), N = this.getAttribute("endpoint") || globalThis.__EGGI_CHAT_ENDPOINT__ || (["127.0.0.1", "localhost"].includes(location.hostname) ? "http://127.0.0.1:5175/api/eggi-chat" : "");
    if (!N) {
      U.textContent = "EGGI’s game replies are not connected here yet.";
      return;
    }
    this.finish();
    const M = this.run;
    this.busy = !0, this.complete = !1, this.cursor = 0, this.soundAt = 8, this.target = [], S.value = "", this.querySelector("button").disabled = !0, U.textContent = "EGGI is thinking…", this.care.feedStage = "chat", this.thinking.hidden = !1, this.thinking.src || (this.thinking.src = this.media("thinking.mp4")), this.thinking.play().catch(() => {
    });
    const C = od({ ...this.care.stats, poop: 35 }), O = JSON.stringify(C), o = !this.conversationId || O !== this.confirmedContext;
    this.requestAbort = new AbortController(), this.timeout = setTimeout(() => this.requestAbort.abort(), 6e4);
    try {
      const X = await hd({ endpoint: N, signal: this.requestAbort.signal, message: s, conversationId: this.conversationId || "", userId: this.userId, runtimeContext: o ? C : void 0, onAction: (D) => {
        M === this.run && (this.thinking.hidden = !0, this.thinking.pause(), this.care.setFeedMedia(this.media(`idle/${D.media.split("/").pop()}`), { loop: !0 }), U.textContent = "EGGI is answering…");
      }, onVocalization: (D) => {
        M === this.run && this.type(D);
      } });
      if (M !== this.run) return;
      clearTimeout(this.timeout), this.conversationId = X.conversationId, ["initialized", "updated"].includes(X.runtimeContextStatus) && (this.confirmedContext = O), this.thinking.hidden = !0, this.thinking.pause(), this.complete = !0, this.type(X.vocalization), U.textContent = "EGGI answered in its own little language.";
    } catch {
      if (M !== this.run) return;
      U.textContent = "EGGI couldn’t connect. Please try again.", this.finish();
    }
  }
  disconnectedCallback() {
    var m, S, s, U;
    this.finish(), (m = this.abort) == null || m.abort(), this.care && this.originalPet && (this.care.petOnce = this.originalPet), (S = this.thinking) == null || S.remove(), (s = this.bubble) == null || s.remove(), (U = this.fallback) == null || U.remove(), this.abort = null;
  }
}
customElements.get("eggi-care-chat") || customElements.define("eggi-care-chat", dd);
class yd extends HTMLElement {
  connectedCallback() {
    if (this.root) return;
    const m = this.getAttribute("asset-root") || "";
    this.root = Bh.createRoot(this), this.root.render(/* @__PURE__ */ B.jsx(sd, { productDetail: !0, assetUrl: (S) => m ? `${m}eggi-growth-${S.split("/").pop()}` : S }));
  }
  disconnectedCallback() {
    var m;
    (m = this.root) == null || m.unmount(), this.root = null;
  }
}
customElements.get("eggi-product-growth") || customElements.define("eggi-product-growth", yd);
